export const CarsDisclaimers = {
  //---------MODELS SECTION---------
  NEW_FORD_FOCUS: {
    MAIN_TITLE: "Nowy Ford Focus",
    MAIN_TEXT:
      "Ford to marka znana z wieloletniej historii i praktycznych rozwiązań zastosowanych w swoich pojazdach. Ekonomia, komfort i ponadczasowy design są wyróżnikami samochodów tego koncernu. Przejrzyj ofertę producenta i wybierz nowego Forda Focusa dla siebie lub swojej firmy.",
    ADDITIONAL_TEXTS: [
      {
        title: "Fabrycznie nowe samochody Ford Focus dostępne w mAuto",
        text: `
        <p>W mAuto możesz kupić zupełnie nowego Forda Focusa w korzystnej cenie z atrakcyjnym finansowaniem. W ofercie znajdziesz różne wersje silnikowe i wyposażeniowe. Auta są dostępne w różnych wersjach silnika z automatyczną skrzynią biegów. 
        Wybierz leasing lub najem długoterminowy na nowe samochody. Ford Focus będzie dobrym wyborem do uzupełnienia firmowej floty pojazdów. W ofercie są dostępne fabrycznie nowe pojazdy z pakietem ubezpieczeniowym, opcjonalnie kartą paliwową i koordynacją serwisu.
        </p>
        `
      },
      {
        title: "Ekonomiczny nowy samochód – Ford Focus. Do wyboru diesel lub benzyna",
        text: `
        <p>W mAuto możesz wybrać nowego Forda Focusa w wersji Titanium, Active lub ST Line. Silniki o pojemności sięgającej do 1,5 litra generują moc przekraczającą 150 koni mechanicznych. Dla tak kompaktowego pojazdu to wystarczająca wartość, która pozwala na komfortową i dynamiczną jazdę w każdych warunkach.
        Producent zapewnia, że nowe samochody Ford Focus spalają średnio 5,2-5,8 l paliwa na 100 kilometrów w wersji hybrydowej. Wersja z silnikiem EcoBoost zużywa nieco ponad 8 litrów paliwa na 100 km.
        </p>
        `
      },
      {
        title: "Dodatkowe wyposażenie nowego Forda Focusa – dla wymagających kierowców",
        text: `
        <p>Dodatkowe wyposażenie nowego Forda Focusa obejmuje m.in. tapicerowane siedzenia z opcją podgrzewania. Fotele mają również pełną regulację temperatury. Samochód oferuje także podgrzewaną przednią szybę i kierownicę.
        Nowe samochody Ford Focus są świetnym uzupełnieniem firmowej floty aut osobowych. Sprawdzą się w codziennej pracy przedstawicieli handlowych. Skorzystaj z oferty mAuto i wybierz Focusa prosto z salonu. Ciesz się wygodą, bezpieczeństwem i oszczędną jazdą.
        </p>
        `
      }
    ]
  },
  AUDI_Q5_SPORTBACK: {
    MAIN_TEXT:
      "Model Audi Q5 Sportback to samochód klasy premium, który sprosta oczekiwaniom każdego przedsiębiorstwa. Jest przestronny, funkcjonalny i komfortowy. W mAuto znajdziesz ten model w różnych wersjach wyposażenia. Wybierz Audi Q5 Sportback dopasowane do swoich potrzeb. Sprawdź dostępne samochody i skorzystaj z atrakcyjnego finansowania.",
    ADDITIONAL_TEXTS: [
      {
        title: "Audi Q5 Sportback dane techniczne",
        text: `
        <p>
          Audi Q5 to elegancki SUV coupé, który łączy dynamiczny i funkcjonalny design z komfortem jazdy, typowym dla klasy premium.
              Pod maską producent umieścił silnik diesla generujący moc 204 koni mechanicznych.
              Taka jednostka połączona z automatyczną skrzynią biegów zapewnia doskonałe osiągi i ekonomiczną jazdę w każdych warunkach.
        </p>

    <p>Niektóre z rozwiązań technologicznych zastosowanych w tym modelu Audi to:</p>
    <ul>
      <li>reflektory w technologii LED</li>
      <li>tarczowe hamulce z przodu i z tyłu</li>
      <li>system rozpoznawania znaków drogowych z kamerą</li>
      <li>opcjonalnie podgrzewane fotele przednie</li>
      <li>moduł Mild Hybrid</li>
      <li>kluczyk z funkcją Safe Lock</li>
    </ul>

    <p>
      Producent zdecydował się na wprowadzenie wielu technologicznych udogodnień.
      Dzięki temu Audi Q5 Sportback zyskuje na praktyczności i daje niesamowitą przyjemność z jazdy każdemu kierowcy.
    </p>
        `
      },
      {
        title: "Audi Q5 Sportback — spalanie",
        text: `
          <p>Audi Q5 Sportback charakteryzuje się stosunkowo niewielkim zużyciem paliwa. 
          Zgodnie z danymi producenta Audi Q5 Sportback spala:</p>
    
          <ul>
            <li>w cyklu niskim - 10,1 l/100 km;</li>
            <li>w cyklu średnim - 7,8 l/100 km;</li>
            <li>w cyklu wysokim - 6,6 l/100 km;</li>
            <li>w cyklu bardzo wysokim - 7,6 l/100 km;</li>
            <li>w cyklu mieszanym - 7,7 l/100 km.</li>
          </ul>
    
          <p>To idealna opcja dla przedsiębiorców, którzy chcą uzupełnić firmową flotę 
          ponadczasowym i ekonomicznym pojazdem z dużą przestrzenią bagażową.</p>
        `
      },
      {
        title: "Przestronne i nowoczesne Audi Q5 Sportback - idealne dla przedsiębiorców",
        text: `
          <p>Fabrycznie nowe Audi Q5 Sportback to model samochodu, który sprosta potrzebom każdego przedsiębiorstwa. 
          Duża przestrzeń bagażowa, przestronne miejsce dla kierowcy oraz liczne udogodnienia dla pasażerów. 
          To cechy, które wyróżniają nowego, kompaktowego SUV-a od Audi.</p>
    
          <p>W podstawowym wyposażeniu tego modelu znajdziesz m.in.:</p>
    
          <ul>
            <li>nowoczesny interfejs do łączenia ze smartfonem,</li>
            <li>elektromechaniczne wspomaganie układu kierowniczego,</li>
            <li>nagrzewnicę powietrza zapewniającą komfort wewnątrz kabiny, szczególnie zimą.</li>
          </ul>
        `
      },
      {
        title: "Elegancja i komfort w jednym - Audi Q5 Sportback w mAuto",
        text: `
          <p>Jeśli szukasz połączenia wygody, ekonomii i elegancji, to Audi Q5 Sportback będzie dobrym wyborem.  
          To samochód wykonany z zachowaniem precyzji i z użyciem wytrzymałych oraz ekologicznych materiałów.</p>
    
          <p>W mAuto możesz wybrać nowe Audi Q5 Sportback w korzystnym finansowaniu w ramach najmu długoterminowego.</p>
          
          <p>Nie potrzebujesz środków na opłatę wstępną, a umowę najmu podpiszesz nawet na 48 miesięcy.  
          W ten sposób zredukujesz miesięczną ratę do korzystnego poziomu i nie obciążysz firmowego budżetu w nadmiernym stopniu.</p>
        `
      },
      {
        title: "Fabrycznie nowe Audi Q5 Sportback - auto klasy premium do firmowej floty",
        text: `
          <p>Nowoczesny, fabrycznie nowy model Audi Q5 w wersji Sportback to doskonałe uzupełnienie firmowej floty aut.  
          Miejskie SUV-y zaprojektowano z myślą o małych, średnich i dużych przedsiębiorcach.</p>
    
          <p>Najważniejsze cechy tego modelu:</p>
    
          <ul>
            <li>wygodne fotele,</li>
            <li>spora przestrzeń bagażowa,</li>
            <li>zaawansowany komputer pokładowy.</li>
          </ul>
    
          <p>Samochody z najnowszych roczników dostępne w ofercie mAuto sprostają oczekiwaniom nawet najbardziej wymagających kierowców.  
          Doskonałe osiągi, niskie zużycie paliwa i niewielkie koszty finansowania - to wszystko sprawia, że warto zainwestować w nowy model Audi Q5 Sportback i cieszyć się wygodą podczas każdej biznesowej podróży.</p>
        `
      },
      {
        title: "Niemiecka jakość, która zachwyca - czym wyróżnia się Audi Q5 Sportback?",
        text: `
          <p>Audi Q5 Sportback to niezawodne połączenie technologii i elegancji.  
          Samochód jest idealny zarówno do miasta, jak i na długie trasy.  
          Wyrazista stylistyka nadwozia w połączeniu z zaawansowanymi technologiami zapewnia komfort oraz bezpieczeństwo na najwyższym poziomie.</p>
    
          <p><strong>Wyróżniki tego modelu:</strong></p>
    
          <ol>
            <li><strong>Nowoczesny design coupé</strong> - sportowa linia dachu i wyraziste linie nadwozia nadają autu wyjątkowy, dynamiczny charakter.</li>
            <li><strong>Zaawansowane systemy bezpieczeństwa</strong> - technologie Audi Pre Sense, asystent pasa ruchu i adaptacyjny tempomat dbają o bezpieczeństwo podróży.</li>
            <li><strong>Komfortowe wnętrze klasy premium</strong> - przestronne, wykończone wysokiej jakości materiałami wnętrze zapewnia luksusowy komfort dla każdego pasażera.</li>
            <li><strong>Wydajne jednostki napędowe</strong> - silniki, w tym opcje mild hybrid, łączą moc z oszczędnością, zapewniając niskie zużycie paliwa i dynamiczną jazdę.</li>
          </ol>
    
          <p>Audi Q5 Sportback powstało z myślą o przedsiębiorcach poszukujących stylowego, komfortowego i przestronnego SUV-a do zadań specjalnych.</p>
        `
      }
    ]
  },
  VOLKSWAGEN_PASSAT: {
    MAIN_TEXT: `
      Volkswagen Passat to elegancki i funkcjonalny samochód, który idealnie wpisuje się w potrzeby zarówno prywatne, jak i biznesowe.  
      Doskonale sprawdzi się w mieście oraz na dłuższych trasach.  
      To model ceniony za komfort jazdy i solidne wykonanie, które gwarantują niezawodność oraz wysoką jakość podróży.</p>

      <p>Sprawdź dostępne modele Volkswagena Passata w mAuto i wybierz pojazd do firmowej floty.
    `,
    ADDITIONAL_TEXTS: [
      {
        title: "Volkswagen Passat - dane techniczne",
        text: `
          <p>Poleasingowy Volkswagen Passat to strzał w dziesiątkę, jeśli szukasz samochodu, który będzie tani w eksploatacji i funkcjonalny.  
          VW Passat z roczników po 2020 roku na standardowym wyposażeniu ma przede wszystkim:</p>
    
          <ul>
            <li>aktywny system bezpieczeństwa PreCrash,</li>
            <li>czujniki ciśnienia w oponach,</li>
            <li>czujniki deszczu i zmierzchu,</li>
            <li>systemy bezpieczeństwa ESP, emergency assist, a także ABS, EDL i EDTC.</li>
          </ul>
    
          <p>Volkswagen Passat jest też wyposażony w LED-owe reflektory, system wykrywania pasa ruchu oraz funkcjonalny komputer pokładowy.  
          To wszystko, co niezbędne w samochodach flotowych.</p>
        `
      },
      {
        title: "Volkswagen Passat - zużycie paliwa",
        text: `
          <p>Volkswagen Passat to samochód ceniony za komfort i ekonomię jazdy.  
          Oferuje szeroką gamę jednostek napędowych dostosowanych do potrzeb kierowców.  
          W mAuto znajdziesz Volkswagena Passata z jednostkami benzynowymi oraz napędem diesla.</p>
    
          <p><strong>Zużycie paliwa dla poszczególnych silników:</strong></p>
    
          <ul>
            <li><strong>Passat B8 1.5 TSI EVO 150 KM:</strong>
              <ul>
                <li>cykl miejski: około 8,0-9,0 l/100 km;</li>
                <li>cykl pozamiejski: około 5,5-6,5 l/100 km;</li>
                <li>cykl mieszany: około 7,0-8,0 l/100 km.</li>
              </ul>
            </li>
            <li><strong>Passat B8 2.0 TSI 190 KM:</strong>
              <ul>
                <li>cykl miejski: około 9,0-10,0 l/100 km;</li>
                <li>cykl pozamiejski: około 6,5-7,5 l/100 km;</li>
                <li>cykl mieszany: około 8,0-9,0 l/100 km.</li>
              </ul>
            </li>
            <li><strong>Passat B8 2.0 TDI 150 KM:</strong>
              <ul>
                <li>cykl miejski: około 6,0-7,0 l/100 km;</li>
                <li>cykl pozamiejski: około 4,5-5,5 l/100 km;</li>
                <li>cykl mieszany: około 5,0-6,0 l/100 km.</li>
              </ul>
            </li>
          </ul>
    
          <p>Realne zużycie paliwa tego samochodu jest uzależnione od stylu jazdy, warunków pogodowych oraz rodzaju wybranej trasy.  
          Niemniej jednak ten model świetnie sprawdzi się jako uzupełnienie firmowej floty, np. z przeznaczeniem dla przedstawiciela handlowego.</p>
        `
      },
      {
        title: "Poleasingowy Volkswagen Passat - auto do firmowej floty",
        text: `
          <p>VW Passat w wersji poleasingowej to świetne rozwiązanie dla przedsiębiorców, którzy szukają oszczędności i bezpieczeństwa.  
          Producent zadbał o nowoczesne wyposażenie pojazdu, które przekłada się na bezpieczeństwo.  
          W standardowej wersji znajdują się także funkcje ułatwiające nawigację.</p>
    
          <p>Używany Volkswagen Passat to pojazd, który sprosta oczekiwaniom każdej firmy dbającej o ekonomię i komfort podróży pracowników.  
          Zyskaj sprawdzony i niezawodny samochód - gotowy do intensywnej eksploatacji.</p>
        `
      },
      {
        title: "Komfort i ekonomia w jednym - VW Passat",
        text: `
          <p>Przestronne wnętrze zapewnia wygodę nawet w długich podróżach.  
          Oszczędne silniki gwarantują niskie zużycie paliwa, a to obniża koszty operacyjne w firmie.  
          Zaawansowane systemy wspomagające jazdę dbają o bezpieczeństwo i wygodę kierowcy.</p>
    
          <p>Na komfort kierowcy wpływa także inteligentnie rozplanowany kokpit.  
          Wszystkie elementy są rozmieszczone tak, aby móc z nich skorzystać jednym ruchem ręki, co redukuje rozproszenie podczas jazdy.</p>
        `
      },
      {
        title: "Volkswagen Passat - wydajne silniki do różnych zastosowań",
        text: `
          <p>W mAuto znajdziesz Volkswagena Passata z silnikiem diesla lub napędem benzynowym.  
          Silnik TDI sprawdzi się na dłuższych trasach, co czyni go idealnym wyborem dla przedstawicieli handlowych.  
          Jeśli dojeżdżasz do klientów w obrębie jednej miejscowości, ekonomiczny silnik 1.5 TSI z automatyczną skrzynią biegów będzie optymalnym rozwiązaniem.</p>
    
          <p>Codzienna eksploatacja poleasingowego Volkswagena Passata nie jest kosztowna.  
          Przy niewielkim spalaniu i świetnych osiągach możesz korzystać z firmowego auta przy minimalnym obciążeniu budżetu.</p>
        `
      },
      {
        title: "Używany Volkswagen Passat z finansowaniem w mAuto",
        text: `
          <p>Poleasingowy Volkswagen Passat w ofercie mAuto to pojazd, który sprosta oczekiwaniom każdego przedsiębiorstwa.  
          W jednym miejscu znajdziesz wiele wersji wyposażeniowych i silnikowych.  
          Wszystkie poleasingowe wersje Passata są dostępne z atrakcyjnym finansowaniem.</p>
    
          <p>Skorzystaj z leasingu na firmę lub możliwości kupna używanego VW Passata za gotówkę.  
          W mAuto wybierasz certyfikowany, sprawdzony i zweryfikowany pojazd.</p>
    
          <p>Możesz wybrać finansowanie z 0% wkładu początkowego na okres nawet do 60 miesięcy.  
          Dodatkowo zyskujesz szeroki pakiet korzyści od mAuto, w tym:</p>
    
          <ul>
            <li>ubezpieczenie OC, AC, NNW,</li>
            <li>koordynację serwisu za symboliczną złotówkę miesięcznie,</li>
            <li>opcjonalną kartę paliwową dla przedsiębiorców.</li>
          </ul>
    
          <p>Dzięki temu zakup poleasingowego Volkswagena Passata okazuje się naprawdę korzystnym rozwiązaniem.  
          Postaw na ekonomiczne, nowoczesne i komfortowe auto.  
          Wybierz używanego Passata do firmowej floty aut.</p>
        `
      }
    ]
  },
  BMW_SERIA_3: {
    MAIN_TEXT: `
      BMW serii 3 to świetny wybór dla przedsiębiorców ceniących sobie połączenie elegancji i dynamicznych osiągów.  
      To pojazd ze sportowym zacięciem i reprezentatywną stylistyką. W ofercie mAuto znajdziesz różne wersje BMW serii 3  
      z zaawansowanymi technologiami, komfortowym wnętrzem i wydajnymi silnikami. Zobacz dostępne opcje i wybierz auto do firmowej floty.
    `,
    ADDITIONAL_TEXTS: [
      {
        title: "BMW serii 3 - dane techniczne",
        text: `
          <p>BMW Serii 3 to synonim sportowej elegancji i zaawansowanej technologii. Ten model wyposażono w ekonomiczne,  
          a zarazem wydajne jednostki napędowe oraz nowoczesne rozwiązania. To gwarancja komfortu eksploatacji pojazdu na co dzień.</p>
  
          <p>Wymiary BMW serii 3 to:</p>
          <ul>
            <li>długość: 4713 mm,</li>
            <li>szerokość: 1827 mm,</li>
            <li>wysokość: 1440 mm,</li>
            <li>rozstaw osi: 2851 mm.</li>
          </ul>
  
          <p>Pojemność zbiornika paliwa to aż 59 litrów, natomiast przestrzeń w bagażniku sięga do 480 litrów. Przy zachowaniu masy  
          własnej na poziomie 1575 kilogramów BMW serii 3 zapewnia niesamowite osiągi podczas jazdy w każdych warunkach.  
          Jednocześnie zyskujesz komfort podróży nawet z większą ilością bagażu.</p>
        `
      },
      {
        title: "BMW serii 3 - spalanie",
        text: `
          <p>Według danych producenta nowe BMW serii 3 w cyklu mieszanym spala ok. 6,4-7,2 l paliwa na 100 km. Takie wartości  
          dla cyklu mieszanego to doskonały wynik. Model posiada silnik o pojemności 1998 cm³ i mocy 156 koni mechanicznych.  
          Dzięki temu fabrycznie nowe BMW serii 3 to gwarancja wydajności połączonej z ekonomią.</p>
  
          <p>Realne spalanie w modelach BMW zależy od indywidualnego stylu jazdy, warunków pogodowych, ukształtowania terenu oraz liczby pasażerów.</p>
  
          <p>Emisja CO2 w cyklu mieszanym dla BMW serii 3 mieści się w przedziale 145-162 g/km. To wartości, które wskazują,  
          że nowy model sedana od BMW serii 3 jest naprawdę ekologiczny.</p>
        `
      },
      {
        title: "Nowoczesne auto klasy premium - BMW serii 3 dla przedsiębiorców",
        text: `
          <p>BMW serii 3 to doskonały wybór dla przedsiębiorców. Samochód sprawdzi się zarówno w małej, średniej, jak i dużej firmie.  
          To niezawodne wsparcie floty zwłaszcza tam, gdzie liczy się oszczędność na kosztach eksploatacji, doskonały wygląd pojazdu,  
          a także niezawodność.</p>
  
          <p>Dynamiczny charakter tego modelu łączy elegancję z doskonałymi osiągami. To sprawia, że BMW serii 3 jest niezawodnym wyborem  
          zarówno na codzienne dojazdy do klienta, jak i reprezentacyjne spotkania biznesowe.</p>
  
          <p>Zaawansowane technologie wspierające bezpieczeństwo oraz systemy multimedialne poprawiają ogólną wygodę eksploatacji pojazdu w firmowej flocie.  
          Przestronne wnętrze, ergonomiczne fotele i precyzyjne prowadzenie sprawiają, że każdy przejazd staje się przyjemnością.</p>
        `
      },
      {
        title: "Eleganckie i funkcjonalne BMW serii 3",
        text: `
          <p>BMW Serii 3 dla firm to pojazd, który podkreśli profesjonalizm i prestiż przedsiębiorstwa. Auto klasy premium łączy w sobie ponadczasową  
          elegancję z delikatnym, sportowym zacięciem. Podstawowe wyposażenie nowego modelu BMW serii 3 obejmuje m.in.: </p>
  
          <ul>
            <li>system alarmowy,</li>
            <li>automatyczną skrzynię biegów z łopatkami,</li>
            <li>system monitorowania ciśnienia w oponach,</li>
            <li>pełen pakiet usług ConnectedDrive i Connected Professional.</li>
          </ul>
  
          <p>Powyższe warianty, w połączeniu z inteligentnym kokpitem dla kierowcy przekładają się na bezpieczeństwo i wygodę prowadzenia pojazdu w każdych warunkach.  
          Panoramiczny wyświetlacz w standardzie ułatwia nawigację np. podczas długich tras biznesowych. Dodatkowe wyposażenie obejmuje pakiet sportowy M,  
          sportowe fotele, a także wydajny układ kierowniczy.</p>
        `
      },
      {
        title: "Ekonomia i wydajność w jednym samochodzie - BMW 3",
        text: `
          <p>BMW serii 3 oferuje dynamiczną jazdę przy minimalnym zużyciu paliwa. To dobra opcja dla przedsiębiorców zainteresowanych jak najniższymi  
          kosztami eksploatacji aut w firmowej flocie. Producent zadbał o to, aby utrzymać lekką konstrukcję ramy, jak najniższą masę własną i połączyć to z wydajnymi silnikami.  
          To połączenie, które zadowoli nawet zaawansowanych kierowców.</p>
  
          <p>Modele BMW wyposażono też w zaawansowane systemy, takie jak technologia mild hybrid i inteligentne zarządzanie energią. Dzięki temu silnik skutecznie wykorzystuje  
          każdą kroplę paliwa, zapewniając jednocześnie imponujące osiągi. To samochód stworzony dla tych, którzy oczekują doskonałych parametrów i ekonomiczności,  
          niezależnie od planowanego dystansu.</p>
        `
      },
      {
        title: "Nowe BMW serii 3 z atrakcyjnym finansowaniem w mAuto",
        text: `
          <p>Fabrycznie nowe BMW serii 3 jest dostępne w mAuto z korzystnym finansowaniem w ramach najmu długoterminowego. Bez opłaty wstępnej możesz rozłożyć płatności  
          na 48 równych, miesięcznych rat. W pakiecie do BMW serii 3 dostępny jest pakiet ubezpieczenia OC, AC, NNW, wsparcie serwisowe oraz opcjonalnie karta paliwowa  
          z bonusem dla przedsiębiorców.</p>
  
          <p>Na fabrycznie nowe auto BMW serii 3 można też wykupić pakiet assistance drogowego. W mAuto wybierzesz nowoczesny samochód w opcji najmu długoterminowego.  
          Postaw na wygodę, bezpieczeństwo i niezawodność podczas każdego dnia eksploatacji auta w firmowej flocie.</p>
        `
      }
    ]
  },
  NEW_BMW_SERIA_3: {
    MAIN_TEXT: `
      BMW serii 3 to świetny wybór dla przedsiębiorców ceniących sobie połączenie elegancji i dynamicznych osiągów.  
      To pojazd ze sportowym zacięciem i reprezentatywną stylistyką. W ofercie mAuto znajdziesz różne wersje BMW serii 3  
      z zaawansowanymi technologiami, komfortowym wnętrzem i wydajnymi silnikami. Zobacz dostępne opcje i wybierz auto do firmowej floty.
    `,
    ADDITIONAL_TEXTS: [
      {
        title: "BMW serii 3 - dane techniczne",
        text: `
          <p>BMW Serii 3 to synonim sportowej elegancji i zaawansowanej technologii. Ten model wyposażono w ekonomiczne,  
          a zarazem wydajne jednostki napędowe oraz nowoczesne rozwiązania. To gwarancja komfortu eksploatacji pojazdu na co dzień.</p>
  
          <p>Wymiary BMW serii 3 to:</p>
          <ul>
            <li>długość: 4713 mm,</li>
            <li>szerokość: 1827 mm,</li>
            <li>wysokość: 1440 mm,</li>
            <li>rozstaw osi: 2851 mm.</li>
          </ul>
  
          <p>Pojemność zbiornika paliwa to aż 59 litrów, natomiast przestrzeń w bagażniku sięga do 480 litrów. Przy zachowaniu masy  
          własnej na poziomie 1575 kilogramów BMW serii 3 zapewnia niesamowite osiągi podczas jazdy w każdych warunkach.  
          Jednocześnie zyskujesz komfort podróży nawet z większą ilością bagażu.</p>
        `
      },
      {
        title: "BMW serii 3 - spalanie",
        text: `
          <p>Według danych producenta nowe BMW serii 3 w cyklu mieszanym spala ok. 6,4-7,2 l paliwa na 100 km. Takie wartości  
          dla cyklu mieszanego to doskonały wynik. Model posiada silnik o pojemności 1998 cm³ i mocy 156 koni mechanicznych.  
          Dzięki temu fabrycznie nowe BMW serii 3 to gwarancja wydajności połączonej z ekonomią.</p>
  
          <p>Realne spalanie w modelach BMW zależy od indywidualnego stylu jazdy, warunków pogodowych, ukształtowania terenu oraz liczby pasażerów.</p>
  
          <p>Emisja CO2 w cyklu mieszanym dla BMW serii 3 mieści się w przedziale 145-162 g/km. To wartości, które wskazują,  
          że nowy model sedana od BMW serii 3 jest naprawdę ekologiczny.</p>
        `
      },
      {
        title: "Nowoczesne auto klasy premium - BMW serii 3 dla przedsiębiorców",
        text: `
          <p>BMW serii 3 to doskonały wybór dla przedsiębiorców. Samochód sprawdzi się zarówno w małej, średniej, jak i dużej firmie.  
          To niezawodne wsparcie floty zwłaszcza tam, gdzie liczy się oszczędność na kosztach eksploatacji, doskonały wygląd pojazdu,  
          a także niezawodność.</p>
  
          <p>Dynamiczny charakter tego modelu łączy elegancję z doskonałymi osiągami. To sprawia, że BMW serii 3 jest niezawodnym wyborem  
          zarówno na codzienne dojazdy do klienta, jak i reprezentacyjne spotkania biznesowe.</p>
  
          <p>Zaawansowane technologie wspierające bezpieczeństwo oraz systemy multimedialne poprawiają ogólną wygodę eksploatacji pojazdu w firmowej flocie.  
          Przestronne wnętrze, ergonomiczne fotele i precyzyjne prowadzenie sprawiają, że każdy przejazd staje się przyjemnością.</p>
        `
      },
      {
        title: "Eleganckie i funkcjonalne BMW serii 3",
        text: `
          <p>BMW Serii 3 dla firm to pojazd, który podkreśli profesjonalizm i prestiż przedsiębiorstwa. Auto klasy premium łączy w sobie ponadczasową  
          elegancję z delikatnym, sportowym zacięciem. Podstawowe wyposażenie nowego modelu BMW serii 3 obejmuje m.in.: </p>
  
          <ul>
            <li>system alarmowy,</li>
            <li>automatyczną skrzynię biegów z łopatkami,</li>
            <li>system monitorowania ciśnienia w oponach,</li>
            <li>pełen pakiet usług ConnectedDrive i Connected Professional.</li>
          </ul>
  
          <p>Powyższe warianty, w połączeniu z inteligentnym kokpitem dla kierowcy przekładają się na bezpieczeństwo i wygodę prowadzenia pojazdu w każdych warunkach.  
          Panoramiczny wyświetlacz w standardzie ułatwia nawigację np. podczas długich tras biznesowych. Dodatkowe wyposażenie obejmuje pakiet sportowy M,  
          sportowe fotele, a także wydajny układ kierowniczy.</p>
        `
      },
      {
        title: "Ekonomia i wydajność w jednym samochodzie - BMW 3",
        text: `
          <p>BMW serii 3 oferuje dynamiczną jazdę przy minimalnym zużyciu paliwa. To dobra opcja dla przedsiębiorców zainteresowanych jak najniższymi  
          kosztami eksploatacji aut w firmowej flocie. Producent zadbał o to, aby utrzymać lekką konstrukcję ramy, jak najniższą masę własną i połączyć to z wydajnymi silnikami.  
          To połączenie, które zadowoli nawet zaawansowanych kierowców.</p>
  
          <p>Modele BMW wyposażono też w zaawansowane systemy, takie jak technologia mild hybrid i inteligentne zarządzanie energią. Dzięki temu silnik skutecznie wykorzystuje  
          każdą kroplę paliwa, zapewniając jednocześnie imponujące osiągi. To samochód stworzony dla tych, którzy oczekują doskonałych parametrów i ekonomiczności,  
          niezależnie od planowanego dystansu.</p>
        `
      },
      {
        title: "Nowe BMW serii 3 z atrakcyjnym finansowaniem w mAuto",
        text: `
          <p>Fabrycznie nowe BMW serii 3 jest dostępne w mAuto z korzystnym finansowaniem w ramach najmu długoterminowego. Bez opłaty wstępnej możesz rozłożyć płatności  
          na 48 równych, miesięcznych rat. W pakiecie do BMW serii 3 dostępny jest pakiet ubezpieczenia OC, AC, NNW, wsparcie serwisowe oraz opcjonalnie karta paliwowa  
          z bonusem dla przedsiębiorców.</p>
  
          <p>Na fabrycznie nowe auto BMW serii 3 można też wykupić pakiet assistance drogowego. W mAuto wybierzesz nowoczesny samochód w opcji najmu długoterminowego.  
          Postaw na wygodę, bezpieczeństwo i niezawodność podczas każdego dnia eksploatacji auta w firmowej flocie.</p>
        `
      }
    ]
  },
  HYUNDAI_KONA: {
    MAIN_TEXT: `
      Poleasingowy Hyundai Kona to samochód, który może uzupełnić flotę pojazdów każdego przedsiębiorstwa. Niewielki i ekonomiczny silnik gwarantuje niskie koszty eksploatacji. To dobry wybór, jeśli szukasz połączenia wygody, bezpieczeństwa i praktycznego wyposażenia. Zobacz warianty Hyundaia Kona w mAuto i wybierz pojazd dla swojej firmy.
    `,
    ADDITIONAL_TEXTS: [
      {
        title: "Hyundai Kona - dane techniczne",
        text: `
          Hyundai Kona to kompaktowy SUV dostępny z różnymi jednostkami napędowymi. Popularna wersja tego samochodu wyposażona jest w silnik benzynowy 1.0 T-GDI o pojemności 998 cm3, który generuje moc 120 KM. Kona oferuje przestronne wnętrze z bagażnikiem o pojemności 466 litrów (według standardu VDA) lub 723 litrów (według standardu SAE) przy złożonych tylnych siedzeniach. 
          Co więcej, posiada też nowoczesne systemy bezpieczeństwa, takie jak np. automatyczne hamowanie awaryjne z wykrywaniem pieszych, asystent pasa ruchu oraz monitorowanie martwego pola. To w połączeniu z kompaktowymi wymiarami przekłada się na wielofunkcyjność.
        `
      },
      {
        title: "Hyundai Kona - zużycie paliwa",
        text: `
          <p>Model Hyundaia z silnikiem 1.0 T-GDI charakteryzuje się umiarkowanym zużyciem paliwa. To ekonomiczny wybór zarówno do jazdy miejskiej, jak i na trasie. </p>
          <p>Średnie spalanie paliwa dla tego modelu przedstawia się następująco:</p>
          <ul>
            <li><strong>Cykl mieszany:</strong> około 5,5-6,0 l/100 km;</li>
            <li><strong>Jazda miejska:</strong> około 6,5-7,0 l/100 km;</li>
            <li><strong>Trasa:</strong> około 5,0-5,5 l/100 km.</li>
          </ul>
          <p>Hyundai Kona sprawdzi się jako kompaktowe auto, które nie obciąży budżetu podczas podróży biznesowych. Wydajne systemy dawkowania paliwa i technologie wspomagające jazdę przekładają się na skuteczną redukcję zużycia benzyny i tym samym ogólnych kosztów eksploatacji samochodu.</p>
        `
      },
      {
        title: "Poleasingowy Hyundai Kona - dla małych i dużych firm",
        text: `
          <p>
            Używane samochody Hyundai Kona z roczników od 2018 roku wzwyż to dobry wybór dla każdego przedsiębiorstwa. Niewielki silnik łączy w sobie ekonomię i niezawodność. Standardowe wyposażenie tego modelu sprosta oczekiwaniom niemalże każdego kierowcy.
            W standardzie auto wyposażono w:
          </p>
          <ul>
            <li>automatyczny system włączania świateł,</li>
            <li>czujniki ciśnienia w oponach,</li>
            <li>system kontroli zjazdu ze wzniesień,</li>
            <li>dwupoziomową podłogę bagażnika,</li>
            <li>systemy kontroli trakcji i stabilizacji pojazdu.</li>
          </ul>
          <p>Podróże firmowe z Hyundaiem Kona stają się bezpieczniejsze. Wybierz to auto do floty przedsiębiorstwa i zyskaj pewność, że każda trasa do klienta zakończy się powodzeniem.</p>
        `
      },
      {
        title: "Ekonomiczny, komfortowy i elegancki - używany Hyundai Kona",
        text: `
          <p>
            Hyundai Kona to idealne połączenie elegancji i ekonomicznej eksploatacji, co czyni go świetnym wyborem zarówno do codziennych dojazdów, jak i dłuższych podróży. Kona z łatwością porusza się po miejskich ulicach, zachowując przy tym wyjątkowy styl. To samochód, który oferuje przemyślane, funkcjonalne wnętrze i wygodne fotele, które zapewniają komfort każdemu pasażerowi.
            Ekonomia to kolejna kluczowa zaleta tego modelu - Hyundai Kona odznacza się niskim zużyciem paliwa, dzięki czemu możesz zaoszczędzić na codziennych kosztach podróży. Samochody Hyundai z oferty mAuto to idealny wybór dla poszukujących oszczędności. Zapewniają pełną wygodę i jest stosunkowo tanie w utrzymaniu.
          </p>
        `
      },
      {
        title: "Hyundai Kona z praktycznym wyposażeniem",
        text: `
          <p>
            Na praktyczność Hyundaia Kona składa się wiele czynników. Automatyczna klimatyzacja, wielofunkcyjna kierownica i interfejs Bluetooth to nie wszystko. Producent wyposażył ten model w dodatkowe udogodnienia, m.in.: system ISOFIX oraz praktyczny zestaw do samodzielnej naprawy przebitej opony.
            Takie wyposażenie pozwala na swobodną jazdę zarówno na krótkich trasach, jak i podczas dłuższych wyjazdów biznesowych. Potencjał Hyundaia Kona można wykorzystać przede wszystkim w firmach handlowych oraz w małych działalnościach gospodarczych prowadzonych na lokalnym rynku.
          </p>
        `
      },
      {
        title: "Kompaktowy Hyundai Kona z ekonomicznym silnikiem",
        text: `
          <p>Silnik 1.0 T-GDI to sprawdzona jednostka napędowa. Zaprojektowano ją z myślą o wysokiej efektywności paliwowej przy utrzymaniu niskiej emisji spalin. Kompaktowy i lekki silnik w Hyundai Kona generuje satysfakcjonującą moc. Dzięki temu świetnie radzi sobie podczas jazdy miejskiej i pozamiejskiej. Turbodoładowana jednostka powoduje, że reakcja na przyspieszenie jest natychmiastowa.</p>
        `
      },
      {
        title: "Atrakcyjne finansowanie Hyundai Kona w mAuto",
        text: `
          <p>
            Decydując się na poleasingowego Hyundaia Kona z oferty mAuto możesz skorzystać z finansowania w ramach leasingu lub zakupu za gotówkę. W przypadku leasingu umowę podpiszesz z zerowym wkładem własnym na okres nawet do 60 miesięcy.
            W mAuto dostępny jest też pakiet ubezpieczenia OC, AC, NNW oraz wsparcie assistance drogowego. Opcjonalnie dla przedsiębiorców wydawana jest karta paliwowa oraz usługa koordynacji serwisu za symboliczną złotówkę miesięcznie.
          </p>
        `
      }
    ]
  },
  VOLVO_V90: {
    MAIN_TEXT: `
      Samochody Volvo V90 to połączenie szwedzkiej precyzji i ponadczasowego designu. Sprawdź poleasingowe auta tego producenta w ofercie mAuto. Postaw na jakość, niezawodność i bezpieczeństwo. Skorzystaj z atrakcyjnego finansowania Volvo V90 i wybierz pakiet korzyści dla swojego przedsiębiorstwa.
    `,
    ADDITIONAL_TEXTS: [
      {
        title: "Volvo V90 - dane techniczne",
        text: `
          <p>Volvo V90 to luksusowe kombi klasy wyższej, produkowane od 2016 roku. Model ten oferuje przestronne wnętrze oraz zaawansowane technologie bezpieczeństwa. Wymiary modeli Volvo V90 z roczników z 2020 roku to:</p>
          <ul>
            <li><strong>długość:</strong> 4936 mm;</li>
            <li><strong>szerokość:</strong> 1890 mm (z lusterkami: 2019 mm);</li>
            <li><strong>wysokość:</strong> 1475 mm;</li>
            <li><strong>rozstaw osi:</strong> 2941 mm;</li>
            <li><strong>pojemność bagażnika:</strong> 560 litrów (maksymalnie do 1526 litrów przy złożonych siedzeniach).</li>
          </ul>
          <p>Wszystkie samochody wyposażone są w systemy wspomagające kierowcę, takie jak ABS, poduszki powietrzne, czujniki deszczu oraz systemy poprawy jakości powietrza. Dodatkowym wyróżnikiem tego modelu jest komfortowe wnętrze z wysokiej jakości materiałów wykończeniowych.</p>
        `
      },
      {
        title: "Volvo V90 - zużycie paliwa",
        text: `
          <p>
            Samochody Volvo V90 różnią się między pod względem specyfikacji. W modelu z silnikiem D4 SCR średnie zużycie paliwa wynosi około 5,2-5,5 l/100 km w cyklu mieszanym.
            Wersja z układem hybrydowym B4 D osiąga zużycie na poziomie 5,8-6,2 l/100 km. Silnik D5, dostępny w modelu Cross Country (CC) spala 5,9-6,3 l/100 km.
            Średnie poziomy spalania paliwa w poszczególnych wersjach silnikowych przedstawiają się następująco:
          </p>
          <ul>
            <li><strong>Silnik D4 SCR (2.0 D4 190 KM):</strong>
              <ul>
                <li><strong>cykl miejski:</strong> około 6,0-6,2 l/100 km;</li>
                <li><strong>cykl pozamiejski:</strong> około 4,5-4,7 l/100 km;</li>
                <li><strong>cykl mieszany:</strong> około 5,0-5,2 l/100 km.</li>
              </ul>
            </li>
            <li><strong>Silnik B4 D (2.0 B4 Diesel Mild Hybrid 197 KM):</strong>
              <ul>
                <li><strong>cykl miejski:</strong> około 6,0-6,2 l/100 km;</li>
                <li><strong>cykl pozamiejski:</strong> około 4,5-4,7 l/100 km;</li>
                <li><strong>cykl mieszany:</strong> około 5,0-5,2 l/100 km.</li>
              </ul>
            </li>
            <li><strong>Silnik D5 (2.0 D5 235 KM) w wersji Cross Country:</strong>
              <ul>
                <li><strong>cykl miejski:</strong> około 6,5-6,7 l/100 km;</li>
                <li><strong>cykl pozamiejski:</strong> około 5,0-5,2 l/100 km;</li>
                <li><strong>cykl mieszany:</strong> około 5,6-5,8 l/100 km.</li>
              </ul>
            </li>
          </ul>
          <p>Nawet najmocniejszy wariant w poleasingowych Volvo V90 zapewnia optymalne zużycie paliwa. Dzięki temu można skutecznie zredukować koszty eksploatacji pojazdu i odciążyć budżet przedsiębiorstwa.</p>
        `
      },
      {
        title: "Przestronne i praktyczne Volvo V90 dla przedsiębiorców",
        text: `
          <p>
            Volvo V90 to idealne rozwiązanie dla przedsiębiorców ceniących przestrzeń i komfort. Elegancki i funkcjonalny design zapewnia doskonałe warunki do podróży służbowych, zarówno w mieście, jak i na dłuższych trasach. Duża pojemność bagażnika ułatwia przewóz dokumentów, sprzętu czy próbek produktowych.
            To kluczowe w codziennych obowiązkach w przedsiębiorstwie. Volvo V90 wpływa też na prestiżowy wizerunek marki, który z pewnością zyska uznanie klientów i partnerów biznesowych. Przestrzeń bagażowa sięgająca w standardzie do 560 litrów jest wystarczająca, aby wygodnie przewozić towary w firmie.
            Dzięki zaawansowanym systemom bezpieczeństwa każda podróż jest nie tylko komfortowa, ale i bezpieczna. Intuicyjne rozwiązania technologiczne np. system poprawiający jakość powietrza w kabinie przekłada się na komfort wszystkich pasażerów.
          </p>
        `
      }
    ]
  },
  //---------MAKES SECTION-----------
  NEW_MERCEDES_BENZ: {
    MAIN_TITLE: "Nowy Mercedes",
    MAIN_TEXT: `
    Fabrycznie nowy Mercedes to auto, które może być uzupełnieniem wizerunku przedsiębiorstwa. W ofercie mAuto znajdziesz najnowsze modele Mercedesa z wydajnymi silnikami i doskonałym wyposażeniem. Wybierz samochód niemieckiego producenta i zacznij cieszyć się komfortem w korzystnej cenie. Sprawdź dostępne opcje w mAuto i podpisz umowę.
  `,
    ADDITIONAL_TEXTS: [
      {
        title: "Nowe samochody Mercedesa w ofercie mAuto",
        text: `
        <p>
          Zupełnie nowe samochody Mercedes w mAuto to synonim luksusu, innowacyjności i niezawodności. Wybierz na auto z tej gamy i zyskaj prestiż komfort i połączone z zaawansowanymi technologiami.
          mAuto oferuje wiele modeli, dostosowanych do różnorodnych potrzeb i oczekiwań klientów biznesowych. Dostępne wersje nowego Mercedesa to:
        </p>
        <ul>
          <li><strong>Mercedes-Benz GLE</strong> - przestronny SUV klasy premium, idealny dla osób ceniących komfort oraz bezpieczeństwo. Wyposażony w nowoczesne systemy wspomagania kierowcy oraz luksusowe wnętrze, zapewnia wyjątkowe doznania z jazdy.</li>
          <li><strong>Mercedes-Benz GLC</strong> - kompaktowy, funkcjonalny i elegancki SUV. Auto jest idealne do codziennej jazdy miejskiej. Oferuje dynamiczne osiągi oraz zaawansowane technologie, które podnoszą komfort i bezpieczeństwo podróży.</li>
          <li><strong>Mercedes-Benz E Klasa</strong> - limuzyna klasy biznes, symbol prestiżu i elegancji. Wyposażona w najnowsze rozwiązania technologiczne, zapewnia komfort na najwyższym poziomie oraz doskonałe właściwości jezdne.</li>
          <li><strong>Mercedes-Benz GLB</strong> - kompaktowy SUV z opcją siedmiu miejsc. Łączy przestronność z kompaktowymi wymiarami. Ten model gwarantuje wszechstronność i komfort w codziennym użytkowaniu.</li>
          <li><strong>Mercedes-Benz A Klasa</strong> - nowoczesny hatchback, który wyróżnia się dynamicznym designem i zaawansowanymi technologiami. Idealny dla kierowców ceniących styl oraz innowacyjne rozwiązania w zakresie multimediów i bezpieczeństwa.</li>
          <li><strong>Mercedes-Benz CLA</strong> - czterodrzwiowe coupé o sportowej sylwetce, łączące elegancję z dynamiką. Oferuje zaawansowane systemy wspomagania oraz komfortowe wnętrze. To czyni go doskonałym wyborem dla osób poszukujących wyjątkowego stylu i osiągów.</li>
        </ul>
        <p>Zakup nowego Mercedesa to inwestycja w jakość klasy premium. Auta potrafią sprostać oczekiwania najbardziej wymagających klientów biznesowych pod względem jakości, osiągów i komfortu codziennej eksploatacji.</p>
      `
      },
      {
        title: "Nowoczesne i praktyczne - fabrycznie nowe samochody Mercedesa",
        text: `
        <p>
          Nowe samochody Mercedesa wyróżniają się innowacyjnością, luksusowym wnętrzem oraz elegancją. Producent zadbał o przemyślane rozwiązania technologiczne. Auta spełniają wysokie standardy techniczne, dzięki czemu sprostają oczekiwaniom każdego kierowcy.
          Systemy wspomagające bezpieczeństwo jazdy, komfortowe wnętrza i ekologiczne jednostki napędowe. To elementy, które czynią nowe Mercedesy doskonałym wyborem do uzupełnienia firmowej floty aut.
        </p>
      `
      },
      {
        title: "Nowy samochód Mercedes dla przedsiębiorstwa z praktycznym wyposażeniem",
        text: `
        <p>Standardowe wyposażenie nowych samochodów Mercedesa obejmuje system Android Auto i Apple CarPlay oraz antenę GPS. Posiada także system personalizacji dźwięku, cyfrowe radio, system ESP i ABS. Na liście wyposażenia znajduje się również aktywny asystent utrzymania pasa ruchu. Producent nowych Mercedesów zadbał o to, aby kierowca miał dostęp do wielu udogodnień poprawiających komfort i bezpieczeństwo.</p>
      `
      },
      {
        title: "Nowe samochody Mercedesa klasy premium - doskonałe osiągi i ekonomia",
        text: `
        <p>
          Modele z gamy nowych Mercedesów łączą troskę o środowisko z satysfakcją z jazdy. Wysoka jakość i dbałość o detale gwarantują satysfakcję z każdej przejechanej trasy. Nowoczesne jednostki napędowe zapewniają niskie spalanie. Dzięki temu użytkownicy mogą cieszyć się oszczędnościami przy zachowaniu wysokiej wydajności.
          Samochody klasy premium dostępne od ręki w mAuto występują w wersjach z silnikiem benzynowym oraz diesla. Nowe Mercedesy, których moc przekracza nawet 250 koni mechanicznych, pozwalają na dynamiczne wyprzedzanie w trasie. Takie osiągi dostarczają też sporą dawkę pozytywnych emocji podczas jazdy.
        </p>
      `
      },
      {
        title: "Fabrycznie nowy Mercedes od mAuto z atrakcyjnym finansowaniem",
        text: `
        <p>
          W ofercie mAuto fabrycznie nowe Mercedesy są dostępne w ramach elastycznych warunków finansowania, które można dostosować do indywidualnych preferencji. Decydując się na Mercedesa, zyskujesz pojazd, który spełnia zarówno najwyższe standardy techniczne, jak i stylowe. To auta idealne dla tych, którzy cenią sobie klasę i nowoczesność na co dzień.
          Wybierz nowego Mercedesa klasy premium w mAuto i skorzystaj z ubezpieczenia OC, AC i NNW w cenie miesięcznego najmu długoterminowego. Dodatkowe opcje to karta paliwowa, pakiet serwisowy oraz wsparcie drogowe assistance. W ramach najmu nowe samochody Mercedesa można mieć z zerową opłatą wstępną nawet na 48 miesięcy.
        </p>
      `
      }
    ]
  },
  VOLVO_XC60: {
    MAIN_TEXT:
      "Nowoczesne i luksusowe Volvo XC 60 w ofercie mAuto. Modele z rocznika 2023 dostępne w różnych wariantach finansowania – leasingu i najmie długoterminowym. Wybierz spośród kilku wersji wyposażenia i ciesz się wygodą i prestiżem z segmentu premium. Postaw na sprawdzoną markę, która sprosta codziennym wyzwaniom stawianym przed autami flotowymi.",
    ADDITIONAL_TEXTS: [
      {
        title: "Volvo XC 60 – dane techniczne",
        text: `
          <p>Fabrycznie nowe Volvo XC 60 to dobry wybór, szczególnie jeśli cenisz sobie praktyczne rozwiązania połączone z innowacjami technologicznymi. Najważniejsze parametry techniczne wyróżniające model Volvo XC 60 to:</p>
          <ul>
            <li>wydajny silnik o pojemności dwóch litrów,</li>
            <li>zaawansowany system oczyszczania powietrza z jonizacją wewnątrz pojazdu,</li>
            <li>bezkluczykowy system odpalania samochodu z bezdotykową obsługą bagażnika,</li>
            <li>asystent podjazdu,</li>
            <li>system WHIPS, który zmniejsza ryzyko urazu kręgosłupa szyjnego podczas kolizji lub wypadku,</li>
            <li>reflektory LED,</li>
            <li>układ monitorowania pasa ruchu,</li>
            <li>kolanowe poduszki powietrzne,</li>
            <li>zintegrowane spryskiwacze szyb z piórami wycieraczek,</li>
            <li>wielofunkcyjne radio,</li>
            <li>dynamiczne zawieszenie.</li>
          </ul>
          <p>To tylko kilka parametrów, które zachęcają do zakupu Volvo XC 60 do firmowej floty samochodów osobowych. Oprócz powyższych poszczególne modele Volvo dostępne w mAuto występują z pakietem wyposażenia dodatkowego, np. podgrzewanie foteli przednich i tylnych oraz kierownicy.</p>
        `
      },
      {
        title: "Volvo XC 60 – spalanie",
        text: `
          <p>Według informacji od producenta średnie spalanie Volvo XC 60 w cyklu mieszanym nie powinno przekraczać poziomu 7,9 litra na 100 kilometrów. To świetny wynik, biorąc pod uwagę doskonałe osiągi tego pojazdu oraz moc na poziomie do 250 koni mechanicznych.</p>
        `
      },
      {
        title: "Volvo XC 60 w ofercie mAuto",
        text: `
          <p>Decydując się na zakup dowolnej wersji modelowej Volvo XC 60 z oferty mAuto oprócz atrakcyjnej ceny zakupu i przejrzystej formy finansowania, zyskujesz dodatkowo dostęp do szerokiego pakietu usług dodatkowych.</p>
        `
      }
    ]
  },
  CITROEN_C3: {
    MAIN_TEXT:
      "Poznaj szeroką ofertę modeli Citroena C3 z rocznika 2023. Samochody dostępne w ramach atrakcyjnego finansowania w formie najmu dla firm. Poznaj szeroką gamę dostępnych aut i wybierz pojazd, który w 100% sprosta Twoim oczekiwaniom i sprawdzi się w firmowej flocie samochodów osobowych.",
    ADDITIONAL_TEXTS: [
      {
        title: "Citroen C3 – dane techniczne",
        text: `
          <p>Najnowsze modele Citroena C3 to dobry wybór jako auto do firmowej floty, chociażby ze względu na doskonałe parametry techniczne oraz wyposażenie. Auta francuskiego producenta łączą w sobie cechy małych SUV-ów i kompaktowych hatchbacków. Dzięki temu popularne C3 świetnie sprawdza się w warunkach miejskich, a jednocześnie wyróżnia się na tle innych modeli z tego segmentu. Najistotniejsze dane techniczne Citroena C3 to:</p>
          <ul>
            <li>oszczędny silnik benzynowy,</li>
            <li>pełen pakiet systemów ABS, REF, AFU i ESP, które wpływają na bezpieczeństwo jazdy,</li>
            <li>wspomaganie kierownicy,</li>
            <li>automatyczna klimatyzacja,</li>
            <li>czujnik parkowania,</li>
            <li>tempomat,</li>
            <li>asystent ruszania na wzniesieniach.</li>
          </ul>
          <p>Citroen C3 ma znacznie więcej atutów zachęcających do jego zakupu. Jeśli chcesz uzupełnić firmową flotę o niezawodne auto, które sprawdzi się prawie w każdych warunkach – postaw na tego Citroena.</p>
        `
      },
      {
        title: "Citroen C3 – spalanie",
        text: `
          <p>Średnie spalanie w przypadku modelu Citroena C3 to wynik na poziomie 8 litrów na 100 kilometrów w cyklu mieszanym. Typowo miejska jazda nie powinna wygenerować spalania większego niż 10 litrów na 100 kilometrów. W przypadku użytkowania Citroena C3 poza miastem na trasie możesz ograniczyć zużycie paliwa nawet do 5,5 litra na 100 kilometrów przy założeniu, że nie jedziesz szybciej niż 90 km/h.</p>
        `
      },
      {
        title: "Citroen C3 w ofercie mAuto",
        text: `
          <p>Nowy Citroen C3 to świetny wybór dla przedsiębiorców w branży handlowej. Idealnie nadaje się do jazdy po mieście, a także na trasy międzymiastowe. To auto perfekcyjne dla przedstawiciela handlowego. Kupując je w mAuto zyskujesz też pakiet korzyści: ubezpieczenie, wsparcie serwisowe oraz kartę paliwową.</p>
        `
      }
    ]
  },
  TOYOTA_YARIS: {
    MAIN_TEXT:
      "Przejrzyj bogatą ofertę różnych wersji modelowych auta Toyota Yaris z ostatnich roczników. To wyjątkowe auta, które doskonale sprawdzą się jako uzupełnienie firmowej floty pojazdów. Wybierz model, który w 100% sprosta Twoim oczekiwaniom. Dopasuj nową Toyotę Yaris na podstawie indywidualnych preferencji i skorzystaj.",
    ADDITIONAL_TEXTS: [
      {
        title: "Toyota Yaris – dane techniczne",
        text: `
          <p>Ostatnie modele Toyoty Yaris to świetny wybór jako niewielkie auto miejskie do uzupełnienia firmowej floty samochodów. Wyjątkowa trwałość podzespołów, wieloletnia gwarancja oraz ponadczasowa linia boczna to tylko trzy wyróżniki tego modelu. Koncern Toyota zadbał o to, aby Yaris sprostał oczekiwaniom nawet najbardziej wymagających użytkowników. To auto z segmentu pojazdów miejskich, które wyróżnia się takimi cechami jak m.in.:</p>
          <ul>
            <li>oszczędne jednostki spalinowe i hybrydowe o pojemności 1,5 litra,</li>
            <li>system asystenta pasa ruchu oraz automatyczne światła z czujnikiem zmierzchu,</li>
            <li>elektrycznie sterowane lusterka,</li>
            <li>łączność Bluetooth,</li>
            <li>uchwyty ISOFIX na tylnej kanapie,</li>
            <li>immobilizer,</li>
            <li>nowoczesny system multimedialny wbudowany w kokpit.</li>
          </ul>
          <p>To tylko kilka z najważniejszych rozwiązań dostępnych w modelach Toyoty Yaris. Oszczędność, ponadczasowa stylistyka i niezawodność to cechy zachęcające do włączenia takiego samochodu do floty swojego przedsiębiorstwa.</p>
        `
      },
      {
        title: "Toyota Yaris – spalanie",
        text: `
          <p>Według danych producenta Toyota Yaris osiąga spalanie na poziomie 5,5 litra na 100 kilometrów. To świetny wynik, który przekłada się na ogromne oszczędności podczas eksploatacji auta w przestrzeni miejskiej i nie tylko.</p>
        `
      },
      {
        title: "Toyota Yaris w ofercie mAuto",
        text: `
          <p>Zamierzasz kupić jedną z dostępnych wersji modelowych Toyoty Yaris? W ofercie mAuto znajdziesz samochody poleasingowe i fabrycznie nowe dostępne praktycznie od ręki. Decydując się na zakup przez mAuto zyskujesz atrakcyjną formę finansowania oraz szeroki pakiet usług dodatkowych do wyboru do każdego modelu Toyoty Yaris – zarówno hybrydy, jak i jednostki spalinowej.</p>
        `
      }
    ]
  },
  TOYOTA_AURIS: {
    MAIN_TEXT:
      "Niezawodne modele Toyoty Auris są dostępne w ofercie mAuto. Przejrzyj auta z ostatnich roczników i wybierz model dopasowany do Twoich indywidualnych potrzeb. Jeśli szukasz nowych pojazdów do firmowej floty to Toyota Auris będzie strzałem w dziesiątkę. Wybierz jeden spośród dostępnych modeli i ciesz się autem w rozsądnej cenie.",
    ADDITIONAL_TEXTS: [
      {
        title: "Toyota Auris – dane techniczne",
        text: `
          <p>Toyota Auris to samochód, który znajduje zastosowanie zarówno jako pojazd użytkowany prywatnie, jak i uzupełnienie firmowej floty. Koncern zajmujący się produkcją tych modeli zadbał o każdy szczegół, dzięki czemu wieloletnia eksploatacja samochodu tej klasy nie stanowi żadnego problemu. Kluczowe parametry techniczne wyróżniające Toyotę Auris spośród innych modeli dostępnych w sprzedaży to:</p>
          <ul>
            <li>aż 6 poduszek powietrznych wraz z poduszką na kolana kierowcy,</li>
            <li>centralny wyświetlacz pomiędzy zegarami,</li>
            <li>system wspomagania hamowania,</li>
            <li>system stabilizacji toru jazdy,</li>
            <li>wspomaganie układu kierowniczego,</li>
            <li>automatyczna klimatyzacja,</li>
            <li>czujniki parkowania.</li>
          </ul>
          <p>Toyota Auris to auto, które naprawdę warto kupić jako uzupełnienie firmowej floty. Postaw na niezawodność i zamów poleasingową lub nową Toyotę Auris na atrakcyjnych warunkach finansowania.</p>
        `
      },
      {
        title: "Toyota Auris – spalanie",
        text: `
          <p>Ten model Toyoty wyróżnia się spalaniem na poziomie ok. 7,6 litra benzyny na 100 kilometrów drogi. To świetny wynik, biorąc pod uwagę gabaryty auta oraz masę całkowitą. Dla silnika 1.6 w wersji benzynowej to jak najbardziej akceptowalne spalanie.</p>
        `
      },
      {
        title: "Toyota Auris w ofercie mAuto",
        text: `
          <p>Jeśli szukasz jednego samochodu, który z łatwością dopasuje się do Twoich zmiennych potrzeb, koniecznie przejrzyj modele Toyoty Auris dostępne w ofercie mAuto. Wraz z bezawaryjnym autem zyskasz też dostęp do szerokiego pakietu korzyści i usług dodatkowych.</p>
        `
      }
    ]
  },
  TOYOTA_COROLLA: {
    MAIN_TEXT:
      "Jeśli potrzebujesz wygodnego, niezawodnego i oszczędnego pojazdu do firmowej floty, koniecznie zastanów się nad zakupem Toyoty Corolli. W tym przypadku producent zadbał nawet o najmniejsze detale, dostarczając na rynek wielofunkcyjne auta. Zdecyduj się na jedną z wielu wersji modeli z ostatnich lat Toyoty Corolla i ciesz się całkowicie nowym autem.",
    ADDITIONAL_TEXTS: [
      {
        title: "Toyota Corolla – dane techniczne",
        text: `
          <p>Najnowsze modele Toyoty Corolla to kwintesencja to wyjątkowe połączenie użyteczności i komfortu podróżowania. Postaw na połączenie innowacji technologicznych, klasycznej linii stylistycznej oraz oszczędności – tym wyróżnia się najnowsza Toyota Corolla. Poniżej znajdziesz najważniejsze dane techniczne dotyczące tego modelu Toyoty:</p>
          <ul>
            <li>duża moc przy pojemności silnika na poziomie 1490 m3,</li>
            <li>kolorowy wyświetlacz na tablicy wskaźników,</li>
            <li>przednie i tylne czujniki parkowania,</li>
            <li>automatyczne ściemnianie lusterka wstecznego,</li>
            <li>asystent głosowy,</li>
            <li>7 poduszek powietrznych w systemie SRS,</li>
            <li>ogranicznik prędkości.</li>
          </ul>
          <p>Toyota Corolla to samochód, który jest w stanie sprostać oczekiwaniom nawet najbardziej wymagających użytkowników. Poszczególne modele auta Toyota Corolla, dostępne w mAuto wyróżniają się nie tylko bogatym wyposażeniem wnętrza, ale także dostępem do najnowszych systemów bezpieczeństwa.</p>
        `
      },
      {
        title: "Toyota Corolla – spalanie",
        text: `
          <p>Zgodnie z informacjami dostarczonymi przez producenta nowa Toyota Corolla ma spalanie na poziomie nawet poniżej 6 litrów na 100 kilometrów drogi w trybie mieszanym. Takie osiągi generują ogromne oszczędności, szczególnie jeśli Toyota Corolla pojawi się w firmowej flocie samochodów.</p>
        `
      },
      {
        title: "Toyota Corolla w ofercie mAuto",
        text: `
          <p>Zdecyduj się na zakup dowolnie wybranej wersji modelowej auta Toyota Corolla. W mAuto zyskasz dostęp do wielu samochodów od ręki, a dodatkowo skorzystasz z atrakcyjnych form finansowania dopasowanych do potrzeb i możliwości Twojego przedsiębiorstwa.</p>
        `
      }
    ]
  },
  AUDI_Q5: {
    MAIN_TEXT:
      "Nowoczesne Audi Q5 to jeden z wielu samochodów dostępnych w ofercie mAuto. Modele z najnowszych roczników są dostępne w różnych wariantach finansowania – leasingu albo najmu długoterminowego. To średniej wielkości SUV, który doskonale nada się do jazdy po mieście, jak i po bezdrożach. Postaw na Audi Q5 i ciesz się prestiżową prezentacją samochodu oraz komfortem eksploatacji każdego dnia. Wybierz swoje Audi Q5!",
    ADDITIONAL_TEXTS: [
      {
        title: "Audi Q5 – dane techniczne",
        text: `
          <p>Zaawansowany technologicznie i wygodny samochód Audi Q5 łączy w sobie najnowocześniejsze rozwiązania oraz systemy bezpieczeństwa, które przekładają się na niesamowity komfort podróżowania. Wybierz ten pojazd do firmowej floty, a zyskasz ogromną przestrzeń bagażową i niezawodność w jednym. Kluczowe wyróżniki tego modelu to:</p>
          <ul>
            <li>moc na poziomie ponad 200 KM,</li>
            <li>nowoczesny system Audi parking system plus i drive select,</li>
            <li>wirtualny kokpit z pełną łącznością bezprzewodową,</li>
            <li>kamera cofania,</li>
            <li>automatyczna klimatyzacja 3-strefowa,</li>
            <li>nowoczesne światła Matrix LED i innowacyjny układ zmywania reflektorów.</li>
          </ul>
          <p>Samochody Audi doskonale sprawdzą się jako prestiżowe samochody klasy premium w przedsiębiorstwie. Uzupełnij swoją firmową flotę i postaw na najnowsze modele Q5.</p>
        `
      },
      {
        title: "Audi Q5 – spalanie",
        text: `
          <p>Według danych producenta spalanie w modelu Audi Q5 spalanie nie przekracza poziomu ok. 8,4 litra na 100 kilometrów drogi w trybie mieszanym. Stosunkowo niewielkie zużycie paliwa z prędkością maksymalną sięgającą do 240 km/h to świetny wynik.</p>
        `
      },
      {
        title: "Audi Q5 w ofercie mAuto",
        text: `
          <p>Zdecyduj się na jeden z modeli Audi Q5 dostępnych w ofercie mAuto i zyskaj luksusowy i przestronny samochód w atrakcyjnej cenie. Oprócz możliwości skorzystania z leasingu lub najmu długoterminowego możesz też wybrać szeroki pakiet korzyści dla klientów mAuto wraz z pełnym ubezpieczeniem OC, AC i NNW.</p>
        `
      }
    ]
  },
  OPEL_ASTRA: {
    MAIN_TEXT:
      "Zobacz szeroką propozycję modeli Opla Astry z rocznika 2023 i nie tylko. W jednym miejscu znajdziesz najciekawsze wersje modelowe, które są w stanie sprostać zmiennym wymaganiom przedsiębiorców. Dopasuj kryteria wyszukiwania do swoich preferencji i zdecyduj się na zakup. Nowy Opel Astra doskonale sprawdzi się w firmowej flocie aut osobowych. To auto możesz mieć w atrakcyjnym leasingu.",
    ADDITIONAL_TEXTS: [
      {
        title: "Opel Astra – dane techniczne",
        text: `
          <p>Samochody Opel Astra mogą zaskoczyć każdego użytkownika. Producent zdecydował się na wprowadzenie wielu innowacji technologicznych. Na podstawowym wyposażeniu Opla Astry znajdziesz przede wszystkim elektrycznie sterowany hamulec postojowy oraz komfortowe fotele. Pozostałe parametry wyróżniające Opla Astrę w ofercie mAuto to:</p>
          <ul>
            <li>aż 10-calowy wyświetlacz kolorowy,</li>
            <li>elektrycznie sterowane szyby przednie i tylne,</li>
            <li>klimatyzacja,</li>
            <li>reflektory w technologii LED,</li>
            <li>kierownica pokryta skórą,</li>
            <li>automatyczne światła z czujnikiem oświetlenia,</li>
            <li>światłoczułe wewnętrzne lusterko.</li>
          </ul>
          <p>To tylko kilka parametrów, które powodują, że Opel Astra jest dobrym wyborem do firmowej floty pojazdów. Jeśli szukasz niezawodnego auta z eleganckim wnętrzem – wybierz Opla Astrę.</p>
        `
      },
      {
        title: "Opel Astra – spalanie",
        text: `
          <p>Opel Astra to samochód osobowy, którego spalanie nie przekracza 6,5 litra na 100 kilometrów w trybie miejskim, a także 5 litrów w trybie mieszanym. Takie wartości są deklarowane przez producenta. To sprawia, że Opel Astra jest tani w eksploatacji, a więc doskonale nadaje się do codziennego użytkowania w firmowej flocie samochodów osobowych.</p>
        `
      },
      {
        title: "Opel Astra w ofercie mAuto",
        text: `
          <p>Nowy Opel Astra to samochód idealny dla przedsiębiorców zajmujących się handlem. Stosunkowo niewielkie spalanie, niezawodność oraz gwarantowany komfort jazdy to główne korzyści wynikające z zakupu tego samochodu. Oprócz tego, kupując Opla Astrę z oferty mAuto otrzymujesz pakiet udogodnień: ubezpieczenie, kartę paliwową oraz atrakcyjne warunki finansowania.</p>
        `
      }
    ]
  },
  SKODA_OCTAVIA: {
    MAIN_TEXT:
      "Przejrzyj ciekawą propozycję Skody. Model Octavia możesz mieć w cenie zaczynającej się już od 383 złote miesięcznie. Skoda Octavia jest dostępna na atrakcyjnych warunkach finansowania i w wielu wersjach modelowych. Wybierz Skodę Octavię, która w 100% sprosta Twoim oczekiwaniom. To idealne auto do uzupełnienia floty samochodów osobowych w przedsiębiorstwie.",
    ADDITIONAL_TEXTS: [
      {
        title: "Skoda Octavia – dane techniczne",
        text: `
          <p>Najnowocześniejsze modele Skody Octavia to połączenie ponadczasowego designu oraz niesamowitych osiągów. Jeśli szukasz nowych aut do firmowej floty, koniecznie weź pod uwagę model Skoda Octavia, który doskonale sprawdza się w miejskich i pozamiejskich warunkach. Samochody czeskiego producenta łączą w sobie wszystko to, co najlepsze: nienaganny design, doskonałe osiągi oraz niezawodność w każdej sytuacji. Kluczowe parametry techniczne modelu Skoda Octavia to:</p>
          <ul>
            <li>pełne systemy bezpieczeństwa ABS i ASR,</li>
            <li>aż 6 sztuk poduszek powietrznych wraz z kurtynami,</li>
            <li>system regulacji hamowania na zakręcie CBC,</li>
            <li>oprogramowanie przeciwblokujące koła podczas hamowania silnikiem,</li>
            <li>elektryczne podnoszenie szyb z przodu i z tyłu,</li>
            <li>system kontroli ciśnienia w oponach,</li>
            <li>multimedialne radio,</li>
            <li>lampy w technologii LED.</li>
          </ul>
          <p>To tylko kilka cech wyróżniających model Skoda Octavia spośród innych samochodów dostępnych w ofercie mAuto. Postaw na jakość i niezawodność – kup Skodę Ocatvię do swojej firmy w atrakcyjnej ofercie leasingu.</p>
        `
      },
      {
        title: "Skoda Octavia – spalanie",
        text: `
          <p>Zgodnie z danymi producenta spalanie w modelach Skody Octavii nie przekracza wartości ok. 5,3 litra na 100 kilometrów podczas cyklu mieszanego. Tak niski poziom zużycia paliwa sprawia, że Skoda Octavia jest idealnym wyborem do firmowej floty aut, np. dla przedstawicieli handlowych. Niskie spalanie i niezawodność to cechy, w które warto zainwestować.</p>
        `
      },
      {
        title: "Skoda Octavia w ofercie mAuto",
        text: `
          <p>Wybierz Skodę Octavię do swojej firmy. Zarówno fabrycznie nowa, jak i poleasingowa będzie świetnym uzupełnieniem floty przedsiębiorstwa. To perfekcyjne auto nie tylko dla przedstawicieli handlowych, ale także dla kadry kierowniczej. Zamów Skodę Octavię w mAuto i zyskaj szeroki pakiet korzyści: kartę paliwową, pełen pakiet ubezpieczeń i opiekę serwisową.</p>
        `
      }
    ]
  },
  HYUNDAI_I30: {
    MAIN_TEXT:
      "Najnowsze modele Hyundai i30 dostępne praktycznie od ręki w ofercie mAuto. Topowe modele z najświeższych roczników kupisz w dobrych cenach. Postaw na niezawodność i wybierz Hyundaia i30. Ciesz się prestiżem, niezawodnością oraz doskonałymi osiągami. Wybierz samochody sprawdzonej marki, która jest w stanie sprostać wyzwaniom, z jakimi zmagają się auta w firmowych flotach. Zobacz modele Hyundai i30 dostępne od ręki.",
    ADDITIONAL_TEXTS: [
      {
        title: "Hyundai i30 – dane techniczne",
        text: `
          <p>Fabrycznie nowy Hyundai i30 to samochód, który doskonale nadają się do firmowej floty pojazdów – zarówno dla kadry kierowniczej, jak i dla przedstawicieli handlowych. Hyundai i30 to połączenie najnowszych technologii z niezawodnymi jednostkami silnikowymi. Kluczowe dane techniczne modeli Hyundai i30 dostępnych w ofercie mAuto to:</p>
          <ul>
            <li>systemu bezpieczeństwa ABS, ESC i HAC,</li>
            <li>poduszki i kurtyny powietrzne,</li>
            <li>asystent unikania kolizji czołowych,</li>
            <li>immobilizer,</li>
            <li>elektryczne wspomaganie kierownicy,</li>
            <li>multimedialne radio z 10,25-calowym ekranem dotykowym,</li>
            <li>reflektory w technologii LED.</li>
          </ul>
          <p>Hyundai i30 to samochód, który ma w sobie praktycznie wszystko to, czego możesz potrzebować w firmowej flocie pojazdów.</p>
        `
      },
      {
        title: "Hyundai i30 – spalanie",
        text: `
          <p>Zgodnie z informacjami od producenta Hyundai i30 zużywa nie więcej niż 4,8 litra paliwa na 100 kilometrów w trybie mieszanym. To w połączeniu z niską emisją spalin na poziomie 109 g, a także wysoką mocą jednostki silnika jest gwarancją sporych oszczędności na codziennej eksploatacji auta.</p>
        `
      },
      {
        title: "Hyundai i30 w ofercie mAuto",
        text: `
          <p>Zdecyduj się na Hyundaia i30 w ofercie mAuto, a na pewno nie pożałujesz. Oprócz atrakcyjnych warunków finansowania zyskasz też dostęp do pełnego pakietu ubezpieczeń, karty paliwowej oraz wsparcia serwisowego. Skorzystaj z oferty mAuto i postaw na sprawdzone modele Hyundai i30 dostępne od ręki.</p>
        `
      }
    ]
  },
  FORD_FOCUS: {
    MAIN_TEXT:
      "Poznaj najnowsze modele Forda Focusa w mAuto. To ponadczasowe, niezawodne i oszczędne samochody. Skorzystaj z atrakcyjnej formy finansowania – najmu długoterminowego lub leasingu. Ford Focus idealnie uzupełni firmową flotę samochodów osobowych. Wybierz jedną z wielu dostępnych wersji wyposażenia Forda Focusa dostępnych od ręki.",
    ADDITIONAL_TEXTS: [
      {
        title: "Ford Focus – dane techniczne",
        text: `
          <p>Nowe i poleasingowe auta takie jak Ford Focus to idealny wybór dla każdego przedsiębiorstwa. Jeśli szukasz połączenia niezawodności, doskonałych osiągów oraz dostępu do licznych udogodnień – ten samochód będzie idealny. Najistotniejsze parametry wyróżniające Forda Focusa to:</p>
          <ul>
            <li>najnowsze systemy bezpieczeństwa ESP, TSC, TA, EBA i HSA,</li>
            <li>bezprzewodowe radio z dużym dotykowym wyświetlaczem,</li>
            <li>reflektory w technologii LED,</li>
            <li>relingi bagażnika dachowego na standardowym wyposażeniu,</li>
            <li>wbudowany moduł FordPass Connect,</li>
            <li>trójramienna kierownica,</li>
            <li>system monitorowania ciśnienia w oponach,</li>
            <li>skórzane wykończenie wnętrza,</li>
            <li>elektrycznie regulowane lusterka boczne i szyby,</li>
            <li>poduszki powietrzne i kurtyny w przedniej i tylnej części auta.</li>
          </ul>
          <p>To najistotniejsze parametry techniczne z punktu widzenia użytkownika. Wybierz Forda Focusa do swojej firmowej floty i ciesz się niezawodnością połączoną z komfortem podróżowania.</p>
        `
      },
      {
        title: "Ford Focus – spalanie",
        text: `
          <p>Producent zapewnia, że Ford Focus ma spalanie na poziomie nie większym niż 8,9 litra na 100 kilometrów w trybie mieszanym. To dobry wynik, biorąc pod uwagę wysoką moc jednostki napędowej oraz gabaryty samochodu.</p>
        `
      },
      {
        title: "Ford Focus w ofercie mAuto",
        text: `
          <p>Wybierz nowego lub poleasingowego Forda Focusa w mAuto. Zyskasz atrakcyjne warunki finansowania, kartę paliwową oraz pakiet usług serwisowych. Wybierz formę finansowania dopasowaną do swoich potrzeb i zdecyduj się na Forda Focusa – idealne uzupełnienie firmowej floty aut osobowych.</p>
        `
      }
    ]
  },
  OPEL_ASTRA_V: {
    MAIN_TEXT:
      "Sprawdź ofertę samochodów Opel Astra V w mAuto. Wybierz model, który najlepiej pasuje do potrzeb Twojej firmy. Astra to ekonomiczne, eleganckie i komfortowe auto, idealne zarówno dla przedstawicieli handlowych, jak i osób prowadzących działalność gospodarczą.",
    ADDITIONAL_TEXTS: [
      {
        title: "Opel Astra V – dane techniczne",
        text: `
          <p>Opel Astra V jest dostępny w dwóch wersjach silnikowych: 1.6 CDTI, 1.5 CDTI i 1.2 T Edition. Wyróżnikiem tych samochodów jest stosunek ceny do jakości. Astry z serii V osiągają wysokie wyniki przy stosunkowo niskim zużyciu paliwa. Jednocześnie auta są przystępne cenowo, co czyni je atrakcyjnym wyborem dla osób poszukujących ekonomicznych rozwiązań.</p>  
          <p>Spośród rozwiązań zastosowanych w najnowszych modelach Opla Astry warto wymienić m.in.:</p>
          <ul>
            <li>asystent podjazdu pod górkę,</li>
            <li>tempomat,</li>
            <li>automatyczna klimatyzacja,</li>
            <li>elektryczne szyby przednie,</li>
            <li>elektryczny podajnik pasa bezpieczeństwa.</li>
          </ul>  
          <p>Wersje Opla Astry V w ofercie mAuto różnią się mocą i momentem obrotowym silnika. Jednostki 1.6 CDTI to obecnie najmocniejsze silniki w rocznikach do 2018 roku. Wersje 1.2 Turbo to natomiast silniki benzynowe, które generują nieco większą moc ze względu na zastosowanie turbosprężarki.</p>
        `
      },
      {
        title: "Opel Astra V – zużycie paliwa",
        text: `
          <p>Sprawdź, jak prezentuje się zestawienie zużycia paliwa dla wybranych silników:</p>
  
          <p><strong>Opel Astra 1.6 CDTI</strong></p>
          <p>Silnik 1.6 CDTI wyróżnia się oszczędnością paliwa, zwłaszcza podczas dłuższych podróży. Średnie zużycie w cyklu mieszanym wynosi około 5,2-6,3 l/100 km. W trasie można uzyskać wynik nawet 4,7-5,1 l/100 km, przy ekonomicznej jeździe. W mieście zużycie paliwa jest nieco wyższe, ale wciąż konkurencyjne jak na jednostkę wysokoprężną.</p>
  
          <p><strong>Opel Astra 1.5 CDTI</strong></p>
          <p>Nowsza jednostka 1.5 CDTI, dostępna po liftingu Astry, cechuje się jeszcze lepszą wydajnością w wersji o mocy 122 KM. Średnie zużycie wynosi około 5,2 l/100 km. Na autostradzie lub przy stałej prędkości w trasie wynik może spadać nawet do 4,5-5,0 l/100 km. Jest to jeden z najbardziej oszczędnych modeli Astry.</p>
  
          <p><strong>Opel Astra 1.2 Turbo (benzyna)</strong></p>
          <p>Wersja 1.2 Turbo o mocy 130 KM spala ok. 6,4-7,2 l/100 km w cyklu mieszanym. Na trasie, przy zrównoważonej jeździe, zużycie może wynosić około 6,4 l/100 km. W mieście natomiast można spodziewać się zużycia na poziomie około 7,0-7,2 l/100 km.</p>
  
          <p><strong>Silnik 1.4 Turbo (benzyna)</strong></p>
          <p>To benzynowa jednostka o mocy 150 KM, która oferuje dobre połączenie osiągów i oszczędności paliwa. Średnie zużycie w cyklu mieszanym wynosi około 5,5-6,6 l/100 km. Na dłuższych odcinkach, przy umiarkowanej prędkości, zużycie paliwa może spaść do 4,4-5,5 l/100 km. W mieście wartość ta wzrasta do 7,1-8,6 l/100 km.</p>
        `
      },
      {
        title: "Opel Astra V – idealne auto do floty małej, średniej i dużej firmy",
        text: `
          <p>Poleasingowy Opel Astra V to świetne auto do uzupełnienia firmowej floty. Samochody niemieckiego producenta sprostają oczekiwaniom zarówno właścicieli jednoosobowych działalności, jak i firm z sektora MŚP. To pojazdy o dużej przestrzeni bagażowej, z wygodnymi fotelami oraz zaawansowanym komputerem pokładowym. Dzięki temu codzienna jazda Astrą V jest przyjemna i komfortowa.</p>
  
          <p>Jeśli szukasz bezpiecznego, wygodnego i przestronnego samochodu? Sprawdź ofertę poleasingowego Opla Astrę V z roczników 2018-2021 w mAuto. Stosunkowo niewielkie koszty leasingowe i niskie koszty eksploatacji auta to kluczowe wyróżniki zachęcające do włączenia tego pojazdu do firmowej floty.</p>
        `
      },
      {
        title: "Elegancki i nowoczesny – Opel Astra V do firmy",
        text: `
          <p>Szukasz taniego, ale i jednocześnie reprezentatywnego samochodu, który nada się do eksploatacji w firmowej flocie przez wiele lat? W takim razie Opel Astra V będzie strzałem w dziesiątkę. Jeśli cenisz sobie połączenie ponadczasowej elegancji, komfortu i bezpieczeństwa jazdy, prawdopodobnie Opel będzie jednym z lepszych wyborów.</p>
        `
      },
      {
        title: "Ekonomiczny Opel Astra V w ofercie mAuto",
        text: `
          <p>Samochody Opel Astra V są dostępne w ofercie poleasingowej mAuto lub za gotówkę. Dzięki kalkulatorowi leasingowemu dostępnemu na stronie możesz łatwo dopasować warunki finansowania do potrzeb Twojej firmy. W ofercie znajdziesz także ubezpieczenie, assistance i kartę paliwową, co czyni ją jeszcze bardziej atrakcyjną.</p>
        `
      }
    ]
  },
  VOLVO_XC40: {
    MAIN_TEXT:
      "Samochody marki Volvo od lat cieszą się doskonałą opinią wśród kierowców. Auta szwedzkiego producenta stanowią synonim elegancji, wysokiej jakości i bezpieczeństwa. Jednocześnie można je umieścić w kategorii samochodów do zadań specjalnych – ładowna przestrzeń bagażowa to wyróżnik wielu modeli marki. Jak w firmowej flocie sprawdzają się modele Volvo XC40? Poznaj ofertę mAuto i przekonaj się.",
    ADDITIONAL_TEXTS: [
      {
        title: "Volvo XC40 – dane techniczne",
        text: `
          <p>Nowe Volvo XC40 to samochód z silnikiem benzynowym 2-litrowym B3 Core o mocy 163 KM. Jednostka z automatyczną skrzynią biegów zapewnia komfort, dobre przyspieszenie i niskie zużycie paliwa.</p>
  
          <p>Spośród rozwiązań zastosowanych w najnowszych modelach Volvo warto wymienić m.in.:</p>
          <ul>
            <li>automatyczną klimatyzację dwustrefową,</li>
            <li>antykolizyjny system Oncoming Lane Mitigation,</li>
            <li>system ułatwiający podjazd pod wzniesienia,</li>
            <li>elektryczne blokady zabezpieczające drzwi,</li>
            <li>7-stopniową, dwusprzęgłową automatyczną skrzynię biegów.</li>
          </ul>
  
          <p>To tylko niektóre udogodnienia zastosowane w nowych modelach Volvo XC40. Jeśli zamierzasz włączyć taki pojazd do firmowej floty, koniecznie weź pod uwagę wszystkie parametry techniczne auta. W ten sposób łatwiej wybierzesz wersję wyposażenia Volvo XC40, która odpowiada Twoim preferencjom.</p>
        `
      },
      {
        title: "Volvo XC40 – zużycie paliwa",
        text: `
          <p>Nowe Volvo XC40 z rocznika 2024 jest dostępne w kilku wersjach silnikowych, z których każda charakteryzuje się innym poziomem zużycia paliwa. Wersja B3 Core posiada 2.0-litrowy, turbodoładowany silnik benzynowy z technologią mild-hybrid, generujący moc 163 KM.</p>
  
          <p>Średnie zużycie paliwa Volvo XC40 wynosi około 42,7 mpg (mil na galon), co odpowiada około 6,6 l/100 km. W rzeczywistych warunkach drogowych, szczególnie podczas dynamicznej jazdy, może ono wynosić od 7 do 9 l/100 km.</p>
  
          <p>Mocniejsza wersja B4 z silnikiem o mocy 197 KM oferuje podobne zużycie paliwa, ale zapewnia nieco lepsze osiągi.</p>
        `
      },
      {
        title: "Volvo XC40 – szwedzka jakość i bezpieczeństwo",
        text: `
          <p>Modele Volvo XC40 to połączenie niezawodności, bezpieczeństwa i wysokiej jakości. Producent dba o to, aby sprzedawane pojazdy sprostały oczekiwaniom nawet najbardziej wymagających kierowców.</p>
  
          <p>Volvo od lat stawia na innowacyjne technologie wspomagające kierowców i dbające o bezpieczeństwo pasażerów. Model XC40 został wyposażony w wiele nowoczesnych systemów i udogodnień. Warto tu wymienić m.in. asystent pasa ruchu, automatyczny hamulec oraz monitorowanie martwego pola.</p>
  
          <p>Takie technologie sprawiają, że samochód doskonale sprawdza się zarówno w miejskim ruchu, jak i na dłuższych trasach. Volvo XC40 to dobry wybór na auto służbowe, niezależnie od branży i upodobań kierowcy.</p>
        `
      },
      {
        title: "Nowe Volvo XC40 – dla małych i dużych przedsiębiorców",
        text: `
          <p>Volvo XC40 to kompaktowy, miejski SUV, który świetnie sprawdzi się zarówno w małej, jak i dużej firmie. Wyróżniki tego modelu, które determinują o opłacalności jego zakupu do firmowej floty to:</p>
  
          <p><strong>wszechstronność</strong> – Volvo świetnie sprawdzi się w roli samochodu firmowego do różnych celów. Auto można wykorzystać zarówno na spotkania z klientami, jak i na codzienne zadania związane z prowadzeniem działalności;</p>
  
          <p><strong>komfort i elegancja</strong> – charakterystyczna linia nadwozia to jeden z elementów rozpoznawalnych marki. To świetnie auta reprezentacyjne, budujące określony wizerunek firmy. Wnętrze natomiast oferuje zaskakująco dużo miejsca, dzięki czemu samochód jest wygodny zarówno dla kierowcy, jak i pasażerów;</p>
  
          <p><strong>zrównoważone zużycie paliwa</strong> – dzięki zastosowaniu nowoczesnych, ekonomicznych jednostek silnikowych.</p>
  
          <p>Volvo XC40 łączy bezpieczeństwo, niezawodność, prestiż i nowoczesne technologie, co sprawia, że to doskonały wybór dla przedsiębiorców. Może być ważnym elementem nowoczesnej floty firmowej.</p>
        `
      },
      {
        title: "Volvo XC40 – miejski SUV w ofercie mAuto",
        text: `
          <p>Jeśli zdecydujesz się na Volvo XC40 z oferty mAuto, zyskasz przede wszystkim szeroki pakiet korzyści. W ramach umowy leasingowej możesz wykupić ubezpieczenie OC, AC, NNW, assistance oraz skorzystać z pełnego wsparcia serwisowego. Dla przedsiębiorców dostępna jest też karta paliwowa, dzięki której eksploatacja Volvo XC40 jest o wiele wygodniejsza.</p>
        `
      }
    ]
  },
  FORD_MONDEO: {
    MAIN_TEXT:
      "Model Forda Mondeo zadebiutował w 1993 roku i do dziś marka produkuje jego kolejne wersje. Auto na przestrzeni lat zyskało renomę limuzyny ze średniej półki – jest eleganckie i stylowe, a jednocześnie przystępne cenowo. Sprawdź ofertę mAuto i wybierz samochód, który zapewni Ci komfort, bezpieczeństwo i świetne osiągi. Przejrzyj naszą ofertę i poznaj modele Forda Mondeo dostępne od ręki.",
    ADDITIONAL_TEXTS: [
      {
        title: "Ford Mondeo – dane techniczne",
        text: `
          <p>Ford Mondeo z roczników 2019-2021 to samochód, który idealnie sprawdzi się w firmowych flotach. Zanim zdecydujesz się na ten pojazd, możesz dokładnie przeanalizować kluczowe parametry techniczne. Spośród dostępnych elementów wyposażenia Forda Mondeo warto wyróżnić:</p>
  
          <ul>
            <li>manualna lub automatyczna skrzynia biegów,</li>
            <li>aktywny system parkowania wspomagający parkowanie równoległe i prostopadłe,</li>
            <li>elektroniczny system rozdziału siły hamulców,</li>
            <li>FordPass Connect z modemem GSM,</li>
            <li>automatyczna klimatyzacja,</li>
            <li>dynamiczne reflektory LED.</li>
          </ul>
  
          <p>Jeśli szukasz połączenia innowacyjności, komfortu oraz niewielkiego zużycia paliwa, koniecznie weź pod uwagę jeden z modeli Forda Mondeo dostępnego w mAuto.</p>
        `
      },
      {
        title: "Ford Mondeo – zużycie paliwa",
        text: `
          <p>Ford Mondeo oferuje szeroką gamę silników, które różnią się pod względem osiągów. Całkowite zużycie paliwa jest zawsze zależne od stylu jazdy. Tak przedstawiają się średnie dane dla poszczególnych wersji silnikowych:</p>
  
          <p><strong>1.5 EcoBoost (160 KM)</strong></p>
          <p>Średnie zużycie paliwa dla tej jednostki benzynowej wynosi około 6,5 l/100 km w cyklu mieszanym.</p>
  
          <p><strong>2.0 TDCi (150 KM)</strong></p>
          <p>Ten popularny silnik wysokoprężny charakteryzuje się zużyciem paliwa na poziomie 5,0 l/100 km w cyklu mieszanym. Jest to bardzo konkurencyjny wynik, szczególnie dla diesli w tej klasie.</p>
  
          <p><strong>2.0 EcoBlue (150 KM)</strong></p>
          <p>Najnowsza generacja silników diesla Forda, EcoBlue, zużywa średnio od 4,5 do 5,0 l/100 km. W mieście zużycie paliwa może wzrosnąć do około 6,0 l/100 km.</p>
  
          <p><strong>2.0 EcoBoost (240 KM)</strong></p>
          <p>Mocniejsza wersja benzynowa oferuje dynamiczne osiągi, ale zużywa średnio 8,5–9,0 l/100 km przy szybszej jeździe. W trasie przy spokojniejszej jeździe można osiągnąć wyniki na poziomie 6,5 l/100 kilometrów.</p>
  
          <p><strong>2.0 Hybrid (187 KM)</strong></p>
          <p>Hybrydowa wersja Mondeo oferuje oszczędność paliwa, zwłaszcza w mieście, gdzie silnik elektryczny wspiera jednostkę spalinową. Średnie zużycie paliwa wynosi 5,5–6,5 l/100 km, a przy oszczędnej jeździe może spaść do 4,5 l.</p>
        `
      },
      {
        title: "Kompaktowy i ekonomiczny – Ford Mondeo",
        text: `
          <p>Poleasingowy Ford Mondeo to ekonomiczny wybór. Niewielkie zużycie paliwa, niezawodne części eksploatacyjne oraz stosunkowo rzadko występujące usterki to kilka wyróżników tego pojazdu. Jeśli dodatkowo szukasz auta, które oferuje dużo przestrzeni bagażowej oraz miejsc dla pasażerów, wtedy weź pod uwagę Forda Mondeo.</p>
  
          <p>To świetny kandydat na pojazd do floty firmowej, gdzie liczą się oszczędności i niewielkie koszty leasingowe. Wybierz Forda Mondeo i podróżuj biznesowo bez wysokich kosztów paliwa.</p>
        `
      },
      {
        title: "Poleasingowy Ford Mondeo – świetny dla biznesu",
        text: `
          <p>Nie ma wątpliwości, że Ford Mondeo to dobry wybór dla biznesu. Modele poleasingowe oferują oszczędności dzięki niższej cenie, mniejszej racie leasingowej i braku opłaty wstępnej.</p>
  
          <p>Wyróżniki zachęcające do zakupu Forda Mondeo dla biznesu to:</p>
          <ul>
            <li>oszczędne jednostki napędowe,</li>
            <li>przestronne wnętrze i duża przestrzeń bagażowa,</li>
            <li>nowoczesne technologie połączone z komputerem pokładowym,</li>
            <li>reputacja niezawodnego i trwałego pojazdu z wieloletnią historią na rynku.</li>
          </ul>
  
          <p>Jeśli prowadzisz firmę i szukasz auta dla przedstawiciela handlowego lub personelu zarządzającego, rozważ Forda Mondeo.</p>
        `
      },
      {
        title: "Ford Mondeo w różnych rocznikach – oferta mAuto",
        text: `
          <p>Oferta mAuto dla Forda Mondeo obejmuje wiele poleasingowych modeli aut w różnych wersjach silnikowych ze skrzynią automatyczną lub manualną. Wybierz jedną z wersji i zyskaj szereg korzyści. W cenie leasingu otrzymasz ubezpieczenie OC, AC, NNW i assistance. Zyskasz także kartę paliwową dla firmy oraz wsparcie serwisowe z pakietem wymiany opon.</p>
  
          <p>Postaw na oszczędność, komfort i reprezentacyjny wygląd – wybierz poleasingowego Forda Mondeo z naszej oferty i zbuduj stabilną flotę firmowych pojazdów.</p>
        `
      }
    ]
  },
  BMW_SERIA_5: {
    MAIN_TEXT:
      "Nowe BMW serii 5 to samochód, który sprosta oczekiwaniom nawet najbardziej wymagających przedsiębiorców. Nowoczesne wyposażenie, intuicyjny kokpit oraz elegancka linia nadwozia to tylko trzy podstawowe wyróżniki tego modelu. Zobacz dostępne egzemplarze BMW serii 5 i wybierz auto idealne do firmowej floty Twojego przedsiębiorstwa.",
    ADDITIONAL_TEXTS: [
      {
        title: "BMW seria 5 – dane techniczne",
        text: `
          <p>BMW 520d xDrive M-Sport zachowuje charakterystyczną dla marki równowagę między sportowymi osiągami a komfortem. Jest doskonałą propozycją dla osób ceniących oszczędność paliwa przy zachowaniu dynamicznej jazdy.</p>
  
          <p>Najistotniejsze parametry techniczne, które determinują opłacalność zakupu BMW serii 5 to:</p>
          <ul>
            <li>permanentny system Start/Stop,</li>
            <li>automatyczna skrzynia biegów z łopatkami przy kierownicy,</li>
            <li>aż 190 KM mocy przy 4000 obrotów,</li>
            <li>bagażnik o pojemności 550 litrów.</li>
          </ul>
  
          <p>Dodatkowo BMW w serii 5 zaimplementowało nowoczesną technologię zawieszenia M-Sport. To oznacza komfort i precyzję prowadzenia dzięki regulowanej twardości zawieszenia, dopasowanej do stylu jazdy. Auto ma też w pełni cyfrowy zestaw wskaźników z 12,3-calowym ekranem, który pokazuje wszystkie istotne informacje o kondycji pojazdu.</p>
        `
      },
      {
        title: "BMW seria 5 – zużycie paliwa",
        text: `
          <p>Nowe BMW Serii 5, zwłaszcza model 520d xDrive M-Sport, łączy oszczędność paliwa z dynamicznymi osiągami. Model napędza czterocylindrowy silniki turbodiesel z technologią mild-hybrid 48V, który generuje moc około 197 KM.</p>
  
          <p>Zużycie w cyklu mieszanym dla wersji 520d xDrive wynosi od 5,5 do 6,0 l/100 km. Emisja CO₂ kształtuje się w zakresie 143-157 gramów na kilometr, w zależności od konfiguracji i warunków jazdy.</p>
        `
      },
      {
        title: "Nowe BMW serii 5 – luksusowe auto ze sportowym pazurem",
        text: `
          <p>BMW serii 5 to od lat synonim elegancji, komfortu i nowoczesnych technologii. W najnowszej odsłonie marka wprowadziła jeszcze więcej innowacyjnych rozwiązań. Zachowała przy tym charakterystyczną dla tego modelu sportową dynamikę. To połączenie luksusu z wyrafinowaną mocą, które zadowoli zarówno miłośników komfortu, jak i pasjonatów szybkiej jazdy.</p>
  
          <p>Jeśli prowadzisz firmę i szukasz szybkiego i eleganckiego auta na spotkania biznesowe, rozważ BMW serii 5. To model samochodu, który mimo 5-drzwiowej wersji ma wyjątkową, sportową sylwetkę i luksusowe wnętrze.</p>
  
          <p>BMW serii 5 imponuje wyglądem, zastosowanymi funkcjami, a także zużyciem paliwa. W tym modelu wynosi ono średnio 6 l/100 km.</p>
        `
      },
      {
        title: "Eleganckie i komfortowe BMW serii 5 – idealne do firmowej floty",
        text: `
          <p>BMW serii 5 to pojazd, który zwraca uwagę na drodze. Jego dynamiczna sylwetka, charakterystyczne linie oraz elegancka stylistyka wnętrza tworzą obraz auta nowoczesnego i luksusowego. Firmom, które dbają o wizerunek, takie auto pomoże budować prestiż. Klienci oraz partnerzy biznesowi z pewnością docenią klasę i elegancję tego modelu.</p>
  
          <p>Jeśli budujesz firmową flotę, weź też pod uwagę kwestie bezpieczeństwa eksploatacji auta. Nowoczesne systemy BMW serii 5 zapewniają, że każda podróż jest bezpieczna i wygodna.</p>
  
          <p>Jeśli szukasz pojazdu, który przyciągnie uwagę potencjalnych klientów i partnerów biznesowych, koniecznie postaw na BMW serii 5. To świetny wybór, zwłaszcza jeśli chcesz, by samochód reprezentował prestiż i wzmocnił pozycję Twojej marki.</p>
        `
      },
      {
        title: "Nowy model BMW Serii 5 naw mAuto",
        text: `
          <p>Dzięki leasingowi BMW serii 5 zyskujesz też wiele korzyści dostępnych w mAuto. Możesz włączyć koszt ubezpieczenia OC, AC, NWW i assistance w miesięczną ratę leasingową. To spore udogodnienie zarówno dla małych działalności, jak i dużych przedsiębiorstw.</p>
  
          <p>BMW serii 5 to samochód, który łączy w sobie wszystko, co najważniejsze dla firm – elegancję, komfort, bezpieczeństwo oraz nowoczesne technologie. To idealna opcja dla przedsiębiorców, którzy chcą inwestować w wysokiej klasy pojazdy, a przy tym ograniczyć koszty.</p>
        `
      }
    ]
  },
  VOLKSWAGEN_TAIGO: {
    MAIN_TEXT:
      "Volkswagen Taigo to nowoczesny SUV typu coupé, którego produkcja rozpoczęła się w 2021 roku. Obecnie samochód podbija serca wielu przedsiębiorców, którzy szukają połączenia kompaktowych rozmiarów, całkiem przestronnej powierzchni bagażowej i jednocześnie niskich kosztów eksploatacji.",
    ADDITIONAL_TEXTS: [
      {
        title: "Volkswagen Taigo – dane techniczne",
        text: `
          <p>Wnętrze Taigo zachwyca nowoczesnym designem, komfortem i zastosowaniem wysokiej jakości materiałów. Samochód ma również bogate wyposażenie, w tym m.in. system nawigacji satelitarnej i klimatyzację automatyczną.</p>
  
          <p>Spośród rozwiązań zastosowanych w najnowszych modelach Volkswagena Taigo warto wymienić m.in.:</p>
          <ul>
            <li>adaptacyjny tempomat (ACC),</li>
            <li>reflektory przeciwmgielne z przodu, z funkcją statycznego doświetlania zakrętów,</li>
            <li>system Front Assist z funkcją hamulca awaryjnego,</li>
            <li>asystent pasa ruchu Lane Assist,</li>
            <li>system Park Assist ułatwiający parkowanie.</li>
          </ul>
  
          <p>Jeśli szukasz auta do firmowej floty, które będzie jednocześnie oszczędne i wygodne, to Volkswagen Taigo będzie naprawdę dobrym wyborem.</p>
        `
      },
      {
        title: "Volkswagen Taigo – zużycie paliwa",
        text: `
          <p>Volkswagen Taigo 2024 oferuje różne wersje silnikowe, które wpływają na zużycie paliwa. Najpopularniejsze jednostki to 1.0 TSI (95 KM, 110 KM) oraz 1.5 TSI (150 KM). Średnie spalanie tych wersji wynosi od 5,4 do 6,1 l/100 km, w zależności od mocy silnika i skrzyni biegów.</p>
  
          <p><strong>TSI 95 KM (manual):</strong> około 5,4 l/100 km.</p>
          <p><strong>TSI 110 KM (manual lub DSG):</strong> od 5,4 l/100 km do 5,9 l/100 km.</p>
          <p><strong>1.5 TSI 150 KM (DSG):</strong> około 6,1 l/100 km.</p>
  
          <p>Wersja 150 KM ma lepsze osiągi, ale zużywa więcej paliwa. Mniejsze jednostki są bardziej oszczędne, zwłaszcza w mieście.</p>
        `
      },
      {
        title: "Kompaktowy, ale wygodny – Volkswagen Taigo dla firmy",
        text: `
          <p>Volkswagen Taigo to doskonały wybór dla rozwijających się przedsiębiorców. Niewielkie zużycie paliwa, komfort i optymalna przestrzeń bagażowa. Te cechy sprawiają, że auto sprawdzi się w krótkich podróżach po mieście. To dobry wybór także na długie trasy, np. na spotkania biznesowe za granicą.</p>
  
          <p>Volkswagen Taigo jest na tyle kompaktowy, aby z łatwością poruszać się po zatłoczonych miejskich ulicach i parkować w ciasnych przestrzeniach. Jeśli zwracasz uwagę na koszty eksploatacji firmowej floty aut, wtedy Volkswagen Taigo powinien sprostać Twoim oczekiwaniom. Silniki TSI gwarantują niskie zużycie paliwa przy zachowaniu optymalnej dynamiki jazdy.</p>
        `
      },
      {
        title: "Nowy Volkswagen Taigo z silnikiem 1.0 – idealne uzupełnienie floty przedsiębiorstwa",
        text: `
          <p>Nowy model Taigo z silnikiem 1.0 TSI to dobry wybór, jeśli zależy Ci na dobrych osiągach. Sprawdzi się także na dłuższych trasach. Nowoczesny design nadwozia w stylu coupé nadaje modelowi elegancki wygląd. Auto podkreśli także prestiż firmy podczas spotkań i wyjazdów służbowych.</p>
        `
      },
      {
        title: "Volkswagen Taigo – nowy lub poleasingowy dla Twojej firmy",
        text: `
          <p>W naszej ofercie znajdziesz Volkswagena Taigo zarówno w wersji poleasingowej, jak i fabrycznie nowe auto prosto z salonu. To ekonomiczne pojazdy, które możesz mieć przy stosunkowo niewielkich kosztach leasingowych z opcją zerowej wpłaty wstępnej. Wybierz model z oferty mAuto, a znacznie ograniczysz koszty budowy firmowej floty pojazdów.</p>
  
          <p>Dodatkowo możesz skorzystać też z szerokiego pakietu korzyści, np. ubezpieczenia OC, AC i NNW w cenie miesięcznego leasingu. To dobry sposób, aby optymalizować wydatki związane z utrzymaniem firmowej floty aut.</p>
        `
      }
    ]
  },
  BMW_X5: {
    MAIN_TEXT:
      "Szukasz eleganckiego, dużego samochodu, który sprawdzi się zarówno na dłuższych, jak i krótszych trasach? W takim razie BMW X5 dostępne w mAuto będzie dobrym wyborem. To duży SUV, który może stanowić mocne uzupełnienie firmowej floty pojazdów. Zobacz dostępne wersje BMW X5 w ofercie mAuto i wybierz dogodną formę finansowania.",
    ADDITIONAL_TEXTS: [
      {
        title: "BMW X5 – dane techniczne",
        text: `
          <p>BMW X5 to dobry wybór dla przedsiębiorców, którzy stawiają na komfort podróży i dużą przestrzeń bagażową. Ten model gwarantuje doskonałe przyśpieszenie, odczuwalną moc, a to wszystko dzięki zastosowaniu silnika 3.0 o mocy 298 KM.</p>
  
          <p>Parametry techniczne modelu BMW X5, które zachęcają do zakupu to:</p>
          <ul>
            <li>system przeciwkolizyjny,</li>
            <li>adaptacyjny tempomat,</li>
            <li>system kamer 360 stopni,</li>
            <li>automatyczna skrzynia biegów ze sportowymi łopatkami przy kierownicy,</li>
            <li>permanentny system Start/Stop.</li>
          </ul>
  
          <p>Co więcej, BMW X5 ma wydajny silnik, co przekłada się na obniżenie kosztów podróży. To luksusowe auto klasy premium idealne dla firm, które cenią nie tylko ekonomię, ale także wygląd floty.</p>
        `
      },
      {
        title: "BMW X5 – zużycie paliwa",
        text: `
          <p>Nowe BMW X5 2024, w wersji xDrive40i, oferuje imponującą wydajność paliwową, z którą wiąże się zużycie na poziomie:</p>
  
          <p><strong>Cykl miejski:</strong> około 10,1 l/100 km. W warunkach miejskich zużycie paliwa jest najwyższe z powodu większego obciążenia silnika.</p>
          <p><strong>Cykl pozamiejski:</strong> średnio 8,7 l/100 km. Podczas jazdy po autostradach i drogach szybkiego ruchu, zużycie paliwa spada dzięki bardziej stabilnym warunkom jazdy.</p>
          <p><strong>Cykl mieszany:</strong> około 9,4 l/100 km.</p>
  
          <p>Dzięki technologii mild hybrid, BMW X5 łączy moc z efektywnością. Zużywa przy tym mniej paliwa niż wcześniejsze wersje. To sprawia, że BMW to nie tylko luksusowy, ale również względnie ekonomiczny SUV w swoim segmencie cenowym.</p>
  
          <p>Co ciekawe, BMW X5 gwarantuje zasięg do 882 kilometrów na jednym tankowaniu. To możliwe dzięki zastosowaniu zbiornika paliwa o pojemności 83 litrów.</p>
        `
      },
      {
        title: "Nowe BMW X5 – auto premium dostępne od ręki",
        text: `
          <p>Nowe samochody BMW X5 możesz kupić w ofercie mAuto w ramach najmu długoterminowego. Opcjonalnie możesz też wybrać model poleasingowy, dostępny w o wiele niższej cenie niż fabrycznie nowy pojazd. Samochody BMW X5 są dostępne od ręki z szerokim pakietem korzyści dla przedsiębiorców.</p>
  
          <p>Jeśli szukasz samochodu, który będzie nienagannym uzupełnieniem firmowej floty aut, koniecznie weź pod uwagę BMW X5. Nowoczesne systemy bezpieczeństwa, luksusowe wykończenie wnętrza oraz niepodważalny komfort każdego dnia eksploatacji pojazdu. To cechy, które zachęcają wielu przedsiębiorców do przesiadki na BMW X5 klasy premium z silnikiem generującym prawie 300 koni mechanicznych.</p>
        `
      },
      {
        title: "Fabrycznie nowe BMW X5 – reprezentacyjne auto dla biznesu",
        text: `
          <p>BMW X5 to luksusowy SUV, który idealnie sprawdzi się jako reprezentacyjne auto dla biznesu. Elegancki design, nowoczesne technologie i przestronne wnętrze podkreślają prestiż marki. Zapewniają także wysoki komfort podróży. Ten model łączy zaawansowane systemy bezpieczeństwa i mocny silnik. Oferuje niezawodność i imponujące osiągi, co czyni go idealnym wyborem dla wymagających przedsiębiorców.</p>
  
          <p>Doskonałe osiągi i ekonomia – nowe BMW X5</p>
          <p>Silnik diesla o mocy 298 KM zapewnia doskonałe osiągi. Duża moc połączona z niewielkim zużyciem paliwa i wyjątkową kulturą pracy przekłada się na wysoki poziom zadowolenia użytkownika.</p>
  
          <p>Nawet intensywna eksploatacja nowego BMW X5 nie stanowi żadnego problemu. To pojemne, przestronne i funkcjonalne auto dla biznesu, które sprawdzi się zarówno w małych, jak i dużych firmach.</p>
        `
      },
      {
        title: "BMW X5 w ofercie mAuto",
        text: `
          <p>BMW X5 to połączenie wszystkiego, co najlepsze. Auta dostępne w mAuto stanowią dobry wybór dla każdego przedsiębiorcy, który szuka innowacyjności, komfortu i bezpieczeństwa w jednym samochodzie. Model X5 od BMW to konstrukcja znana od wielu lat na rynku motoryzacyjnym, która cieszy się uznaniem wśród wielu kierowców.</p>
  
          <p>Kupując BMW X5 w mAuto, zyskujesz dostęp do pakietu korzyści – w tym ubezpieczenia AC, OC i NNW.</p>
        `
      }
    ]
  },
  BMW_X2: {
    MAIN_TEXT:
      "BMW X2 to nowoczesny i stylowy SUV, który łączy sportowy charakter z eleganckim designem. Model wyróżnia dynamiczna sylwetka, masywny grill i opadająca linia dachu. Chcesz kupić nowe BMW X2 do floty swojego przedsiębiorstwa? Przejrzyj naszą ofertę i wybierz wersję dopasowaną do swoich potrzeb i preferencji.",
    ADDITIONAL_TEXTS: [
      {
        title: "BMW X2 – dane techniczne",
        text: `
          <p>Stylowa konstrukcja SUV-a BMW X2 to propozycja idealna propozycja dla przedsiębiorców. Auto z segmentu premium sprawdzi się w warunkach miejskich, na trasie, a także do transportu firmowego towaru do klienta. To biznesowy samochód, który zapewnia komfortową jazdę w każdych warunkach.</p>
  
          <p>Najważniejsze dane techniczne wyróżniające najnowsze BMW X2 to:</p>
          <ul>
            <li>ekonomiczny, ale jednocześnie wydajny silnik benzynowy,</li>
            <li>moc sięgająca do 156 koni mechanicznych,</li>
            <li>powiększony bak paliwa, który wydłuża maksymalny zasięg na jednym tankowaniu,</li>
            <li>uchwyty do fotelika dla dziecka na przednim fotelu pasażera,</li>
            <li>system monitorowania ciśnienia opon.</li>
          </ul>
        `
      },
      {
        title: "BMW X2 – zużycie paliwa",
        text: `
          <p>BMW X2 sDrive20i M-Sport z silnikiem 1.5 turbo to ekonomiczne auto, idealne do jazdy miejskiej i na długie trasy.</p>
  
          <p>Jak wygląda średnie zużycie paliwa dla nowego modelu BMW X2?</p>
          <ul>
            <li><strong>W cyklu miejskim</strong> średnie zużycie paliwa wynosi około 8,2-8,5 l/100 km.</li>
            <li><strong>W trasie</strong> spada do około 6,2-6,5 l/100 km.</li>
            <li><strong>W cyklu mieszanym</strong> to średnio 7,2-7,5 l/100 km.</li>
          </ul>
  
          <p>To połączenie sportowego charakteru i niskiego zużycia paliwa sprawia, że model jest idealny do dynamicznej jazdy.</p>
  
          <p>Jednostka silnikowa o pojemności 1.5 litra jest ekonomiczna, ale jednocześnie zapewnia doskonałe osiągi. Dzięki temu codzienna eksploatacja BMW X2 nie obciąży budżetu firmy. Niskie zużycie paliwa sprawia, że nawet intensywna jazda po mieście nie wiąże się z dużymi kosztami.</p>
        `
      },
      {
        title: "Nowe BMW X2 – do miasta i w trasę",
        text: `
          <p>Dynamiczny silnik i zaawansowana technologia skrzyni biegów zapewniają komfort oraz oszczędność paliwa podczas podróży służbowych na dłuższych dystansach. Bogate wyposażenie wnętrza z systemami multimedialnymi i nawigacją zwiększa wygodę, a elegancki design podkreśla prestiż firmy. Jeśli chcesz budować wokół przedsiębiorstwa pozytywny wizerunek, koniecznie postaw na auto klasy premium, czyli nowe BMW X2.</p>
        `
      },
      {
        title: "BMW X2 – nowe auto premium od mAuto",
        text: `
          <p>Fabrycznie nowe BMW X2 możesz od ręki kupić w mAuto. To samochód, który pozwoli Ci skupić się na prowadzeniu firmy i zawsze dowiezie Cię na spotkanie biznesowe. Najnowszy model BMW X2 jest dostępny z pakietem ubezpieczenia OC, AC i NNW, a także assistance.</p>
  
          <p>Wybierz BMW X2 i dodaj je do firmowej floty samochodów. Skorzystaj z najmu długoterminowego do 48 miesięcy, bez opłaty wstępnej i z limitem 25 tys. km rocznie. Zredukuj koszty początkowe do minimum.</p>
        `
      }
    ]
  },
  BMW_X3: {
    MAIN_TEXT:
      "BMW X3 zapoczątkowało w 2003 roku segment kompaktowych SUV-ów premium. Nowoczesny design, dynamiczne osiągi i przestronne wnętrze sprawiają, że jest idealny zarówno do miasta, jak i na dłuższe trasy. Wersje z napędem na cztery koła oferują doskonałą przyczepność. Nowoczesne technologie wspomagają kierowcę, zwiększają komfort i bezpieczeństwo. Chcesz mieć nowe BMW X3 w firmowej flocie pojazdów? Sprawdź naszą ofertę i wybierz nowy model z atrakcyjnym finansowaniem i pakietem korzyści.",
    ADDITIONAL_TEXTS: [
      {
        title: "BMW X3 – dane techniczne",
        text: `
          <p>Nowe BMW X3 to średniej wielkości SUV, który doskonale sprawdza się w firmowych flotach. Auto klasy premium wyróżnia się ponadczasowym designem, zwartą konstrukcją oraz nowoczesnymi systemami bezpieczeństwa zespolonymi z komputerem pokładowym.</p>
  
          <p>Dane techniczne, które zasługują na szczególną uwagę to:</p>
          <ul>
            <li>wydajna i ekonomiczna jednostka silnikowa typu diesel o pojemności 1998 m3,</li>
            <li>190 koni mechanicznych mocy maksymalnej,</li>
            <li>powiększony bak paliwa, który wydłuża maksymalną długość trasy na jednym tankowaniu,</li>
            <li>BMW Live Cockpit Plus z systemem nawigacyjnym,</li>
            <li>asystent jazdy półautonomicznej (asystent pasa ruchu, adaptacyjny tempomat),</li>
            <li>tapicerka wykonana z materiałów pochodzących z recyklingu.</li>
          </ul>
  
          <p>BMW X3 z rocznika 2024 to wszechstronny SUV, który łączy nowoczesne technologie, sportowe osiągi oraz luksusowe wykończenie. Jeśli szukasz auta, które dobrze się prezentuje i zapewnia komfort podczas spotkań biznesowych, wybierz BMW.</p>
        `
      },
      {
        title: "BMW X3 – zużycie paliwa",
        text: `
          <p>BMW X3 w wersjach 320d xDrive M-Sport, xDrive20d i xDrive20d mHEV jest wyposażone w nowoczesne silniki diesla o niskim spalaniu.</p>
  
          <p>Jakie jest średnie zużycie paliwa?</p>
          <ul>
            <li><strong>W mieście:</strong> około 6,5-7,0 l/100 km.</li>
            <li><strong>Na trasie:</strong> około 4,8-5,5 l/100 km.</li>
            <li><strong>W cyklu mieszanym:</strong> średnio 5,5-6,2 l/100 km.</li>
          </ul>
  
          <p>Silniki zapewniają niskie spalanie i moc 190 KM oraz moment obrotowy 400 Nm. Dzięki temu X3 umożliwia dynamiczną i komfortową jazdę w każdych warunkach.</p>
        `
      },
      {
        title: "Nowe BMW X3 – dla dużych i małych firm",
        text: `
          <p>Kultowy model BMW X3 to bardzo dobry wybór do firmowej floty zarówno dla niewielkich działalności, jak i dużych korporacji. Pojazd klasy premium prezentuje się niesamowitą linią nadwozia, a także doskonałymi osiągami przy zachowaniu ekonomii eksploatacji.</p>
  
          <p>Liczne systemy bezpieczeństwa, nowoczesny i inteligentny kokpit oraz luksusowe materiały wykończenia wnętrza powodują, że każda podróż biznesowa staje się wygodna. To dobre auto zarówno na krótkie dystanse, jak i dłuższe trasy np. międzynarodowe wyjazdy biznesowe. Postaw na BMW X3 dostępne w mAuto i ciesz się wygodą i niezawodnością.</p>
        `
      },
      {
        title: "BMW X3 – komfort i styl",
        text: `
          <p>BMW X3 to idealne rozwiązanie dla osób poszukujących komfortu. Wnętrze zaprojektowano w taki sposób, by zapewniało podróżującym maksimum przestronności i ergonomię.</p>
  
          <p>Wygodne fotele na tylnej kanapie zapewniają komfortową jazdę i przestrzeń do pracy – także w trasie. Nowe BMW X3 spełnia oczekiwania najbardziej wymagających przedsiębiorców. Oferuje wysoką jakość i wydajność. Jego design, zarówno wewnętrzny, jak i zewnętrzny, robi wrażenie.</p>
        `
      },
      {
        title: "Nowe BMW X3 w ofercie mAuto",
        text: `
          <p>W mAuto możesz kupić BMW X3 z atrakcyjnym finansowaniem w ramach najmu długoterminowego. Przy zerowej opłacie wstępnej i finansowaniu do 48 miesięcy, koszty początkowe są minimalne. W ramach finansowania możesz skorzystać też z pakietu ubezpieczenia w miesięcznej racie. Wybierz nowe BMW i zyskaj pojazd klasy premium, który pozwoli Ci w nienaganny sposób zaprezentować firmę.</p>
        `
      }
    ]
  },
  LAND_ROVER_DISCOVERY: {
    MAIN_TEXT:
      "Land Rover Discovery to kultowy model SUV produkowany od 1989 roku. Samochód słynie z doskonałych możliwości terenowych i przestronnego wnętrza. Jego zaawansowane systemy napędu 4x4 sprawiają, że świetnie sprawdza się w trudnym terenie. Chcesz wprowadzić kultowego SUV-a do floty swojego przedsiębiorstwa? Zobacz ofertę mAuto i wybierz jeden z dostępnych modeli od ręki.",
    ADDITIONAL_TEXTS: [
      {
        title: "Land Rover Discovery – dane techniczne",
        text: `
          <p>SUV Land Rover Discovery oferuje niezwykły komfort jazdy oraz bezpieczeństwo niezależnie od warunków panujących na drodze. To ponadczasowe auto wyróżnia się wydajnym silnikiem, niezawodną skrzynią biegów i charakterystyczną linią boczną.</p>
  
          <p>Najistotniejsze parametry techniczne Land Rover Discovery to:</p>
          <ul>
            <li>asystent podjazdu pod górkę,</li>
            <li>skrzynia rozdzielcza bez reduktora z mechanicznym centralnym mechanizmem różnicowym TorSen,</li>
            <li>autonomiczny hamulec awaryjny,</li>
            <li>systemy monitorujące kondycję kierowcy,</li>
            <li>asystent świateł drogowych AHBA z automatem.</li>
          </ul>
  
          <p>Jeśli szukasz naprawdę dużego auta, które będzie niezawodnym uzupełnieniem firmowej floty Twojego przedsiębiorstwa, koniecznie postaw na Land Rovera Discovery. To auto, które sprawdzi się niemalże w każdych warunkach drogowych – w zależności od potrzeb kierowcy.</p>
        `
      },
      {
        title: "Land Rover Discovery – zużycie paliwa",
        text: `
          <p>Land Rover Discovery to model oferujący szeroki wybór silników, zróżnicowanych pod względem wydajności.</p>
  
          <p><strong>Land Rover Discovery V 2.0 SD4 HSE (240 KM)</strong></p>
          <p>Ten silnik jest oszczędny, zwłaszcza na trasie. To dobry wybór dla osób szukających ekonomicznych SUV-ów z dobrymi osiągami.</p>
          <ul>
            <li>W mieście: ok. 7,8 l/100 km</li>
            <li>Na trasie: ok. 5,8 l/100 km</li>
            <li>Średnie zużycie paliwa (cykl mieszany): 6,5–6,7 l/100 km</li>
          </ul>
  
          <p><strong>Land Rover Discovery Sport 2.0 P250 mHEV HSE</strong></p>
          <p>Model z silnikiem benzynowym i mild-hybrid zużywa więcej paliwa niż diesel. Oferuje jednak lepszą dynamikę i jest ekologiczny dzięki technologii hybrydowej.</p>
          <ul>
            <li>W mieście: ok. 10,8–11,9 l/100 km</li>
            <li>Średnie zużycie paliwa (cykl mieszany): 9,6–10 l/100 km</li>
          </ul>
  
          <p><strong>Land Rover Discovery V 3.0 TD6 HSE (258 KM)</strong></p>
          <p>Silnik TD6 to większa jednostka wysokoprężna, która oferuje zrównoważone zużycie paliwa, w stosunku do mocy i pojemności.</p>
          <ul>
            <li>W mieście: ok. 9,0–10,0 l/100 km</li>
            <li>Średnie zużycie paliwa (cykl mieszany): 7,2 l/100 km</li>
          </ul>
  
          <p>Każda z tych wersji oferuje różne poziomy zużycia paliwa, zależnie stylu jazdy kierowcy, rodzaju trasy i warunków drogowych. Samochody z silnikiem diesla są bardziej ekonomiczne w trasie. Z kolei silniki benzynowe mHEV oferują lepsze osiągi w mieście przy optymalnym zużyciu paliwa.</p>
        `
      },
      {
        title: "Land Rover Discovery – duży SUV dla Twojej firmy",
        text: `
          <p>Discovery nada się do transportu towaru, sprzętu firmowego, a także materiałów marketingowych na targi. Jeśli potrzebujesz w firmie wielofunkcyjnego auta, postaw na Land Rovera. To reprezentacyjny pojazd, który może zastąpić dostawczaka. Spora przestrzeń bagażowa i dużo miejsca dla pasażerów to cechy, które sprawiają, że zakup tego modelu jest opłacalny.</p>
        `
      },
      {
        title: "Poleasingowy Land Rover Discovery – ekonomiczny i komfortowy",
        text: `
          <p>Poleasingowe auto Land Rover Discovery to świetny wybór dla przedsiębiorcy, który potrzebuje przestrzeni i oszczędności w eksploatacji.</p>
  
          <p>Samochód jest komfortowy, dynamiczny, pojemny, a przy tym wszystkim wyjątkowo oszczędny. 10 l/100 km to dobry wynik w porównaniu z innymi autami z tej kategorii. Dzięki temu nie obciążysz firmowego budżetu regularnym tankowaniem auta.</p>
        `
      },
      {
        title: "Land Rover Discovery w ofercie mAuto",
        text: `
          <p>W ofercie mAuto dostępne są modele Land Rovera w różnych wersjach wyposażenia i kolorystyce dopasowanej do różnych potrzeb. Poleasingowy Land Rover Discovery to samochód dostępny w przystępnej cenie z opcją atrakcyjnego finansowania dla przedsiębiorców.</p>
  
          <p>Wybierz leasing w mAuto i skorzystaj z oferty bez wpłaty wstępnej. Oferujemy także pakiet ubezpieczeń OC, AC, NNW i serwis za 1 zł miesięcznie.</p>
        `
      }
    ]
  },
  MERCEDES_BENZ_GLE: {
    MAIN_TEXT:
      "Mercedes GLE to doskonały wybór dla osób, które cenią sobie komfort, styl i nowoczesne technologie w motoryzacji. Jako popularny model w segmencie SUV łączy w sobie elegancki design z zaawansowanymi rozwiązaniami technicznymi. Nowy GLE sprawdzi się zarówno w miejskich warunkach, jak i podczas długich podróży.",
    ADDITIONAL_TEXTS: [
      {
        title: "Mercedes GLE – dane techniczne",
        text: `
          <p>Najnowsze modele Mercedesa GLE oferują szeroką gamę jednostek napędowych. Wśród dostępnych opcji znajdują się zarówno oszczędne silniki diesla, jak i mocne jednostki benzynowe oraz nowoczesne napędy hybrydowe.</p>
  
          <p>Wersje GLE mają moc od 245 KM (model GLE 300d) do 612 KM w wersji AMG. GLE 450 4MATIC z silnikiem 2.0 osiąga 100 km/h w 5,7 sekundy. To przykład doskonałej wydajności i mocy.</p>
  
          <p>Napęd 4MATIC zapewnia świetną trakcję i stabilność w różnych warunkach. Zwiększa to komfort i bezpieczeństwo jazdy. Mercedes GLE imponuje również swoimi wymiarami – długość 4930 mm i szerokość 2010 mm zapewniają przestronne wnętrze dla pięciu pasażerów. Bagażnik ma pojemność 630 litrów, a po złożeniu tylnej kanapy – 2055 litrów. To idealny wybór na codzienne trasy i długie wyjazdy.</p>
        `
      },
      {
        title: "Nowoczesne technologie",
        text: `
          <p>Mercedes GLE wyróżnia się także zaawansowaną technologią i luksusowym wnętrzem. System MBUX zapewnia intuicyjną obsługę przez dotykowy interfejs i asystenta głosowego. Oferuje też nawigację z rozszerzoną rzeczywistością i pełną łączność z urządzeniami mobilnymi.</p>
  
          <p>Luksusowe wnętrze, wykonane z wysokiej jakości materiałów tworzy komfortową i elegancką przestrzeń. Mercedes GLE ma też systemy wspierające kierowców: asystenta pasa ruchu, monitorowanie martwego pola i adaptacyjny tempomat. Takie rozwiązania znacząco zwiększają bezpieczeństwo. Auto jest doskonałym wyborem dla kierowców ceniących komfort i nowoczesne rozwiązania na drodze.</p>
        `
      },
      {
        title: "Mercedes GLE – zużycie paliwa",
        text: `
          <p>Nowy Mercedes GLE wyróżnia się nie tylko sportowym charakterem, ale także efektywnością paliwową. Przykładowe wartości zużycia to:</p>
  
          <p><strong>Silniki diesla:</strong> modele takie jak GLE 300d mogą osiągać średnie zużycie w cyklu mieszanym na poziomie 7-8 l/100 km. Zaawansowane systemy redukują ilość spalanego paliwa, co sprawia, że samochód jest bardziej ekonomiczny.</p>
  
          <p><strong>Silniki benzynowe:</strong> wersje benzynowe, na przykład GLE 450, prezentują zużycie w okolicach 9-10 l/100 km. Mimo większej mocy silniki te zachowują równowagę między wydajnością a komfortem jazdy.</p>
  
          <p><strong>Hybrydy:</strong> wersje hybrydowe plug-in, takie jak GLE 350 de, oferują możliwość jazdy na napędzie elektrycznym do 100 km. Przy regularnym ładowaniu zużycie może wynosić zaledwie 1,1 l/100 km. Dzięki temu GLE staje się jeszcze bardziej atrakcyjnym wyborem dla osób dbających o ekologię.</p>
        `
      },
      {
        title: "Mercedes GLE – połączenie luksusu i bezpieczeństwa",
        text: `
          <p>Mercedes GLE nie tylko zapewnia najwyższy komfort, ale wyróżnia się także innowacyjnymi technologiami, które podnoszą jakość jazdy i bezpieczeństwo. Samochód posiada zaawansowane systemy wspomagania: asystenta parkowania, ostrzeganie o zagrożeniach i aktywne hamowanie. Zwiększają one bezpieczeństwo i komfort jazdy.</p>
  
          <p>Kolejną ważną funkcją w nowym GLE jest system multimedialny MBUX. Umożliwia on zarządzanie funkcjami pojazdu za pomocą prostych poleceń głosowych. Dzięki temu kierowcy mogą bez trudu kontrolować nawigację, klimatyzację czy multimedia bez rozpraszania uwagi. Mercedes GLE obsługuje również funkcje Apple CarPlay i Android Auto.</p>
  
          <p>Dodatkową zaletą GLE jest zaawansowane zawieszenie adaptacyjne oparte na technologii AIRMATIC. System automatycznie dostosowuje je do warunków drogowych oraz stylu jazdy. Dzięki temu nie tylko zwiększa się komfort podróży, ale także bezpieczeństwo. Pojazd płynnie reaguje na zmieniające się warunki na drodze. Technologia pozwala na zachowanie stabilności w każdych warunkach.</p>
  
          <p>Mercedes GLE to model, który łączy w sobie luksus, wygodę i nowoczesne technologie. Niezależnie od wybranej wersji, każdy model zapewnia doskonałe osiągi oraz komfort. To SUV, który sprosta oczekiwaniom zarówno w codziennym użytkowaniu, jak i podczas długich podróży.</p>
  
          <p>Wybierz Mercedesa GLE i ciesz się pełnią możliwości, jakie oferuje ten znakomity model.</p>
        `
      }
    ]
  },
  FORD_TRANSIT: {
    MAIN_TEXT:
      "Ford Transit to popularny samochód dostawczy, który od lat cieszy się zaufaniem kierowców na całym świecie. Model ten łączy w sobie nowoczesny design, doskonałe właściwości jezdne i szeroką gamę zastosowań. Transit to idealny wybór dla firm, które potrzebują pojazdu o dużej ładowności, elastyczności oraz wysokiej efektywności.",
    ADDITIONAL_TEXTS: [
      {
        title: "Ford Transit – dane techniczne",
        text: `
          <p>Nowe modele Forda Transita oferują różnorodność wersji, co pozwala na dopasowanie pojazdu do specyficznych potrzeb. Kluczowe dane techniczne obejmują:</p>
  
          <p><strong>Silnik:</strong> Ford Transit jest wyposażony w motor o mocy od 130 KM do 185 KM. Dzięki technologii EcoBlue napęd charakteryzuje się wysoką efektywnością i niską emisją spalin. To dobry wybór dla firm dbających o ekologię.</p>
  
          <p><strong>Pojemność ładunkowa:</strong> model wyróżnia się imponującą pojemnością, od 8 do 15,1 m³ w zależności od wersji nadwozia. Maksymalna ładowność wynosi nawet 2000 kg, co sprawia, że jest to pojazd doskonały do transportu różnych towarów.</p>
  
          <p><strong>Wymiary:</strong> Transit dostępny jest w kilku długościach nadwozia oraz wysokościach, co umożliwia dostosowanie pojazdu do indywidualnych potrzeb. Długość auta wynosi od 4972 mm do 6054 mm, a wysokość od 1971 mm do 2776 mm. To zapewnia komfortowy dostęp do przestrzeni ładunkowej.</p>
  
          <p><strong>Systemy multimedialne:</strong> w najnowszych modelach Forda Transita zastosowano nowoczesny system SYNC 3, który umożliwia łatwe zarządzanie funkcjami multimedialnymi. Za sprawą intuicyjnego interfejsu oraz obsługi głosowej kierowcy mogą bezpiecznie korzystać z nawigacji, mediów i telefonu podczas jazdy.</p>
  
          <p><strong>Bezpieczeństwo:</strong> Forda Transit wyposażono w wiele nowoczesnych systemów bezpieczeństwa. Posiada m.in. system monitorowania ciśnienia w oponach, asystenta pasa ruchu oraz automatyczne awaryjne zatrzymanie. Dzięki nim kierowcy mogą czuć się pewnie na drodze, a ich ładunek jest bezpieczny.</p>
        `
      },
      {
        title: "Ford Transit – zużycie paliwa",
        text: `
          <p>Średnie spalanie Forda Transita z silnikiem 2.0 EcoBlue to:</p>
  
          <p><strong>Silniki diesla:</strong> w zależności od wersji i obciążenia, zużycie paliwa może wynosić od 6 do 8 l/100 km. To znacząca oszczędność w porównaniu do wielu konkurencyjnych modeli.</p>
  
          <p><strong>Ekologiczne wersje:</strong> Ford Transit dostępny jest również w wersji hybrydowej, która łączy silnik spalinowy z elektrycznym. Modele te oferują zużycie paliwa na poziomie zaledwie 4,8 l/100 km.</p>
        `
      },
      {
        title: "Wygoda i funkcjonalność",
        text: `
          <p>Ford Transit to nie tylko solidny dostawczak, ale także pojazd, który zapewnia komfort w czasie pracy. Nowoczesny zestaw wskaźników i wyświetlacz LCD zapewniają szybki dostęp do informacji o jeździe. W zależności od wersji kabina może pomieścić od 3 do 9 osób, co czyni go elastycznym rozwiązaniem dla firm transportowych. W kabinie znajduje się wiele schowków, które pozwalają na wygodne przechowywanie narzędzi czy dokumentów.</p>
        `
      },
      {
        title: "Nowoczesne technologie",
        text: `
          <p>Do przydatnych funkcji w nowych modelach Forda Transita należą:</p>
  
          <ul>
            <li>Asystent parkowania, który automatycznie wykrywa miejsca parkingowe i pomaga kierowcy.</li>
            <li>Funkcje łączności: System SYNC 3 umożliwia integrację z urządzeniami mobilnymi i oferuje dostęp z aplikacji bezpośrednio z ekranu pojazdu.</li>
            <li>Adaptacyjne zawieszenie, które dostosowuje się do obciążenia oraz warunków drogowych.</li>
          </ul>
  
          <p>Ford Transit to samochód, który łączy w sobie niezawodność, komfort i nowoczesne technologie. To sprawia, że jest idealnym wyborem dla przedsiębiorców poszukujących sprawdzonego auta dostawczego. Producent oferuje wiele możliwości dopasowania samochodu do potrzeb. Dzięki temu Ford Transit sprosta oczekiwaniom nawet najbardziej wymagających użytkowników.</p>
        `
      }
    ]
  },
  MERCEDES_BENZ_C: {
    MAIN_TEXT:
      "Mercedes C Klasa to synonim luksusu i nowoczesności w świecie samochodów osobowych. Od momentu debiutu, model ten zyskał uznanie wśród kierowców poszukujących auta łączącego elegancki design, zaawansowaną technologię i komfortową jazdę. C Klasa to doskonały wybór dla osób ceniących sobie styl oraz innowacyjne rozwiązania w codziennym użytkowaniu.",
    ADDITIONAL_TEXTS: [
      {
        title: "Mercedes C Klasa – dane techniczne",
        text: `
          <p>Najnowsza generacja Mercedesa C Klasy zachwyca swoimi osiągami oraz różnorodnością opcji wyposażenia. Oto kluczowe dane techniczne, które wyróżniają ten model:</p>
  
          <p><strong>Silniki:</strong> C Klasa oferuje silniki o różnych mocach. Napędy benzynowe mają pojemność 1,5 l do 2,0 l. Moc silników benzynowych wynosi natomiast od 156 KM do 258 KM.</p>
  
          <p><strong>Wymiary:</strong> Mercedes C Klasa ma długość wynoszącą od 4710 mm do 4750 mm w zależności od wersji nadwozia (sedan, kombi). Szerokość to 1820 mm, a wysokość 1442 mm.</p>
  
          <p><strong>Przestronność:</strong> samochód oferuje przestronne wnętrze oraz dużą przestrzeń bagażową. Pojemność bagażnika wynosi od 360 l w wersji sedan do 490 l w wersji kombi.</p>
  
          <p><strong>Systemy multimedialne:</strong> w najnowszych wersjach C Klasy zastosowano nowoczesny system MBUX. Umożliwia on intuicyjne wybór funkcji pojazdu za pomocą poleceń głosowych. Dzięki dużemu ekranowi dotykowemu, kierowcy mają łatwy dostęp do nawigacji, mediów i informacji o jeździe.</p>
  
          <p><strong>Bezpieczeństwo:</strong> Mercedes C Klasa to samochód, który stawia bezpieczeństwo na pierwszym miejscu. Auto posiada liczne systemy wspomagające kierowcę, takie jak asystent martwego pola, asystent pasa ruchu oraz system automatycznego zatrzymania. Te innowacyjne rozwiązania przyczyniają się do zwiększenia bezpieczeństwa na drodze.</p>
        `
      },
      {
        title: "Mercedes C Klasa – zużycie paliwa",
        text: `
          <p>Mercedes C Klasa wyróżnia się niskim zużyciem paliwa, co czyni go atrakcyjnym wyborem dla kierowców dbających o firmowy budżet.</p>
  
          <p><strong>Silniki benzynowe:</strong> w modelach z silnikiem benzynowym, średnia zużycia w cyklu mieszanym wynosi od 5,5 l do 7,5 l/100 km. Dla silników o niższej mocy, zużycie paliwa może wynosić nawet 5,5 l na 100 km.</p>
  
          <p><strong>Silniki diesla:</strong> wersje z silnikami wysokoprężnymi zużywają paliwo na poziomie od 4,0 l do 6,0 l/100 km.</p>
  
          <p><strong>Hybrydowe rozwiązania:</strong> Mercedes C Klasa dostępny jest również w wersji hybrydowej. Tutaj zużycie paliwa wynosi zaledwie 2,5 l na 100 km w trybie mieszanym.</p>
        `
      },
      {
        title: "Komfortowe wnętrze",
        text: `
          <p>Wnętrze Mercedesa C Klasy to połączenie elegancji, wygody oraz nowoczesnych rozwiązań technologicznych. W modelu zastosowano wysokiej jakości materiały, które wpływają na komfort podróży. Fotele oferują szerokie możliwości regulacji.</p>
  
          <p>Wnętrze C Klasy charakteryzuje się dużą dbałością o szczegóły. Każdy detal jest przemyślany – od skórzanej tapicerki po drewniane elementy i stylowe akcenty. Samochód oferuje komfortowe warunki dla pięciu osób. Użytkownicy mogą cieszyć się dużą ilością miejsca, co wpływa na wygodę podróży, szczególnie podczas dłuższych tras.</p>
  
          <p>W klasie C zastosowano innowacyjne rozwiązania, m.in. adaptacyjne reflektory LED, które automatycznie dostosowuje się do warunków jazdy. System audio Burmester oferuje wysoką jakość dźwięku, co sprawia, że każda podróż staje się prawdziwą przyjemnością.</p>
        `
      },
      {
        title: "Udogodnienia w Mercedesie C Klasy",
        text: `
          <p>Mercedes C Klasa to model, który wykorzystuje nowoczesne technologie, aby zwiększyć komfort i bezpieczeństwo jazdy. Kierowca może skorzystać m.in. z asystenta parkowania, który ułatwia jazdę w trudnych warunkach parkingowych. Inteligentny system MBUX umożliwia integrację z urządzeniami mobilnymi. W niektórych wersjach C Klasa dostępna jest technologia adaptacyjnego zawieszenia, która dostosowuje jego twardość do warunków drogowych oraz stylu jazdy.</p>
  
          <p>Mercedes C Klasa to idealny wybór dla osób, które cenią sobie luksus, komfort oraz nowoczesne technologie. Model ten doskonale sprawdzi się zarówno w codziennych dojazdach, jak i dłuższych podróżach służbowych.</p>
        `
      }
    ]
  },
  JAGUAR_F_PACE: {
    MAIN_TEXT:
      "Jaguar F-Pace to luksusowy SUV, który łączy sportowe osiągi z eleganckim stylem. Model zdobył popularność na całym świecie. Oferuje połączenie luksusu, komfortu i nowoczesnych technologii. To świetny wybór dla osób szukających pojazdu, który wyróżnia się designem i osiągami.",
    ADDITIONAL_TEXTS: [
      {
        title: "Jaguar F-Pace – dane techniczne",
        text: `
          <p>Nowe modele Jaguara F-Pace zachwycają nie tylko wyglądem, ale także parametrami technicznymi:</p>
  
          <p><strong>Silniki:</strong> F-Pace oferuje bogaty wybór jednostek napędowych, w tym zarówno silniki benzynowe, jak i diesla. Te pierwsze oferują moc od 250 KM do 550 KM w wersji SVR. Z kolei wersja diesel osiąga moc do 240 KM przy stosunkowo niskim zużyciu paliwa.</p>
  
          <p><strong>Wymiary:</strong> auto ma długość wynoszącą 4751 mm, szerokość 1936 mm i wysokość 1667 mm. Model ten oferuje zatem przestronność wnętrza oraz komfort dla pięciu pasażerów, a także znakomitą pojemność bagażnika wynoszącą 650 l.</p>
  
          <p><strong>Systemy multimedialne:</strong> Jaguar F-Pace posiada nowoczesny system inControl. Zapewnia on łatwy dostęp do funkcji pojazdu oraz aplikacji mobilnych. Duży ekran dotykowy oraz system audio premium zapewniają doskonałe wrażenia podczas jazdy.</p>
  
          <p><strong>Bezpieczeństwo:</strong> auto posiada m.in. asystenta awaryjnego zatrzymania, monitorowanie martwego pola oraz asystenta pasa ruchu. Dzięki tym rozwiązaniom podróżujący mogą czuć się bezpiecznie w każdej sytuacji.</p>
        `
      },
      {
        title: "Jaguar F-Pace – zużycie paliwa",
        text: `
          <p>Pod względem ekonomii użytkowania, Jaguar F-Pace również prezentuje się korzystnie. Średnie zużycie paliwa różni się w zależności od wybranej wersji silnikowej:</p>
  
          <p><strong>Silniki benzynowe:</strong> auto spala w cyklu mieszanym średnio od 8,5 l do 12 l/100 km. Modele o mniejszej pojemności mogą osiągnąć wyniki w okolicach 8,5 l.</p>
  
          <p><strong>Silniki diesla:</strong> wersje z silnikami wysokoprężnymi charakteryzują się lepszą efektywnością paliwową. Zużywa średnio od 5,5 l do 7,5 l/100 km. To świetny wynik, który sprawia, że F-Pace jest odpowiedni do dłuższych tras.</p>
  
          <p><strong>Hybryda:</strong> Jaguar F-Pace dostępny jest również w wersji hybrydowej, która łączy silnik benzynowy z elektrycznym. Hybryda charakteryzuje się zużyciem na poziomie 2,5 l/100 km w cyklu mieszanym.</p>
        `
      },
      {
        title: "Luksusowe wnętrze",
        text: `
          <p>Wnętrze Jaguara F-Pace to połączenie luksusu, przestronności oraz nowoczesnych rozwiązań.</p>
  
          <p>We wnętrzu zastosowano materiały najwyższej jakości, w tym skóry i naturalnego drewna. Dbałość o detale sprawia, że każdy element wnętrza jest wyjątkowy. Auto oferuje również dużo miejsca dla pasażerów. Dzięki przemyślanej konstrukcji każdy z pięciu pasażerów znajdzie miejsce na nogi oraz przestrzeń nad głową.</p>
  
          <p>Modele Jaguara F-Pace są wyposażone w nowoczesne technologie, jak adaptacyjne reflektory LED, które dostosowuje się do warunków jazdy. Zainstalowano także system audio Meridian, zapewniający doskonałe wrażenia dźwiękowe.</p>
        `
      },
      {
        title: "Sportowe osiągi",
        text: `
          <p>Za sprawą przemyślanej konstrukcji Jaguar F-Pace oferuje dynamiczne osiągi oraz doskonałe właściwości jezdne. Napęd na wszystkie koła zwiększa stabilność i kontrolę nad pojazdem w trudnych warunkach. Kierowcy mogą cieszyć się pewnością prowadzenia, niezależnie od panujących warunków atmosferycznych.</p>
  
          <p>W modelach z adaptacyjnym zawieszeniem Jaguar F-Pace automatycznie dostosowuje jego twardość do warunków drogowych oraz stylu jazdy. To sprawia, że podróż jest komfortowa zarówno na gładkich autostradach, jak i krętych drogach. Dzięki różnym trybom jazdy, kierowcy mogą dostosować parametry pojazdu do własnych preferencji. To sprawia, że model z łatwością łączy komfort z dynamicznymi osiągami.</p>
  
          <p>Jaguar F-Pace to idealny wybór dla osób poszukujących luksusowego SUV-a, który łączy elegancję z dynamicznymi osiągami. Model ten doskonale sprawdzi się zarówno w codziennych dojazdach, jak i podczas dłuższych podróży służbowych.</p>
        `
      }
    ]
  },
  MERCEDES_BENZ_GLC: {
    MAIN_TEXT:
      "Mercedes GLC to nowoczesny SUV, który łączy w sobie elegancję, komfort oraz zaawansowane technologie. Model zdobył uznanie kierowców na całym świecie dzięki swojemu wyjątkowemu stylowi oraz imponującym osiągom. To idealny wybór dla tych, którzy poszukują pojazdu z segmentu premium. Auto doskonale sprawdzi się zarówno w codziennych dojazdach, jak i podczas dłuższych podróży.",
    ADDITIONAL_TEXTS: [
      {
        title: "Mercedes GLC – dane techniczne",
        text: `
          <p>Nowe modele Mercedes GLC to synonim jakości i innowacji. Oto najważniejsze dane techniczne, które wyróżniają ten model:</p>
  
          <p><strong>Silniki:</strong> GLC dostępny jest w różnych wariantach silnikowych, w tym oszczędnych jednostkach benzynowych i diesla. Silniki benzynowe o pojemności 2.0 litra oferują od 170 KM do 258 KM. W przypadku diesla moc to średnio od 160 KM do 245 KM. W ofercie znajdują się również wersje hybrydowe.</p>
  
          <p><strong>Wymiary:</strong> model ma długość 4662 mm, szerokość 1890 mm oraz wysokość 1640 mm. Wnętrze pojazdu jest przestronne i komfortowe dla pięciu pasażerów. Bagażnik o pojemności 550 litrów oferuje wystarczającą ilość miejsca na bagaże czy większe zakupy.</p>
  
          <p><strong>Systemy multimedialne:</strong> nowoczesny system MBUX w Mercedesie GLC pozwala wygodnie sterować funkcjami pojazdu. Wysokiej jakości wyświetlacz oraz system audio to gwarancja znakomitych wrażeń z jazdy.</p>
  
          <p><strong>Bezpieczeństwo:</strong> Mercedes GLC to pojazd, który zapewnia duży poziom bezpieczeństwa. Auto posiada zaawansowane systemy, takie jak asystent hamowania, monitorowania martwego pola oraz adaptacyjny tempomat, co zwiększa komfort i bezpieczeństwo podróżujących.</p>
        `
      },
      {
        title: "Mercedes GLC – zużycie paliwa",
        text: `
          <p>Mercedes GLC oferuje nie tylko doskonałe osiągi. Średnie zużycie paliwa różni się w zależności od wybranego wariantu silnikowego:</p>
  
          <p><strong>Silniki benzynowe:</strong> średnie zużycie paliwa w cyklu mieszanym wynosi od 7,5 l do 9,5 l/100 km.</p>
  
          <p><strong>Silniki diesla:</strong> charakteryzują się lepszą efektywnością paliwową. Spalają średnio od 5,0 l do 7,0 l/100 km.</p>
  
          <p><strong>Hybrydy:</strong> hybrydowe wersje GLC oferują doskonałą efektywność. Spalają średnio zaledwie 2,5 l/100 km w cyklu mieszanym. To świetne rozwiązanie dla osób dbających o środowisko, które jednocześnie chcą cieszyć się komfortem jazdy.</p>
        `
      },
      {
        title: "Eleganckie wnętrze",
        text: `
          <p>Wnętrze Mercedesa GLC łączy luksus z nowoczesnymi rozwiązaniami, co zapewnia wyjątkowy komfort podczas każdej podróży. Każdy detal starannie zaprojektowano, a materiały użyte do wykończenia wnętrza, takie jak skóra i naturalne drewno, podkreślają wysoką jakość. Dbałość o szczegóły oraz precyzyjna obróbka sprawiają, że jazda Mercedesem GLC staje się wyjątkowym doświadczeniem. Przemyślana konstrukcja zapewnia także dużą przestronność kabiny. Auto oferuje pasażerom komfortowe warunki zarówno podczas codziennych przejazdów, jak i na długich trasach.</p>
  
          <p>Samochód wyposażono w automatyczną klimatyzację, która gwarantuje optymalne warunki w każdych warunkach pogodowych. Auto posiada także inteligentne światła, które dopasowują się do aktualnych potrzeb kierowcy. Duży ekran dotykowy systemu multimedialnego pozwala na intuicyjne zarządzanie funkcjami pojazdu. Ułatwia przy tym dostęp do nawigacji, multimediów i innych ustawień, co czyni każdą podróż jeszcze przyjemniejszą.</p>
        `
      },
      {
        title: "Dynamika jazdy",
        text: `
          <p>Mercedes GLC to SUV, który oferuje zarówno komfort, jak i dobre osiągi. Wersje Mercedesa GLC z napędem 4MATIC zapewniają doskonałą przyczepność i stabilność w każdych warunkach. Adaptacyjne podwozie dopasowuje twardość do warunków drogowych i preferencji kierowcy. Dla miłośników dynamicznej jazdy GLC oferuje różne jej tryby, w tym sportowy.</p>
  
          <p>Cechy Mercedesa GLC sprawiają, że jest jednym z najlepszych SUV-ów w swoim segmencie. Jego nowoczesny design oraz zaawansowane technologie czynią go pojazdem, który sprosta potrzebom nawet najbardziej wymagających kierowców.</p>
        `
      }
    ]
  },
  MERCEDES_BENZ_E_KLASA: {
    MAIN_TEXT:
      "Mercedes E Klasa to jedno z najbardziej rozpoznawalnych i cenionych aut w segmencie limuzyn premium. Łączy w sobie elegancki design, komfort jazdy oraz zaawansowane technologie, które sprawiają, że jazda tym modelem to czysta przyjemność. Model zdobył przychylność kierowców na całym świecie dzięki doskonałym osiągom, przestronnemu wnętrzu i licznym innowacjom.",
    ADDITIONAL_TEXTS: [
      {
        title: "Mercedes E Klasa – dane techniczne",
        text: `
          <p>Nowe modele Mercedes E Klasa to synonim jakości i niezawodności, o czym świadczą dane techniczne:</p>
  
          <p><strong>Silniki:</strong> E Klasa oferuje szeroką gamę jednostek napędowych: silniki benzynowe, diesla oraz hybrydy plug-in. Silniki benzynowe mają pojemność 2.0 litra i oferują moc od 197 KM do 367 KM. Diesel natomiast zapewnia moc od 160 KM do 286 KM.</p>
  
          <p><strong>Wymiary:</strong> E Klasa ma długość 4940 mm, szerokość 1852 mm oraz wysokość 1460 mm. Dzięki tym wymiarom, wnętrze pojazdu jest przestronne i komfortowe. Auto zapewnia wygodę dla pięciu pasażerów oraz dużą pojemność bagażnika wynoszącą 540 litrów.</p>
  
          <p><strong>Technologia multimedialna:</strong> E Klasa posiada nowoczesny system MBUX, który ułatwia dostęp do różnych funkcjo samochodu. Wysokiej jakości wyświetlacz i zaawansowany system audio zapewniają znakomite wrażenia podczas jazdy.</p>
  
          <p><strong>Bezpieczeństwo:</strong> auto zapewnia wysoki poziom bezpieczeństwa. W wyposażeniu Mercedesa są m.in. asystent parkowania, system monitorowania martwego pola oraz aktywny asystent zatrzymania.</p>
        `
      },
      {
        title: "Mercedes E Klasa – zużycie paliwa",
        text: `
          <p>Średnie zużycie paliwa Mercedes E Klasy różni się w zależności od wybranego wariantu silnikowego:</p>
  
          <p><strong>Silniki benzynowe:</strong> w cyklu mieszanym auto zużywa średnio od 7,0 l do 10,0 l/100 km.</p>
  
          <p><strong>Silniki diesla:</strong> wersje z silnikami diesla spalają średnio od 4,5 l do 6,0 l/100 km.</p>
  
          <p><strong>Hybrydy:</strong> spalają średnio 1,5 l/100 km w cyklu mieszanym.</p>
        `
      },
      {
        title: "Wnętrze E Klasy",
        text: `
          <p>Wnętrze Mercedesa E Klasy wyróżnia się elegancją dzięki skórze i naturalnemu drewnu. Starannie zaprojektowane detale sprawiają, że każda podróż jest przyjemnością. Przemyślana konstrukcja kabiny zapewnia przestronność zarówno dla pasażerów, jak i ich bagażu, co czyni auto idealnym wyborem na dłuższe trasy. E Klasa posiada automatyczną klimatyzację, inteligentne światła i system multimedialny z dużym ekranem dotykowym. To zwiększa wygodę użytkowników i pozwala intuicyjnie zarządzać funkcjami pojazdu.</p>
        `
      },
      {
        title: "Dynamika jazdy",
        text: `
          <p>Wersje z napędem 4MATIC zapewniają doskonałą przyczepność i stabilność, co sprawia, że prowadzenie pojazdu jest czystą przyjemnością. Z kolei adaptacyjne podwozie pozwala dostosować twardość do aktualnych warunków drogowych i preferencji. Kierowcy mogą wybierać różne tryby jazdy. Tryb sportowy zapewnia szybszą reakcję na gaz i dodaje sportowego charakteru trasie.</p>
        `
      }
    ]
  },
  AUDI_A3: {
    MAIN_TEXT:
      "Potrzebujesz wygodnego i stylowego samochodu do wzbogacenia firmowej floty? Koniecznie zastanów się nad wyborem jednego z modeli Audi A3. To samochód klasy premium od lat cieszy się uznaniem kierowców na całym świecie.",
    ADDITIONAL_TEXTS: [
      {
        title: "Audi A3 – prestiż i niezawodność dla Twojej firmy",
        text: `
          <p>Audi A3 łączy w sobie dynamiczny design, zaawansowane technologie oraz wysoki komfort podróżowania. Dla klienta biznesowego to przede wszystkim gwarancja niezawodności, która minimalizuje ryzyko nieprzewidzianych przestojów, oraz prestiżowy wizerunek, który pozytywnie wpływa na postrzeganie firmy.</p>
  
          <p>Co więcej, nowoczesne jednostki napędowe zapewniają optymalne koszty eksploatacji. W ofercie mAuto.pl znajdziesz modele Audi A3 z najnowszych roczników w różnorodnych wersjach wyposażenia. Dzięki temu idealnie dopasujesz samochód do indywidualnych potrzeb i specyfiki działalności przedsiębiorstwa.</p>
        `
      },
      {
        title: "Audi A3 – dane techniczne",
        text: `
          <p>Modele Audi A3 łączą w sobie sportowy charakter z elegancją, co czyni je doskonałym wyborem zarówno jako dynamiczne auto miejskie, jak i komfortowy pojazd na dłuższe trasy służbowe. Jako reprezentant segmentu premium, Audi wyróżnia się najwyższą jakością wykonania, dbałością o detale oraz zastosowaniem innowacyjnych rozwiązań podnoszących bezpieczeństwo i komfort użytkowania.</p>
  
          <p>Wśród kluczowych elementów wyposażenia, które wyróżniają Audi A3 są:</p>
          <ul>
            <li>dynamiczne jednostki napędowe – dostępne w wersji z silnikiem benzynowym (TFSI) o mocy 150 KM;</li>
            <li>zaawansowane systemy bezpieczeństwa – modele wyposażone są m.in. w system omijania przeszkód i parkowania, asystent skrętu i system monitorowania martwego pola;</li>
            <li>nowoczesne oświetlenie – reflektory w technologii LED oraz tylne światła z dynamicznymi kierunkowskazami z tyłu;</li>
            <li>komfort i wygoda na najwyższym poziomie – 3-strefowa klimatyzacja, elektrycznie sterowane szyby i lusterka, podłokietnik środkowy;</li>
            <li>intuicyjny system multimedialny – 6 głośników, złącza USB z funkcją ładowania w tylnej części kabiny.</li>
          </ul>
  
          <p>To tylko niektóre z najważniejszych rozwiązań dostępnych w modelach Audi. Oszczędność, ponadczasowa stylistyka i niezawodność to cechy zachęcające do włączenia takiego samochodu do floty swojego przedsiębiorstwa, podnosząc zarówno efektywność operacyjną, jak i prestiż marki.</p>
        `
      },
      {
        title: "Audi A3 – spalanie",
        text: `
          <p>Jednym z kluczowych czynników branych pod uwagę przy wyborze samochodów do floty firmowej są koszty eksploatacji, a w szczególności zużycie paliwa. Dzięki zastosowaniu nowoczesnych technologii i efektywnych jednostek napędowych, modele Audi prezentują się pod tym względem bardzo korzystnie.</p>
  
          <p>Wartości zużycia paliwa prezentują się następująco:</p>
          <ul>
            <li>spalanie w cyklu miejskim: 7 l/100 km,</li>
            <li>spalanie w cyklu pozamiejskim: 4,7 l/100 km,</li>
            <li>spalanie w cyklu mieszanym: 5,5 l/100 km.</li>
          </ul>
  
          <p>Co więcej, emisja CO₂ na poziomie 126 g/km świadczy o relatywnie niewielkim wpływie na środowisko, co jest coraz istotniejszym aspektem dla nowoczesnych przedsiębiorstw. Wybór takiego samochodu pozwala na efektywne zarządzanie kosztami transportu oraz budowanie wizerunku firmy odpowiedzialnej ekologicznie, bez kompromisów w zakresie dynamiki czy komfortu jazdy.</p>
        `
      },
      {
        title: "Audi A3 w ofercie mAuto",
        text: `
          <p>Zastanawiasz się nad wyborem jednej z dostępnych wersji Audi? Chcesz wzbogacić flotę swojej firmy o pojazd, który łączy prestiż z efektywnością?</p>
  
          <p>W ofercie mAuto.pl znajdziesz szeroki wybór nowych modeli Audi A3. Rozumiemy potrzeby klientów biznesowych, dlatego oferujemy atrakcyjne formy finansowania – leasing oraz najem długoterminowy. Dzięki elastycznej ofercie możesz samodzielnie określić czas trwania umowy, wysokość opłaty wstępnej (może być nawet 0% wartości pojazdu) oraz skorzystać z dodatkowych udogodnień.</p>
  
          <p>W ramach współpracy oferujemy również szeroki pakiet usług dodatkowych, w tym pełen pakiet ubezpieczeń OC, AC i NNW, możliwość skorzystania z karty paliwowej oraz profesjonalną opiekę serwisową. Wybierz formę finansowania dopasowaną do potrzeb Twojego przedsiębiorstwa i zdecyduj się na Audi A3. To idealne uzupełnienie firmowej floty aut osobowych, które podkreśli profesjonalizm i nowoczesność Twojej działalności.</p>
        `
      }
    ]
  },
  BMW_X1: {
    MAIN_TEXT:
      "Twoja firma potrzebuje wszechstronnego, solidnego i reprezentacyjnego auta? Sprawdź modele BMW X1. To ceniony SUV z segmentu premium, który łączy sportowy styl z elegancją i zaawansowanymi funkcjami. Taki samochód podkreśli profesjonalny wizerunek Twojego przedsiębiorstwa.",
    ADDITIONAL_TEXTS: [
      {
        title: "Nowoczesne i wszechstronne BMW X1",
        text: `
          <p>BMW od lat cieszy się pozycją prestiżowej i chętnie wybieranej marki wśród przedsiębiorców, a model X1 jest tego doskonałym przykładem. Jego dynamiczna, a zarazem ponadczasowa sylwetka zwraca uwagę i podkreśla status kierowcy.</p>
  
          <p>Funkcjonalne i stylowe SUV-y coraz częściej zastępują tradycyjne luksusowe sedany w firmowych flotach. Przemawia za tym ich wszechstronność – doskonale sprawdzają się jako komfortowe i reprezentacyjne samochody dla kadry zarządzającej, oferując przy tym znaczną przestrzeń bagażową, nieocenioną przy wielu zadaniach służbowych.</p>
  
          <p>W ofercie mAuto.pl znajdziesz najnowsze modele BMW X1 z rocznika 2025 w bogatej wersji wyposażeniowych. Wybierz pojazd dopasowany do potrzeb i profilu działalności, przy wsparciu atrakcyjnych rozwiązań finansowych, takich jak leasing oraz najem długoterminowy.</p>
        `
      },
      {
        title: "BMW X1 – dane techniczne",
        text: `
          <p>Najnowsze modele BMW X1 to doskonały wybór jako wszechstronny pojazd służbowy. Auta łączą w sobie precyzję prowadzenia z funkcjonalnością i przestronnością SUV-a. Samochody niemieckiego producenta wyróżniają się jakością wykonania, dbałością o każdy detal oraz zastosowaniem innowacyjnych rozwiązań technologicznych. Dynamiczna linia nadwozia nadaje mu wyrazisty i nowoczesny charakter.</p>
  
          <p>BMW X1 wyposażono m.in. w:</p>
          <ul>
            <li>oszczędny silnik benzynowy 1.5l (136 KM) z automatyczną skrzynią biegów;</li>
            <li>pakiet sportowy M: zawieszenie adaptacyjne, sportowe fotele (ogrzewane);</li>
            <li>systemy asystujące kierowcy, asystent parkowania z kamerą, adaptacyjne reflektory LED;</li>
            <li>przyciemniane szyby, deska rozdzielcza Luxury;</li>
            <li>multimedia: radio DAB+, personal eSIM, interfejs ładowania bezprzewodowego;</li>
            <li>alarm, system monitorowania ciśnienia opon, zestaw naprawczy;</li>
            <li>ekskluzywne wykończenie: tapicerka M Alcantara/Veganza, listwy czarne, podsufitka M Anthracite.</li>
          </ul>
  
          <p>Połączenie sportowego zacięcia, elegancji, nowoczesnych technologii i niezawodności czyni BMW X1 doskonałym wyborem dla firm, które cenią sobie zarówno prestiż, jak i efektywność.</p>
        `
      },
      {
        title: "BMW X1 – spalanie",
        text: `
          <p>Koszty eksploatacji są kluczowym elementem przy wyborze floty firmowej, a zużycie paliwa odgrywa tu znaczącą rolę. Model BMW X1 został zaprojektowany z myślą o optymalnym połączeniu dynamiki i efektywności.</p>
  
          <p>Według danych producenta BMW X1 charakteryzuje się następującym zużyciem paliwa:</p>
          <ul>
            <li>spalanie w cyklu mieszanym: ok. 6,3 - 7,0 l/100 km,</li>
            <li>emisja CO₂ w cyklu mieszanym: ok. 143 - 158 g/km.</li>
          </ul>
  
          <p>Takie wartości zużycia paliwa są konkurencyjne w segmencie kompaktowych SUV-ów premium. To oznacza rozsądne koszty operacyjne, szczególnie przy regularnej eksploatacji pojazdów w firmie. Wybierając BMW X1 do swojej floty, zyskujesz pewność, że koszty paliwa będą utrzymane na racjonalnym poziomie, bez rezygnacji z komfortu i osiągów charakterystycznych dla marki BMW.</p>
        `
      },
      {
        title: "Modele BMW X1 w ofercie mAuto",
        text: `
          <p>Szukasz dynamicznego i prestiżowego SUV-a do wyposażenia firmowej floty? BMW X1 dostępne w ofercie mAuto.pl to doskonały wybór, który spełni oczekiwania nawet najbardziej wymagających klientów biznesowych. W ofercie dostępne są fabrycznie nowe modele z rocznika 2025.</p>
  
          <p>W mAuto oferujemy elastyczne i atrakcyjne formy finansowania – leasing i najem długoterminowy. Nasi doradcy pomogą Ci wybrać najkorzystniejsze rozwiązanie, dopasowane do możliwości i strategii Twojego przedsiębiorstwa.</p>
  
          <p>Decydując się na współpracę, zyskujesz nie tylko nowy samochód, ale również kompleksową obsługę. Oferujemy pełen pakiet ubezpieczeń OC, AC i NNW, wsparcie w zarządzaniu serwisem pojazdów oraz możliwość skorzystania z karty paliwowej.</p>
  
          <p>Skontaktuj się z nami już dziś, aby poznać szczegóły.</p>
        `
      }
    ]
  },
  OPEL_INSIGNIA: {
    MAIN_TEXT:
      "Szukasz dla swojej firmy samochodu, który skutecznie łączy elegancki wygląd z praktyczną wszechstronnością na co dzień? Poznaj bliżej Opla Insignia. Ten model to doskonały wybór dla przedsiębiorców oczekujących reprezentacyjnej estetyki bliskiej klasie premium oraz funkcjonalności niezbędnej do sprostania dynamice współczesnego biznesu.",
    ADDITIONAL_TEXTS: [
      {
        title: "Opel Insignia – stworzony dla biznesu",
        text: `
          <p>Opel Insignia od lat potwierdza swoją silną pozycję jako samochód chętnie wybierany przez przedsiębiorców. Jego odświeżona, elegancka sylwetka skutecznie przyciąga wzrok i buduje profesjonalny wizerunek, subtelnie nawiązując do estetyki segmentu premium.</p>
  
          <p>W wymagającym środowisku biznesowym prezentuje się jako wyjątkowo atrakcyjna propozycja. Te auta oferują szerokie spektrum zastosowań: od komfortowego i prestiżowego środka transportu dla kadry kierowniczej, po niezawodne narzędzie pracy z obszerną przestrzenią bagażową w wariancie kombi.</p>
  
          <p>W ofercie mAuto.pl znajdziesz starannie wyselekcjonowane modele Opla, gotowe sprostać oczekiwaniom Twojej działalności. Wybierz samochód w preferowanej wersji nadwozia z bogatym wyposażeniem, korzystając przy tym ze wsparcia naszych atrakcyjnych rozwiązań finansowych. Dołącz do grona zadowolonych posiadaczy Opla Insignia.</p>
        `
      },
      {
        title: "Opel Insignia – dane techniczne",
        text: `
          <p>Każda kolejna seria modelu Opel Insignia została zaprojektowana z myślą o zapewnieniu kierowcy i pasażerom maksymalnego komfortu oraz bezpieczeństwa. Modele z roczników 2021-22 oferują niezawodność i wydajność – kluczowe aspekty dla każdego przedsiębiorstwa. Samochody Opel Insignia charakteryzują się nie tylko dynamiczną linią nadwozia, ale również przemyślanym wnętrzem i szeregiem systemów wspierających kierowcę.</p>
  
          <p>Wyposażenie Opla Insignia oferuje m.in.:</p>
          <ul>
            <li>mocny i oszczędny silnik 2.0 CDTI z systemem Start & Stop dla optymalnych kosztów;</li>
            <li>zaawansowane systemy bezpieczeństwa: ESP, asystent pasa ruchu, ostrzeganie przed kolizją i pieszymi;</li>
            <li>nowoczesne reflektory LED z asystentem świateł drogowych oraz automatycznym włączaniem świateł;</li>
            <li>komfort premium: fotel kierowcy AGR, sportowe fotele, klimatyzacja dwustrefowa, skórzana kierownica;</li>
            <li>system Multimedia Navi Pro, cyfrowe zegary, 7 głośników;</li>
            <li>praktyczne wsparcie: czujniki parkowania (przód/tył), elektryczny hamulec postojowy, czujnik deszczu;</li>
            <li>funkcjonalność biznesową: składany hak holowniczy, punkty montażu siatki bagażowej.</li>
          </ul>
  
          <p>Takie wyposażenie sprawia, że Opel Insignia jest nie tylko reprezentacyjnym, ale również wyjątkowo funkcjonalnym i bezpiecznym samochodem, idealnie dopasowanym do wymagań firmowej floty.</p>
        `
      },
      {
        title: "Opel Insignia – spalanie",
        text: `
          <p>Jednym z kluczowych czynników branych pod uwagę przy wyborze samochodu do floty firmowej jest jego ekonomiczność.</p>
  
          <p>Opel Insignia z silnikiem 2.0 CDTI o mocy 174 KM, mimo swoich dynamicznych osiągów i komfortowych rozmiarów, charakteryzuje się rozsądnym zapotrzebowaniem na paliwo. Według danych producenta średnie spalanie dla tej jednostki napędowej w cyklu mieszanym może kształtować się na poziomie około 5-6 litrów na 100 kilometrów. Taki wynik, w połączeniu z dużą pojemnością zbiornika paliwa, przekłada się na imponujący zasięg. Dla przedsiębiorstwa oznacza to realne oszczędności w kosztach eksploatacji, szczególnie przy intensywnym użytkowaniu pojazdów przez pracowników. Niskie spalanie Opla Insignia to dowód na to, że można pogodzić dynamikę jazdy z dbałością o firmowy budżet.</p>
        `
      },
      {
        title: "Opel Insignia w ofercie mAuto",
        text: `
          <p>Decyzja o włączeniu modelu Opel Insignia do firmowej floty to strategiczny wybór, który przyniesie Twojemu przedsiębiorstwu wymierne korzyści. Oferujemy nie tylko dostęp do sprawdzonych, poleasingowych egzemplarzy tego wszechstronnego samochodu, ale również pełne wsparcie na każdym etapie procesu zakupowego.</p>
  
          <p>Każda Opel Insignia w naszej ofercie to pojazd z udokumentowaną historią serwisową i przebiegiem, co gwarantuje transparentność i bezpieczeństwo transakcji. Dodatkowo, nasi klienci mogą liczyć na pakiety usług dodatkowych, w tym ubezpieczenie czy opiekę serwisową, co czyni eksploatację wybranych samochodów jeszcze bardziej komfortową i przewidywalną. Zapraszamy do zapoznania się ze szczegółami naszej oferty na modele Opel Insignia – to doskonała inwestycja w mobilność i wizerunek Twojej firmy.</p>
        `
      }
    ]
  },
  VOLVO_V60: {
    MAIN_TEXT:
      "Szukasz samochodu, który łączy w sobie komfort, elegancję i wszechstronność? Sprawdź modele Volvo V60. To samochód z segmentu premium, który łączy sportowy styl z elegancją. Takie auto podkreśli profesjonalny wizerunek Twojego przedsiębiorstwa i zapewni komfort oraz bezpieczeństwo na najwyższym poziomie.",
    ADDITIONAL_TEXTS: [
      {
        title: "Volvo V60 - szwedzka legenda w nowej odsłonie",
        text: `
          <p>Volvo od lat cieszy się ugruntowaną pozycją prestiżowej i chętnie wybieranej marki wśród przedsiębiorców na całym świecie, a model Volvo V60 jest tego doskonałym przykładem. Jego dynamiczna, a zarazem ponadczasowa sylwetka, typowa dla skandynawskiego designu, zwraca uwagę i dyskretnie podkreśla status kierowcy. To eleganckie samochody, które przywołują skojarzenia z bezpieczeństwem, solidnością i luksusem.</p>
  
          <p>Funkcjonalne i stylowe nadwozie typu kombi oferuje szerokie spektrum zastosowań w firmie. Doskonale sprawdzi się zarówno jako komfortowy i reprezentacyjny środek transportu dla kadry zarządzającej, jak i niezawodny pojazd do przewozu firmowego sprzętu czy materiałów. Wybór Volvo V60 to inwestycja w prestiż i rozpoznawalność marki, co z pewnością wpłynie na pozytywne uznanie wśród partnerów biznesowych.</p>
        `
      },
      {
        title: "Volvo V60 – dane techniczne",
        text: `
          <p>W ofercie mAuto.pl znajdziesz starannie wyselekcjonowane, poleasingowe modele Volvo V60 z roczników 2020-2021. Wybierz pojazd idealnie dopasowany do potrzeb i profilu Twojej działalności, korzystając przy tym ze wsparcia naszych doradców oraz atrakcyjnych rozwiązań finansowych.</p>
  
          <p>Volvo V60 z roczników 2020-2021 wyposażono m.in. w:</p>
          <ul>
            <li>wydajne silniki z automatyczną skrzynią biegów;</li>
            <li>zaawansowane systemy bezpieczeństwa Volvo: City Safety, system utrzymania pasa ruchu, Driver Alert;</li>
            <li>komfortowe wnętrze z klimatyzacją 2-strefowa, fotele z reg. lędźwiową, elektryczną klapą bagażnika;</li>
            <li>funkcjonalne wyposażenie: reflektory LED, relingi dachowe, skórzana kierownica;</li>
            <li>wsparcie kierowcy: czujniki parkowania, Auto Hold, siatka bagażowa, składane zagłówki;</li>
            <li>dodatkowe udogodnienia: tempomat, system nawigacji Sensus, Volvo On Call.</li>
          </ul>
  
          <p>Połączenie bezpieczeństwa, eleganckiego designu, nowoczesnych technologii i niezawodności czyni Volvo V60 doskonałym wyborem dla firm, które cenią sobie zarówno prestiż i komfort, jak i efektywność oraz niskie koszty utrzymania.</p>
        `
      },
      {
        title: "Volvo V60 – spalanie",
        text: `
          <p>Podczas poszukiwania firmowego auta jednym z kluczowych aspektów branych pod uwagę jest zużycie paliwa. W przypadku Volvo V60 prezentuje się ono następująco:</p>
  
          <ul>
            <li>dla wersji z silnikiem diesla średnie spalanie w cyklu mieszanym może kształtować się na poziomie od ok. 5,5 do 6,5 l/100 km;</li>
            <li>dla wersji z silnikiem benzynowym średnie spalanie w cyklu mieszanym wynosi zazwyczaj od ok. 6,5 do 7,5 l/100 km.</li>
          </ul>
  
          <p>Wybierając Volvo V60 do swojej floty, zyskujesz pewność, że koszty paliwa będą utrzymane na racjonalnym poziomie, co w połączeniu z wysoką niezawodnością przekłada się na korzystny całkowity koszt inwestycji.</p>
        `
      },
      {
        title: "Sprawdź ofertę Volvo V60 w mAuto",
        text: `
          <p>Dlaczego warto wybrać jeden z modeli Volvo V60 dostępnych w ofercie mAuto? Każdy oferowany egzemplarz jest starannie sprawdzany, aby zapewnić Państwu pewność i satysfakcję z zakupu.</p>
  
          <p>Specjalizujemy się w obsłudze klientów firmowych, dlatego proponujemy elastyczne i atrakcyjne formy finansowania. Nasi doświadczeni doradcy pomogą Ci wybrać najkorzystniejsze rozwiązanie, idealnie dopasowane do możliwości finansowych i strategii rozwoju Twojego przedsiębiorstwa.</p>
  
          <p>Decydując się na współpracę z mAuto, zyskujesz nie tylko sprawdzony samochód, ale również kompleksową obsługę posprzedażową. Oferujemy pełen pakiet ubezpieczeń OC, AC i NNW, wsparcie w zarządzaniu serwisem pojazdów oraz możliwość skorzystania z kart paliwowych, co dodatkowo ułatwia zarządzanie flotą.</p>
  
          <p>Skontaktuj się z nami już dziś, aby poznać szczegóły dostępnych egzemplarzy i wybrać samochód, który będzie niezawodnie służyć Twojej firmie.</p>
        `
      }
    ]
  },
  NEW_VOLVO_XC40: {
    MAIN_TEXT:
      "Volvo od dekad jest symbolem bezpieczeństwa, skandynawskiego designu i innowacji. Nie inaczej jest w przypadku nowego modelu Volvo XC40. To kompaktowy i stylowy SUV, który sprawdzi się w każdych warunkach. Zobacz, jakie innowacyjne rozwiązanie znajdziesz w tym samochodzie. Poznaj ofertę mAuto i wybierz fabrycznie nowe Volvo XC40 dla swojej firmy.",
    ADDITIONAL_TEXTS: [
      {
        title: "Zupełnie nowe samochody Volvo XC40 w ofercie mAuto",
        text: `
          <p>Nowy samochód Volvo XC40 kwintesencja szwedzkiej precyzji i wytrzymałości. Ten wszechstronny miejski SUV jest dostępny z korzystnym finansowaniem na zasadach leasingu lub najmu długoterminowego. Wybierz nowe Volvo XC40 z silnikiem B3 Core z atrakcyjną ratą.</p>
          <p>Fabrycznie nowy pojazd szwedzkiego producenta gwarantuje przestronne wnętrze, wygodne fotele oraz sporo miejsca na bagaże. Sprawdzi się w firmowej flocie jako samochód na dłuższe trasy biznesowe. Nowe samochody Volvo XC40 stanowią kompromis między komfortem, bezpieczeństwem i dostępem do ciekawych rozwiązań technologicznych.</p>
        `
      },
      {
        title: "Pojemny, ale zgrabny – Twój nowy samochód Volvo XC40",
        text: `
          <p>Nowe samochody Volvo XC40 to kompaktowe miejskie SUV-y, które umilą każdą biznesową podróż. Eleganckie i przyjemne w dotyku wykończenie wnętrza i sporo miejsca zarówno dla kierowcy, jak i pasażerów to gwarancja udanej podróży.</p>
          <p>Standardowe wyposażenie nowego Volvo XC40 to pakiet czujników deszczu, wilgotności powietrza, a także przyciemniane tylne szyby. W ramach pakietów rozszerzeń możesz wybrać wersję samochodu z asystentem parkowania. W wyposażeniu dostępne są również podgrzewane siedzenia i kierownica. Możesz także skorzystać z przedłużonej gwarancji do 200 tys. kilometrów przebiegu.</p>
        `
      },
      {
        title: "Fabrycznie nowe Volvo XC40 – auto premium do firmowej floty",
        text: `
          <p>Volvo XC40 to dobry wybór jako uzupełnienie samochodowej floty przedsiębiorstwa. Niezależnie od tego, czy prowadzisz małą, czy dużą firmę, nowoczesny i wszechstronny SUV prosto z salonu prawdopodobnie sprosta Twoim oczekiwaniom. Fabrycznie nowy pojazd dostępny od ręki pozwoli Ci rozwijać przedsiębiorstwo i wygodnie dojeżdżać do kontrahentów biznesowych.</p>
          <p>Kompaktowy SUV klasy premium stanowi dobry wybór, jeśli cenisz sobie wygodę, bezpieczeństwo i reprezentatywny wygląd pojazdu.</p>
        `
      },
      {
        title: "Nowe Volvo XC40 z szerokim pakietem korzyści dla przedsiębiorców",
        text: `
          <p>Zdecyduj się na nowe samochody Volvo XC40 z naszej oferty, a skorzystasz z licznych udogodnień dla firm. Możesz wybrać atrakcyjny pakiet ubezpieczenia OC, AC i assistance, wsparcie koordynacji serwisu, a także kartę paliwową ułatwiającą tankowanie.</p>
        `
      }
    ]
  },
  NEW_AUDI_Q5: {
    MAIN_TEXT:
      "Audi Q5 to jeden mocno rozpoznawalnych modeli niemieckiego producenta. Słynie z nowoczesnych rozwiązań technologicznych oraz dbałości o szczegóły. Nowe Audi Q5 słynie z eleganckiego i przemyślanego designu. Wpisuje się w wartości kierowców doceniających luksus, wysoką jakość i inteligentne systemy bezpieczeństwa. Wybierz nowe Audi Q5 z oferty mAuto do swojego przedsiębiorstwa. Odkryj samochód, który stanie się Twoim biznesowym towarzyszem na długi czas.",
    ADDITIONAL_TEXTS: [
      {
        title: "Nowy samochód Audi Q5 prosto z fabryki – dla wymagających przedsiębiorców",
        text: `
          <p>Audi Q5 to samochód, który zdobył uznanie wśród najbardziej wymagających przedsiębiorców. Stanowi doskonały wybór dla tych, którzy szukają pojazdu łączącego w sobie elegancję, komfort i zaawansowaną technologię. Nowy model Audi Q5 zachwyca dbałością o szczegóły i solidną konstrukcją. Doskonale sprawdza się zarówno jako reprezentacyjne auto firmowe, jak i komfortowy towarzysz dłuższych podróży służbowych.</p>
        `
      },
      {
        title: "Eleganckie i przestronne nowe modele Audi Q5 dostępne w mAuto",
        text: `
          <p>Propozycja mAuto to fabrycznie nowe Audi Q5. Ten SUV świetnie sprawdzi się zarówno w miejskiej dżungli, jak i podczas jazdy w dłuższe trasy. Przestronna przestrzeń bagażowa, sporo miejsca za kierownicą oraz wygodne fotele dla pasażerów na tylnej kanapie. Te cechy sprawiają, że nowe Audi Q5 jest praktyczne nie tylko w firmach, ale i w gospodarstwach domowych.</p>
          <p>W mAuto możesz wybrać nowe Audi Q5 z atrakcyjnym finansowaniem dla firm w ramach najmu długoterminowego lub leasingu. Zyskaj dostęp do samochodu klasy premium z gwarancją niskiej miesięcznej opłaty.</p>
        `
      },
      {
        title: "Nowe Audi Q5 – auto premium do firmowej floty",
        text: `
          <p>Standardowe wyposażenie nowych samochodów Audi Q5 potrafi przyciągnąć uwagę niemalże każdego. Eleganckie, matowe dekoracje wnętrza, nowoczesny system audio oraz termoizolacyjne szyby to tylko niektóre opcje z podstawowego wyposażenia. W ramach rozszerzeń możesz wybrać nowy model Audi Q5 z pakietem Comfort (podgrzewane siedzenia z przodu), kamerą ułatwiającą parkowanie i klimatyzacją 3-strefową.</p>
        `
      },
      {
        title: "Nowe samochody Audi Q5 z pakietem korzyści dla firm",
        text: `
          <p>W ramach oferty mAuto możesz skorzystać także z dostępu do pełnego ubezpieczenia OC, AC, NNW i assistance. Dodatkowo wybierzesz jeden z dwóch dostępnych pakietów serwisowych i opcjonalnej karty paliwowej. Z takim pakietem nowe samochody Audi Q5 stają się niezawodną podstawą w firmowej flocie samochodów.</p>
        `
      }
    ]
  },
  NEW_BMW_X2: {
    MAIN_TEXT:
      "Nowe modele BMW X2 to nowoczesne, komfortowe i przestronne pojazdy. Szukasz samochodu do firmy, który zapewni komfort jazdy i bezpieczeństwo zarówno w mieście, jak i na dłuższych trasach? Postaw na nowe samochody BMW X2 dostępne w mAuto. Wybierz wersję dopasowaną do potrzeb swojego przedsiębiorstwa i skorzystaj z atrakcyjnego finansowania.",
    ADDITIONAL_TEXTS: [
      {
        title: "Nowoczesne nowe samochody BMW X2 w ofercie mAuto",
        text: `
          <p>Nowe BMW X2 to samochody klasy premium, które mogą stanowić podstawę dla firmowej floty pojazdów. Ten model jest połączeniem kompaktowych gabarytów, wydajnej jednostki napędowej oraz doskonałego wyposażenia w standardzie. Postaw na odświeżoną wersję luksusowego samochodu i spraw, że każda biznesowa podróż będzie wyjątkowa. Nowy model BMW X2 zachwyca wszechstronnością i ponadczasową linią boczną. To reprezentatywne auto dla małych i dużych przedsiębiorców.</p>
        `
      },
      {
        title: "Bogate wyposażenie w standardzie w nowych samochodach BMW X2",
        text: `
          <p>Podstawowe wyposażenie nowych samochodów BMW X2 obejmuje pełny teleserwis i cyfrowe radio. W pakiecie są też asystent parkowania z kamerą wsteczną oraz system monitorowania ciśnienia opon. Takie udogodnienia wpływają na komfort użytkowania auta i jednocześnie sprawiają, że pojazd pozostaje w pełni bezpiecznym środkiem lokomocji.</p>
          <p>W ramach dodatkowego wyposażenia dostępna jest opcja rezygnacji z emblematu modelowego. Można również wybrać ogrzewaną kierownicę oraz pakiet sportowy M, idealny dla miłośników intensywnej jazdy.</p>
        `
      },
      {
        title: "Nowe auta BMW X2 – połączenie luksusu, bezpieczeństwa i innowacyjności",
        text: `
          <p>Fabrycznie nowe BMW X2 to model samochodu, który zdobywa serca kierowców poszukujących idealnej równowagi między elegancją a sportowym charakterem. Nowoczesny design i doskonałe osiągi czynią go doskonałym wyborem. Luksus i niezawodność. To samochód, który wyróżnia się na drodze, nie tylko pod względem wyglądu, ale również dzięki zaawansowanym technologiom i systemom bezpieczeństwa. Sprawdza się zarówno w codziennym użytkowaniu, jak i w dłuższych podróżach biznesowych.</p>
        `
      },
      {
        title: "Nowe samochody BMW X2 klasy premium – dla wymagających przedsiębiorców",
        text: `
          <p>Nowy samochód BMW X2 ma wnętrze zaprojektowane z myślą o komforcie kierowcy i pasażerów. Nowe BMW X2 wyróżnia się wysokiej jakości materiałami wykończeniowymi i dbałością o każdy detal. Ergonomiczny układ kokpitu sprawia, że jazda jest prawdziwą przyjemnością. Zaawansowane systemy wspierają kierowcę a nowoczesne funkcje, podnoszą komfort jazdy i poczucie bezpieczeństwa.</p>
        `
      }
    ]
  },
  NEW_BMW_3: {
    MAIN_TEXT:
      "Koncern BMW od wielu lat produkuje samochody osobowe klasy premium. Takie pojazdy wpisują się w potrzeby wielu przedsiębiorców. Postaw na nowe BMW serii 3 dostępne w ofercie mAuto. Wybierz luksus, ponadczasowy wygląd i udogodnienia technologiczne, które poprawiają komfort i zapewniają bezpieczeństwo. Zobacz dostępne wersje nowego BMW serii 3 i uzupełnij firmową flotę.",
    ADDITIONAL_TEXTS: [
      {
        title: "Eleganckie i nowoczesne nowe BMW serii 3 w ofercie mAuto",
        text: `
          <p>Fabrycznie nowe samochody BMW serii 3 to synonim dynamicznego stylu, zaawansowanej technologii i doskonałych osiągów. Ten model od lat cieszy się niesłabnącą popularnością wśród miłośników motoryzacji.</p>
          <p>Jest doskonałym połączeniem elegancji z nowoczesnymi rozwiązaniami. To przyciąga kierowców poszukujących auta, które zapewni komfort w codziennej eksploatacji na potrzeby firmowe. Nowoczesne samochody BMW serii 3 to eleganckie i ponadczasowe modele z segmentu premium.</p>
        `
      },
      {
        title: "Fabrycznie nowe BMW serii 3 z zaawansowanym wyposażeniem w standardzie",
        text: `
          <p>Nowe modele BMW serii 3 standardowo wyposażono w śruby zabezpieczające koła, system alarmowy oraz system monitorowania ciśnienia opon. Opcjonalnie możesz wybrać wersję nowego BMW serii 3 ze sportowym układem kierowniczym. Dostępny jest także pakiet aerodynamiczny M. Producent oferuje też elektrycznie sterowaną szerokość oparcia kierowcy.</p>
        `
      },
      {
        title: "Nowe BMW serii 3 – prestiżowy samochód klasy premium",
        text: `
          <p>Nowy samochód BMW serii 3 to dobry wybór jako uzupełnienie firmowej floty pojazdów. Prestiżowy wygląd i wyposażenie jakości premium to cechy pożądane przez wielu przedsiębiorców. Jeśli potrzebujesz wygodnego, bezpiecznego i wydajnego samochodu, możesz wybrać jedną z wersji dostępnych w ofercie na mAuto. BMW serii 3 to komfortowy i stylowy model z bogatą historią.</p>
        `
      },
      {
        title: "Luksus i ponadczasowy wygląd w jednym – nowe auta BMW serii 3",
        text: `
          <p>Atrakcyjne nowe BMW serii 3 możesz mieć od ręki w ofercie mAuto. Samochód jest dostępny w wielu wersjach wyposażenia i opcjach kolorystycznych. Auta niemieckiego producenta zachwycają także świetnymi osiągami. Silnik benzynowy o mocy ponad 150 koni mechanicznych to gwarancja dynamicznej jazdy i pełnej wygody.</p>
        `
      },
      {
        title: "Nowe BMW 3 na korzystnych warunkach finansowania",
        text: `
          <p>Nowe samochody BMW 3 na atrakcyjnych warunkach finansowania w ramach leasingu lub najmu długoterminowego w mAuto. Opcjonalnie możesz wybrać pakiety serwisowe, pełne ubezpieczenie oraz kartę paliwową w promocyjnej ofercie.</p>
        `
      }
    ]
  },
  NEW_BMW_X5: {
    MAIN_TEXT:
      "Fabrycznie nowe BMW X5 to nowoczesne, luksusowe i wszechstronne auto dla wymagających kierowców. Szukasz komfortowego SUV-a, który zapewni najwyższy poziom wygody na codzienne trasy oraz podczas dłuższych podróży? Nowe BMW X5 dostępne w mAuto to doskonały wybór dla osób ceniących przestronność, elegancję oraz zaawansowane technologie. Sprawdź ofertę i wybierz wersję idealnie dopasowaną do swoich potrzeb.",
    ADDITIONAL_TEXTS: [
      {
        title: "Nowe BMW X5 – prestiżowy SUV klasy premium w ofercie mAuto",
        text: `
          <p>Nowe samochody BMW X5 to SUV-y, które doskonale łączą w sobie luksusowy design z wygodą i przestrzenią. Wyróżniają się elegancką linią, a przestronne wnętrze zaprojektowano z najwyższą dbałością o szczegóły. Wysokiej jakości materiały wykończeniowe, ergonomiczne fotele oraz zaawansowane systemy multimedialne tworzą wyjątkową atmosferę podczas jazdy. Nowe BMW X5 swoim prestiżowym wyglądem doskonale uzupełnia niemalże każdą firmową flotę pojazdów.</p>
        `
      },
      {
        title: "Komfort i nowoczesny design w jednym – nowe BMW X5",
        text: `
          <p>BMW X5 to auta klasy premium ze średniej kategorii gabarytowej. Tego typu SUV-y doskonale nadają się do jazdy w mieście, a także na dłuższe podróże biznesowe. Ponadczasowy i elegancki wygląd sprawia, że nowe BMW X5 świetnie sprawdzi się jako pojazd reprezentacyjny.</p>
        `
      },
      {
        title: "Nowe BMW X5 z doskonałym wyposażeniem w standardzie",
        text: `
          <p>Standardowe wyposażenie nowych BMW X5 obejmuje wiele innowacyjnych rozwiązań, które zwiększają komfort i bezpieczeństwo. Na pokładzie znajdują się m.in. cyfrowe radio, asystent parkowania z kamerą wsteczną i nowoczesne systemy wspomagające kierowcę. Takie udogodnienia pozwalają na pełne wykorzystanie możliwości auta podczas biznesowych wyjazdów. Dla miłośników dynamicznej jazdy dostępne są również opcje dodatkowe, takie jak pakiet sportowy M.</p>
        `
      },
      {
        title: "Nowe BMW X5 w leasing lub najem długoterminowy",
        text: `
          <p>BMW X5 to pojazd klasy premium dostępny w mAuto w elastycznych formach finansowania. Możesz wybrać leasing firmowy lub najem długoterminowy. Dzięki temu możesz cieszyć się nowoczesnym SUV-em bez dużych nakładów finansowych.</p>
          <p>Nasza oferta umożliwia dopasowanie warunków finansowych do indywidualnych preferencji. Dzięki temu zdobędziesz nowy samochód BMW X5 na naprawdę korzystnych warunkach spłaty i z szerokim pakietem korzyści. Możesz wybrać fabrycznie nowy samochód z pakietem pełnego ubezpieczenia OC, AC i NNW, a także wsparciem assistance w cenie najmu.</p>
        `
      }
    ]
  },
  NEW_BMW_X3: {
    MAIN_TEXT:
      "BMW X3 to kompaktowy SUV łączący sportową dynamikę z komfortem jazdy. To model ceniony za wygodę, design i świetne osiągi jednostki napędowej. Miejski pojazd z przestronnym bagażnikiem doskonale sprosta firmowym wyzwaniom. Zobacz wersje nowego BMW X3 dostępne w mAuto i wybierz pojazd idealny do floty Twojego przedsiębiorstwa.",
    ADDITIONAL_TEXTS: [
      {
        title: "Nowe samochody BMW X3 w ofercie mAuto – zwinne i komfortowe",
        text: `
          <p>W ofercie mAuto znajdziesz wiele wersji nowego modelu BMW X3. Wydajne silniki o mocy prawie 200 koni mechanicznych i zwinne automatyczne skrzynie biegów gwarantują dobrą dynamikę jazdy. Odświeżone nowe samochody BMW X3 zaliczamy do kategorii aut premium. Jeśli potrzebujesz pojazdu, który poradzi sobie niemalże w każdych warunkach drogowych, wtedy BMW w wersji X3 będzie dobrym wyborem.</p>
        `
      },
      {
        title: "Nowe BMW X3 – luksusowe wyposażenie premium w pakiecie",
        text: `
          <p>Standardowe wyposażenie BMW X3 obejmuje system multimedialny z dużym ekranem dotykowym, zaawansowane systemy bezpieczeństwa oraz komfortowe fotele z możliwością regulacji. Możesz go dodatkowo rozszerzyć o pakiet sportowy M, system Performance Control i łopatki do zmiany biegów.</p>
          <p>Fabrycznie nowe BMW X3 to doskonały wybór dla firm poszukujących reprezentacyjnego i funkcjonalnego pojazdu. W tym samochodzie każdy wyjazd służbowy będzie bezpieczny i komfortowy. Jeśli prowadzisz poważną firmę i zależ Ci na jak najlepszej prezencji marki, wtedy nowe samochody BMW X3 będą dobrym wyborem.</p>
        `
      },
      {
        title: "Styl w mieście i w terenie – nowe BMW X3",
        text: `
          <p>Nowe samochody BMW X3 łączą w sobie auto terenowe z miejskim SUV-em. Lekko podwyższone zawieszenie, duże koła i wydajny napęd to udogodnienia, które sprawdzają się nawet w trudnych warunkach drogowych. Z takim samochodem nawet najbardziej wymagająca trasa do klienta nie będzie problemem. Mimo zwartej konstrukcji nowe BMW X3 gwarantuje sporo przestrzeni zarówno dla kierowcy, jak i pasażerów.</p>
        `
      },
      {
        title: "Elastyczne warunki finansowania nowego BMW X3 w mAuto",
        text: `
          <p>Fabrycznie nowy samochód BMW X3 jest bardzo dobrym wyborem do firmowej floty aut. Sprawdzi się zarówno w przypadku małych, jak i dużych przedsiębiorstw. W ramach oferty mAuto skorzystasz z atrakcyjnych warunków najmu długoterminowego i leasingu. Zapewniamy też szeroki pakiet korzyści, np. ubezpieczenie OC, AC i NNW w zestawie.</p>
        `
      }
    ]
  },
  NEW_VOLKSWAGEN_TIGUAN: {
    MAIN_TEXT:
      "Nowy Volkswagen Tiguan to komfort, moc i nowoczesne technologie w jednym. Wybierz SUV-a, który dopasuje się do Twoich potrzeb – od przestronnej kabiny po zaawansowane systemy bezpieczeństwa. Nowy Volkswagen Tiguan jest gotowy na każdą trasę, bez względu na warunki. Teraz dostępny od ręki w ofercie mAuto.",
    ADDITIONAL_TEXTS: [
      {
        title: "Nowy samochód Volkswagen Tiguan dostępny w mAuto",
        text: `
          <p>Szukasz połączenia ponadczasowego designu? Chcesz mieć dostęp do innowacyjnych technologii podczas jazdy? Koniecznie sprawdź ofertę nowych samochodów Volkswagena. Tiguan to model, który zachwyca linią boczną, wydajnością, mocą silnika i komfortem. W ofercie mAuto dostępne są różne wersje wyposażenia. Dzięki temu bez problemu wybierzesz nowego Volkswagena Tiguana dopasowanego do potrzeb swojego przedsiębiorstwa.</p>
        `
      },
      {
        title: "Nowy Volkswagen Tiguan – wszechstronny i stylowy SUV",
        text: `
          <p>Nowy VW Tiguan wyposażony w nowoczesne technologie zapewnia komfort jazdy na najwyższym poziomie. Przestronna kabina, pojemny bagażnik i zaawansowane systemy bezpieczeństwa powodują, że to wersja auta, która naprawdę jest godna podziwu. Fabrycznie nowy VW Tiguan doskonale balansuje między dynamiką a wygodą. Producent zadbał o wszystko, co powinien mieć nowoczesny SUV.</p>
        `
      },
      {
        title: "Komfort, bezpieczeństwo i przestrzeń – Nowy VW Tiguan",
        text: `
          <p>Nowe samochody Volkswagen Tiguan wyposażono w automatyczną skrzynię DGS i silnik o mocy 150 koni mechanicznych. Takie zestawienie sprawia, że każda biznesowa podróż staje się wygodniejsza. W pakiecie jest też asystent pojazdu i systemy ESP, ASR, ABS i MSR.</p>
        `
      },
      {
        title: "Volkswagen Tiguan – miejski SUV z dużym potencjałem",
        text: `
          <p>Volkswagen Tiguan to świetne uzupełnienie firmowej floty pojazdów. Wygodny SUV o delikatnej stylistyce zachwyca wyglądem i jednocześnie zapewnia pełne bezpieczeństwo podczas jazdy. To samochód, którym możesz wjechać na drogi szutrowe, a także wygodnie podróżować autostradą.</p>
        `
      },
      {
        title: "Nowy Volkswagen Tiguan – elastyczne finansowanie dla wymagających firm",
        text: `
          <p>Nowe modele samochodów Volkswagen Tiguan dostępne w mAuto możesz mieć na atrakcyjnych warunkach np. najmu długoterminowego. Przy zerowej opłacie wstępnej skorzystasz dodatkowo z pakietu ubezpieczeniowego, wsparcia koordynacji serwisu oraz opcjonalnie karty paliwowej dla swojego przedsiębiorstwa.</p>
        `
      }
    ]
  },
  SUZUKI_VITARA: {
    MAIN_TITLE: "Nowy Suzuki Vitara 2025",
    MAIN_TEXT: "Szukasz idealnego samochodu służbowego, który jest jednocześnie reprezentacyjny, wszechstronny i ekonomiczny? Nowy Suzuki Vitara 2025 łączy te wszystkie cechy. Odkryj, dlaczego ten nowoczesny SUV z napędem hybrydowym i bogatym wyposażeniem to świetny wybór dla Twojej firmy.",
    ADDITIONAL_TEXTS: [
      {
        title: "Suzuki Vitara – wszechstronny SUV dopasowany do Twojego biznesu",
        text: `
        <p>Wszechstronność to słowo klucz, które idealnie opisuje Suzuki Vitara. W miejskiej dżungli docenisz jego zwinność, kompaktowe wymiary i komfort. Gdy jednak droga stanie się bardziej wymagająca, inteligentny napęd 4x4 zagwarantuje pewność prowadzenia i dotarcie do celu.</p>
        
        <p>Twoi pracownicy zyskają komfortowe i bezpieczne narzędzie pracy dzięki wysokiej pozycji za kierownicą, która zapewnia doskonałą widoczność, oraz nowoczesnym systemom wsparcia kierowcy. Przestronne wnętrze i pojemny bagażnik z praktycznym systemem podwójnej podłogi to idealne rozwiązanie do przewozu zarówno materiałów promocyjnych, jak i prywatnego bagażu podczas podróży służbowych.</p>
        
        <p>Elegancki, nowoczesny design buduje profesjonalny wizerunek firmy, a jednocześnie, nie klasyfikując się w segmencie premium, pozwala na optymalizację kosztów floty.</p>
        `
      },
      {
        title: "Suzuki Vitara: dane techniczne i wyposażenie",
        text: `
        <p>W mAuto stawiamy na rozwiązania, które oferują najwięcej korzyści. Dlatego w naszej ofercie znajdziesz Suzuki Vitara z rocznika 2025 w bogatej wersji wyposażenia, która łączy zaawansowaną technologię, bezpieczeństwo i komfort na najwyższym poziomie.</p>
        
        <p><strong>Kluczowe dane techniczne:</strong></p>
        <ul>
          <li>rocznik: 2025,</li>
          <li>silnik: 1.5 DualJet Hybrid, 1462 cm³,</li>
          <li>moc: 116 KM,</li>
          <li>napęd: 4WD ALLGRIP,</li>
          <li>skrzynia biegów: Automatyczna 6AGS.</li>
        </ul>
        
        <p><strong>Dodatkowe wyposażenie:</strong></p>
        <ul>
          <li>System multimedialny z ekranem 9" i nawigacją (Apple CarPlay™, Android Auto™) – Twoje mobilne biuro i centrum rozrywki zawsze pod ręką. Zapewnia stałą łączność, łatwe planowanie trasy i dostęp do kluczowych aplikacji, co zwiększa efektywność pracy w terenie.</li>
          <li>DSBS II (Układ reagowania przedkolizyjnego II generacji) – zaawansowane bezpieczeństwo, które aktywnie chroni Twojego pracownika i pojazd. Minimalizuje ryzyko kolizji i związanych z nią kosztów.</li>
          <li>ACC (Tempomat adaptacyjny) i LKA (Asystent utrzymania pasa ruchu) – większy komfort i mniejsze zmęczenie kierowcy podczas długich tras służbowych. To realna inwestycja w bezpieczeństwo i dobre samopoczucie Twojego zespołu.</li>
          <li>Napęd 4WD ALLGRIP z przełącznikiem trybów jazdy – gwarancja mobilności i pewności prowadzenia w każdych warunkach – od ulewnego deszczu w mieście po nieutwardzone drogi dojazdowe na tereny inwestycyjne.</li>
          <li>Pakiet Zimowy (podgrzewane fotele przednie) – komfort pracy kierowcy niezależnie od pory roku, co przekłada się na jego zadowolenie i wydajność.</li>
          <li>System kluczyka elektronicznego – wygoda i oszczędność cennego czasu na co dzień. Ułatwia szybkie wsiadanie i uruchamianie pojazdu, co jest kluczowe przy napiętym harmonogramie.</li>
          <li>Kamera cofania i tylne czujniki parkowania – łatwiejsze i bezpieczniejsze manewrowanie w ciasnych, miejskich przestrzeniach, co ogranicza ryzyko drobnych uszkodzeń parkingowych.</li>
        </ul>
        `
      },
      {
        title: "Ekonomia i ekologia, czyli Suzuki Vitara – spalanie i koszty",
        text: `
        <p>Nowoczesna flota to flota oszczędna i odpowiedzialna. Napęd hybrydowy w Suzuki Vitara to podwójna korzyść dla Twojej firmy: realne oszczędności na paliwie i budowa pozytywnego, proekologicznego wizerunku.</p>
        
        <ul>
          <li>Spalanie w cyklu mieszanym: 5,6 l/100 km,</li>
          <li>emisja CO₂: 127 g/km.</li>
        </ul>
        
        <p>Niskie zużycie paliwa bezpośrednio przekłada się na obniżenie miesięcznych kosztów operacyjnych każdego pojazdu w Twojej flocie. Każdy litr paliwa zaoszczędzony przez jednego pracownika to wymierna korzyść dla całego budżetu firmy w skali roku. Dodatkowo niska emisja CO₂ wspiera proekologiczny wizerunek i może być istotna w kontekście wewnętrznych norm korporacyjnych czy przyszłych regulacji.</p>
        `
      },
      {
        title: "Wynajem długoterminowy Suzuki Vitara w mAuto – Twoja przewaga w biznesie",
        text: `
        <p>Wybór odpowiedniego samochodu to jedno. Dopasowanie optymalnej formy finansowania to klucz do sukcesu i stabilności finansowej firmy. Wynajem długoterminowy w mAuto to rozwiązanie szyte na miarę, które eliminuje nieprzewidziane wydatki i pozwala skupić się na prowadzeniu biznesu.</p>
        
        <ul>
          <li>Dostępność od ręki – odbierz nowego Suzuki Vitarę 2025 bez wielomiesięcznego oczekiwania i natychmiast wzmocnij swoją flotę.</li>
          <li>Elastyczność – dopasuj okres najmu (od 24 do 48 miesięcy) i limit kilometrów idealnie do potrzeb Twojej działalności.</li>
          <li>Niski próg wejścia – rozpocznij korzystanie z nowego samochodu nawet z 0% opłaty wstępnej, nie angażując kapitału firmy.</li>
          <li>Przewidywalność kosztów – ciesz się stałą miesięczną ratą już od 1234 zł netto, którą w całości możesz zaliczyć w koszty uzyskania przychodu, optymalizując swoje podatki.</li>
        </ul>
        
        <p>Nie czekaj, aż konkurencja Cię wyprzedzi. Skontaktuj się z naszym doradcą, aby poznać spersonalizowaną ofertę wynajmu Suzuki Vitara dla Twojej firmy.</p>
        `
      }
    ]
  },
  HYUNDAI_TUCSON: {
    MAIN_TEXT: "Poznaj nowego Hyundaia Tucson – wszechstronnego SUV-a, który mistrzowsko łączy elegancję, funkcjonalność i nowoczesny design. To niezawodne, ekonomiczne i reprezentacyjne auto, stworzone z myślą o przedsiębiorcach i menedżerach flot, którzy szukają pojazdu do zadań specjalnych. Hyundai Tucson to idealny wybór dla nowoczesnego biznesu, który ceni sobie niezawodność i styl.",
    ADDITIONAL_TEXTS: [
      {
        title: "Hyundai Tuscon – SUV, który nadąża za Twoim biznesem",
        text: `
        <p>Dynamiczny charakter Hyundaia Tucson sprawia, że doskonale odnajduje się on w zmiennym środowisku biznesowym. Zwinny w miejskiej dżungli, pozwala na sprawne poruszanie się między spotkaniami, a na długich trasach gwarantuje komfort i ciszę, sprzyjające koncentracji i prowadzeniu rozmów. Przestronne wnętrze i imponujący bagażnik to odpowiedź na wszystkie wyzwania – od transportu materiałów promocyjnych po komfortowe przewożenie pasażerów. Jego nowoczesny, odważny design przyciąga wzrok i buduje profesjonalny wizerunek firmy, zachowując przy tym rozsądny balans – jest to samochód, który robi wrażenie, ale nie onieśmiela nadmiernym luksusem.</p>
        `
      },
      {
        title: "Hyundai Tucson – dane techniczne",
        text: `
        <p>Hyundai Tucson dostępny w ofercie mAuto to kwintesencja innowacji, bezpieczeństwa i komfortu. Wyposażyliśmy go we wszystko, czego potrzebujesz, aby każda podróż służbowa była czystą przyjemnością.</p>
        
        <ul>
          <li><strong>Zaawansowane systemy bezpieczeństwa</strong> – Twoje poczucie pewności na drodze wspierają m.in. asystent unikania kolizji czołowych (FCA), asystent utrzymywania pasa ruchu (LKA) oraz system monitorowania martwego pola (BCA).</li>
          <li><strong>Komfort i technologia w centrum uwagi</strong> – system multimedialny z panoramicznym ekranem dotykowym 12,3", fabryczną nawigacją oraz interfejsami Apple CarPlay i Android Auto zapewnia stałą łączność i dostęp do kluczowych informacji.</li>
          <li><strong>Nowoczesna wygoda na co dzień</strong> – bezkluczykowy dostęp oraz innowacyjna skrzynia biegów sterowana przyciskami podnoszą komfort codziennego użytkowania.</li>
          <li><strong>Pełna kontrola podczas manewrów</strong> – przednie i tylne czujniki parkowania oraz kamera cofania z dynamicznymi liniami prowadzącymi sprawiają, że nawet najciaśniejsze miejsca parkingowe nie stanowią wyzwania.</li>
          <li><strong>Design, który podkreśla innowacyjność</strong> – reflektory w technologii LED (Pakiet LED) ze światłami do jazdy dziennej typu Hidden Mirror nie tylko gwarantują doskonałą widoczność, ale także nadają autu unikalny, futurystyczny wygląd.</li>
          <li><strong>Komfort w każdych warunkach pogodowych</strong> – klimatyzacja automatyczna dwustrefowa, podgrzewana kierownica oraz podgrzewane fotele przednie zapewniają optymalne warunki podróży przez cały rok.</li>
          <li><strong>Praktyczność i wszechstronność</strong> – całość uzupełniają 18-calowe felgi aluminiowe, praktyczne relingi dachowe oraz tylna kanapa składana w proporcji 40:20:40, która pozwala elastycznie zarządzać przestrzenią bagażową.</li>
        </ul>
        `
      },
      {
        title: "Hyundai Tucson – spalanie i oszczędność w standardzie",
        text: `
        <p>W mAuto doskonale rozumiemy, że dla klientów biznesowych liczy się nie tylko prestiż i wyposażenie, ale przede wszystkim efektywność kosztowa. Hyundai Tucson z silnikiem 1.6 to doskonały wybór także z perspektywy firmowego budżetu. Jego zużycie paliwa to:</p>
        
        <ul>
          <li>cykl miejski: 6,5 l/100 km,</li>
          <li>cykl pozamiejski: 6,2 l/100 km,</li>
          <li>cykl mieszany: 6,3 l/100 km.</li>
        </ul>
        
        <p>Takie wyniki oznaczają niską emisję CO₂ (148 g/km) i przekładają się na realne, comiesięczne oszczędności na paliwie, optymalizując koszty utrzymania floty.</p>
        `
      },
      {
        title: "Odkryj ofertę mAuto na Twojego Hyundaia Tucsona",
        text: `
        <p>Wybierając model Hyundai Tucson w mAuto, zyskujesz nie tylko nowoczesny samochód, ale także partnera, który rozumie potrzeby Twojej firmy.</p>
        
        <ul>
          <li>Nowe modele 2025 od ręki – oferujemy fabrycznie nowe egzemplarze w ramach najmu długoterminowego na okres od 24 do 48 miesięcy. Rata miesięczna już od 1029 zł netto.</li>
          <li>Sprawdzone auta poleasingowe – szukasz jeszcze bardziej ekonomicznych rozwiązań? Sprawdź naszą ofertę modeli ze starszych roczników (do 2021) w atrakcyjnych opcjach leasingu.</li>
          <li>Elastyczne finansowanie dopasowane do Ciebie – dajemy Ci możliwość startu z 0% opłaty wstępnej oraz dopasowania wysokości rat do możliwości i potrzeb Twojej firmy.</li>
          <li>Kompleksowa obsługa i doradztwo – nasi eksperci są do Twojej dyspozycji na każdym etapie – od wyboru idealnej wersji pojazdu po finalizację umowy finansowania.</li>
        </ul>
        
        <p>Inteligentny wybór dla Twojej firmy</p>
        <p>Hyundai Tucson w ofercie mAuto to coś więcej niż samochód – to inteligentne narzędzie pracy, które wspiera rozwój Twojego biznesu, dba o wizerunek i kontroluje koszty. To wybór, który się opłaca.</p>
        
        <p>Nie czekaj. Zapoznaj się ze szczegółami dostępnych modeli na naszej stronie, pobierz dedykowaną ofertę lub skontaktuj się bezpośrednio z naszym doradcą. Przygotujemy dla Ciebie spersonalizowaną propozycję, która idealnie wpisze się w potrzeby Twojej firmy.</p>
        `
      }
    ]
  },
  AUDI_A6: {
    MAIN_TEXT: "Szukasz samochodu, który będzie doskonałą wizytówką Twojej firmy, a jednocześnie sprosta wszystkim wyzwaniom dynamicznego biznesu? Audi A6 to odpowiedź na potrzeby nowoczesnych przedsiębiorców. Ten model jest synonimem prestiżu, zaawansowanej technologii i niezrównanej wszechstronności. W mAuto udowadniamy, że luksus może iść w parze z inteligentnymi decyzjami finansowymi. Wybierz atrakcyjne finansowanie poleasingowe, które pozwoli Twojej firmie rozwijać się bez kompromisów.",
    ADDITIONAL_TEXTS: [
      {
        title: "Audi A6 – stylowa limuzyna w praktycznym wydaniu",
        text: `
        <p>Wizerunek w biznesie ma kluczowe znaczenie. Audi A6, dzięki swojej eleganckiej, dynamicznej sylwetce i luksusowo wykończonemu wnętrzu, buduje prestiż Twojej firmy na każdym kroku. To samochód, który robi doskonałe wrażenie zarówno podczas spotkań z kluczowymi kontrahentami, jak i w codziennym użytkowaniu przez kadrę zarządzającą czy przedstawicieli handlowych.</p>
        
        <p>Jednocześnie, wersja kombi jest niezwykle funkcjonalna. Imponująca przestrzeń bagażowa z łatwością pomieści materiały promocyjne, próbki produktów czy bagaże na kilkudniową delegację. Komfortowe, ergonomicznie zaprojektowane wnętrze gwarantuje, że nawet najdłuższe trasy staną się przyjemnością, a nie obowiązkiem. Audi A6 to idealne połączenie reprezentacyjnej limuzyny i niezawodnego, wszechstronnego narzędzia pracy.</p>
        `
      },
      {
        title: "Audi A6 – dane techniczne",
        text: `
        <p>Audi A6 to nowoczesny samochód, który zachwyca nie tylko wyglądem, ale także osiągami.</p>
        
        <ul>
          <li><strong>Napęd</strong> – legendarny napęd na cztery koła quattro w połączeniu z dynamicznym silnikiem 2.0 TFSI o mocy 265 KM gwarantuje pewność prowadzenia w każdych warunkach oraz doskonałe osiągi, które przekładają się na bezpieczeństwo i komfort podróży.</li>
          <li><strong>Komfort i technologia</strong> – cyfrowy kokpit Audi Virtual Cockpit, zaawansowany system nawigacji MMI Navigation oraz Audi Smartphone Interface tworzą Twoje mobilne centrum dowodzenia. Zarządzaj trasą, połączeniami i multimediami bez odrywania uwagi od drogi.</li>
          <li><strong>Bezpieczeństwo</strong> – pakiet systemów Audi Pre Sense Basic to proaktywna ochrona, która w razie ryzyka kolizji automatycznie napina pasy czy zamyka szyby, minimalizując skutki zdarzenia.</li>
          <li><strong>Wygoda na co dzień</strong> – elektrycznie regulowane fotele z funkcją pamięci, 4-strefowa klimatyzacja automatyczna oraz elektrycznie otwierana i zamykana klapa bagażnika to detale, które docenisz każdego dnia.</li>
          <li><strong>Prestiżowe detale</strong> – pakiet Business i Technology, nastrojowe oświetlenie Ambiente oraz najwyższej jakości materiały wykończeniowe podkreślają luksusowy charakter tego modelu.</li>
        </ul>
        `
      },
      {
        title: "Audi A6 spalanie – ekonomia w segmencie premium",
        text: `
        <p>Audi A6 to nowoczesny samochód, który rewolucjonizuje pojęcie oszczędności w klasie premium. Co to oznacza dla Twojego biznesu? Przede wszystkim realne korzyści finansowe. Inteligentny system zarządzania spalaniem zapewnia wyjątkowo niskie średnie zużycie paliwa. Według danych wynosi ono ok. 4,6-6,3 l/100 km. To kluczowy argument, który realnie obniża całkowity koszt posiadania pojazdu.</p>
        `
      },
      {
        title: "Audi A6 w ofercie mAuto – Twoje auto premium w zasięgu ręki",
        text: `
        <p>Wybór poleasingowego Audi A6 w mAuto to strategiczna decyzja biznesowa. Otrzymujesz sprawdzony samochód z udokumentowaną historią serwisową i pewnym pochodzeniem, a wszystko to w cenie znacznie niższej niż nowy egzemplarz z salonu.</p>
        
        <p>Nasza oferta finansowania jest skrojona na miarę potrzeb Twojej firmy. Proponujemy elastyczny leasing z ratą już od 1056 zł netto miesięcznie oraz opłatą wstępną od 0%. Sam decydujesz o okresie finansowania i wysokości rat, dopasowując je do możliwości swojego przedsiębiorstwa. W mAuto dbamy o minimum formalności, a leasing operacyjny stanowi dla Ciebie tarczę podatkową, pozwalając na optymalizację kosztów prowadzenia działalności.</p>
        
        <p>Nie czekaj, aż najlepsze okazje znikną z rynku. Zapoznaj się z dostępnymi egzemplarzami Audi A6 na naszej stronie, skorzystaj z intuicyjnego kalkulatora leasingowego i skontaktuj się z naszym doradcą. Przygotujemy dla Ciebie spersonalizowaną ofertę, która pomoże Twojej firmie wjechać na drogę sukcesu.</p>
        `
      }
    ]
  },
  AUDI_A4: {
    MAIN_TEXT: "W świecie biznesu, gdzie każdy detal ma znaczenie, wizerunek firmy i niezawodność floty pojazdów to dwa filary sukcesu. Te elementy muszą iść w parze, budując zaufanie klientów i partnerów. Dlatego prezentujemy Audi A4 – synonim luksusu, zaawansowanej technologii i niezrównanego komfortu. To inwestycja w prestiż, która nie nadwyręży firmowego budżetu.",
    ADDITIONAL_TEXTS: [
      {
        title: "Audi A4 – wszechstronne narzędzie pracy w segmencie premium",
        text: `
        <p>Model Audi A4, zwłaszcza w praktycznej i eleganckiej wersji kombi to prawdziwy mistrz wszechstronności. Z jednej strony stanowi nienaganną wizytówkę firmy, idealną dla kadry zarządzającej i na spotkania z kluczowymi kontrahentami. Z drugiej – to niezawodne i funkcjonalne narzędzie do codziennych zadań, oferujące przestronne wnętrze i pojemny bagażnik, gotowy sprostać każdemu wyzwaniu.</p>
        
        <p>Jego dynamiczna, ponadczasowa sylwetka przyciąga spojrzenia, a legendarna jakość wykonania, typowa dla segmentu premium, gwarantuje, że każdy kilometr będzie pokonany w atmosferze komfortu i prestiżu.</p>
        
        <p>W naszej ofercie skupiamy się głównie na modelach z roczników 2021-2022. Są to niemal nowe samochody z udokumentowanym przebiegiem. Wybierając taki pojazd, zyskujesz dostęp do najnowszych rozwiązań technologicznych oraz zaawansowanych systemów bezpieczeństwa. To one zapewniają nie tylko wyjątkowy komfort, ale przede wszystkim spokój ducha i poczucie pełnej kontroli podczas podróży służbowych.</p>
        `
      },
      {
        title: "Audi A4 – dane techniczne i wyposażenie",
        text: `
        <p>Każdy egzemplarz Audi A4 w ofercie mAuto.pl to gwarancja bogatego wyposażenia, które zostało zaprojektowane z myślą o komforcie, bezpieczeństwie i efektywności kierowcy. Poniżej przedstawiamy przykładową specyfikację techniczną typową dla modeli w naszej ofercie.</p>
        
        <ul>
          <li>Silnik: 2.0 TDI,</li>
          <li>moc: 190 KM,</li>
          <li>skrzynia biegów: automatyczna.</li>
        </ul>
        
        <p>Nasze modele Audi A4 wyposażone są w liczne udogodnienia, które podnoszą standard każdej podróży. Do kluczowych należą między innymi:</p>
        
        <ul>
          <li><strong>Audi Virtual Cockpit Plus</strong> – w pełni cyfrowe zegary o wysokiej rozdzielczości, które nadają wnętrzu ultranowoczesny charakter i ułatwiają dostęp do kluczowych informacji bez odrywania wzroku od drogi.</li>
          <li><strong>Reflektory w technologii LED</strong> – gwarancja doskonałej widoczności i bezpieczeństwa po zmroku, a także charakterystyczny, rozpoznawalny element stylistyczny nowoczesnych modeli Audi.</li>
          <li><strong>Audi Smartphone Interface</strong> – bezproblemowa integracja telefonu z systemem MMI, zapewniająca stały dostęp do ulubionych aplikacji, nawigacji czy muzyki bezpośrednio na ekranie pojazdu.</li>
          <li><strong>Tempomat z ogranicznikiem prędkości</strong> – kluczowy element dla komfortu i bezpieczeństwa na długich trasach, pozwalający na utrzymanie stałej prędkości i unikanie mandatów.</li>
          <li><strong>Klimatyzacja automatyczna</strong> – system, który dba o idealną temperaturę i zapewnia komfortowe warunki pracy.</li>
          <li><strong>Kierownica wielofunkcyjna obszyta skórą</strong> – prestiżowy detal i pełna kontrola nad najważniejszymi funkcjami pojazdu bez odrywania rąk od kierownicy.</li>
          <li><strong>Elektryczne wspomaganie otwierania i zamykania bagażnika</strong> – niezastąpiona wygoda i funkcjonalność, którą doceni każdy użytkownik w codziennej eksploatacji.</li>
        </ul>
        `
      },
      {
        title: "Audi A4 – spalanie i efektywność kosztowa",
        text: `
        <p>Kontrola kosztów operacyjnych jest kluczowa w każdym biznesie, a flota samochodowa stanowi jej istotną część. Nowoczesne silniki wysokoprężne montowane w Audi A4 to doskonały kompromis między imponującą dynamiką a racjonalnym zużyciem paliwa. W cyklu mieszanym oszczędne silniki diesla w Audi A4 potrafią zadowolić się zużyciem paliwa na poziomie 5-6 l/100 km, co pozwala na realną i przewidywalną kontrolę kosztów floty. To, w połączeniu z pojemnym zbiornikiem paliwa oraz dużym zbiornikiem AdBlue, minimalizuje częstotliwość postojów i pozwala na optymalizację czasu pracy kierowców, zwłaszcza na długich dystansach.</p>
        `
      },
      {
        title: "Dlaczego poleasingowe Audi A4 z mAuto to dobry wybór?",
        text: `
        <p>Wybór samochodu poleasingowego to decyzja strategiczna. Decydując się na Audi A4 z mAuto zyskujesz więcej niż tylko pojazd – to inwestycja w pewność, oszczędność i elastyczność. Każdy oferowany przez nas egzemplarz jest dokładnie sprawdzony i posiada certyfikat jakości, pełną historię serwisową oraz gwarancję autentyczności przebiegu.</p>
        
        <p>Zyskaj dostęp do samochodu klasy premium za ułamek ceny nowego modelu, co pozwala na mądrą optymalizację budżetu bez żadnych kompromisów w kwestii jakości i prestiżu. Co więcej, oferujemy elastyczne formy finansowania z opłatą wstępną już od 0%. To rozwiązanie, które pozwala zachować pełną płynność finansową firmy. Nasze wyselekcjonowane modele są dostępne od ręki – bez wielomiesięcznego oczekiwania na zamówiony samochód.</p>
        
        <p>Wybierz prestiż i niezawodność dla swojej firmy</p>
        <p>Inwestycja w poleasingowe Audi A4 z pewnego źródła to gwarancja prestiżu, niezawodności i finansowej efektywności.</p>
        
        <p>Sprawdź naszą aktualną ofertę poleasingowych modeli Audi A4 i wybierz samochód, który podniesie rangę Twojej firmy. Skontaktuj się z naszymi doradcami, aby poznać spersonalizowane opcje finansowania i znaleźć idealny egzemplarz dla siebie.</p>
        `
      }
    ]
  },
  RENAULT_CLIO_2025: {
    MAIN_TITLE: "Nowe Renault Clio 2025",
    MAIN_TEXT: "Renault Clio, niekwestionowana ikona miejskiej motoryzacji, powraca w spektakularnej odsłonie na rok 2025, by na nowo zdefiniować standardy w segmencie samochodów służbowych. To idealny wybór dla nowoczesnego biznesu, który ceni połączenie dynamicznego designu, imponującej oszczędności i zaawansowanej technologii. Wybierając najem długoterminowy w mAuto zyskujesz coś więcej niż samochód. To gwarancja przewidywalności kosztów i pełen spokój ducha, bez angażowania się w obsługę pojazdu.",
    ADDITIONAL_TEXTS: [
      {
        title: "Renault Clio – samochód służbowy, który buduje wizerunek",
        text: `
        <p>Samochód służbowy to dziś znacznie więcej niż tylko narzędzie pracy – to mobilna wizytówka Twojej firmy. Nowe Renault Clio z rocznika 2025 doskonale sprawdzi się w tej roli. Jego dynamiczna i elegancka linia nadwozia typu hatchback, podkreślona przez charakterystyczne światła Full LED komunikują profesjonalizm i nowoczesne podejście do biznesu. Niezależnie od tego, czy Twoi pracownicy poruszają się po zatłoczonym centrum miasta, czy pokonują setki kilometrów na spotkania z klientami, Renault Clio zapewni im komfort i bezpieczeństwo, jednocześnie budując pozytywny wizerunek Twojej marki na każdym kroku.</p>
        `
      },
      {
        title: "Renault Clio – dane techniczne",
        text: `
        <p>Wybierając Renault Clio w bogatej wersji wyposażenia, inwestujesz w technologię, która realnie wspiera Twój biznes każdego dnia. Wyposażenie standardowe zostało skomponowane tak, by zaspokoić potrzeby nawet najbardziej wymagających użytkowników biznesowych, dla których liczy się komfort i bezpieczeństwo.</p>
        
        <p><strong>Kluczowe elementy wyposażenia:</strong></p>
        
        <ul>
          <li><strong>Nowoczesne multimedia</strong> – system Easy Link z ekranem 7", wbudowaną nawigacją i unikalną, bezprzewodową replikacją ekranu smartfona (przez WiFi) zapewnia stałą łączność i dostęp do kluczowych aplikacji bez zbędnych kabli.</li>
          <li><strong>Komfort i wygoda</strong> – karta Renault Hands Free to synonim wygody – wystarczy mieć ją przy sobie, by auto samo się otworzyło i było gotowe do uruchomienia. Klimatyzacja automatyczna dba o idealną temperaturę, a fotel kierowcy z regulacją wysokości pozwala na idealne dopasowanie pozycji za kierownicą.</li>
          <li><strong>Bezpieczeństwo na najwyższym poziomie</strong> – aktywny system wspomagania hamowania z funkcją wykrywania pieszych i rowerzystów, system utrzymania pasa ruchu oraz system kontroli zmęczenia kierowcy (DDAW) tworzą tarczę ochronną, minimalizując ryzyko na drodze.</li>
          <li><strong>Wsparcie w mieście</strong> – precyzyjny system wspomagania parkowania tyłem oraz kamera cofania sprawiają, że manewrowanie nawet w najciaśniejszych miejscach parkingowych staje się proste i bezstresowe.</li>
          <li><strong>Pełna kontrola nad jazdą i kosztami</strong> – cyfrowy, konfigurowalny wyświetlacz zegarów o przekątnej 7" dostarcza kluczowych informacji w czytelnej formie, a system Multi-Sense z dedykowanym trybem ECO pozwala na optymalizację stylu jazdy pod kątem jak najniższego zużycia paliwa.</li>
        </ul>
        `
      },
      {
        title: "Ekonomiczna jazda, czyli niskie spalanie Renault Clio",
        text: `
        <p>Koszty paliwa to jeden z głównych wydatków na flotę samochodową. Renault Clio z silnikiem TCe 90 zostało zaprojektowane z myślą o maksymalnej wydajności, co bezpośrednio przekłada się na oszczędności dla Twojej firmy.</p>
        
        <ul>
          <li>Spalanie w cyklu miejskim: 6 l/100 km,</li>
          <li>spalanie w cyklu pozamiejskim: 4,8 l/100 km,</li>
          <li>spalanie w cyklu mieszanym: 5,8 l/100 km,</li>
          <li>emisja CO₂: 130 g/km.</li>
        </ul>
        
        <p>Niskie spalanie Renault Clio przekłada się na mniejsze i bardziej przewidywalne wydatki operacyjne floty. Ograniczona emisja CO₂ to krok w stronę bardziej zrównoważonego biznesu i budowania wizerunku firmy odpowiedzialnej ekologicznie.</p>
        `
      },
      {
        title: "Renault Clio w mAuto – dlaczego warto?",
        text: `
        <p>Wybór odpowiedniego samochodu to jedno, ale kluczowe jest również inteligentne finansowanie i obsługa. Wynajem długoterminowy w mAuto to rozwiązanie, które eliminuje wszystkie problemy związane z posiadaniem floty.</p>
        
        <ul>
          <li><strong>Dostępność od ręki</strong> – nie trać czasu na wielomiesięczne oczekiwanie. W mAuto fabrycznie nowe modele Renault Clio z rocznika 2025 są dostępne niemal od zaraz.</li>
          <li><strong>Elastyczność finansowania</strong> – dopasuj warunki do swoich możliwości. Skorzystaj z opcji najmu z opłatą wstępną już od 0% i ciesz się jedną, stałą, przewidywalną ratą miesięczną przez cały okres trwania umowy.</li>
          <li><strong>Pełna obsługa w cenie</strong> – zapomnij o fakturach za ubezpieczenie, nieprzewidzianych kosztach serwisu czy terminach przeglądów. W ramach jednego abonamentu zapewniamy pełen pakiet obsługi, włączając w to serwis, przeglądy, ubezpieczenie OC/AC i wsparcie assistance.</li>
          <li><strong>Korzyści podatkowe</strong> – rata za wynajem długoterminowy stanowi w całości koszt uzyskania przychodu. To proste i skuteczne narzędzie do optymalizacji podatkowej w Twojej firmie, pozwalające odliczyć zarówno podatek VAT, jak i dochodowy.</li>
        </ul>
        
        <p>Podsumowując, nowe Renault Clio to połączenie stylu, oszczędności i technologii, które idealnie wpisuje się w potrzeby dynamicznego biznesu. Najem długoterminowy w mAuto to z kolei inteligentne i wygodne rozwiązanie finansowe, które daje Ci pełną kontrolę nad budżetem i bezcenny spokój.</p>
        
        <p>Nie czekaj – skontaktuj się z naszym doradcą, aby otrzymać spersonalizowaną ofertę na nowe Renault Clio dla Twojej firmy.</p>
        `
      }
    ]
  },
  KIA_CEED: {
    MAIN_TEXT: "Szukasz samochodu służbowego, który łączy w sobie nowoczesny styl, niezawodność i niskie koszty utrzymania? Kia Ceed to inteligentna odpowiedź na potrzeby współczesnej firmy. Ten popularny model w wersji hatchback w mistrzowski sposób godzi dynamiczny design, codzienną funkcjonalność oraz przewidywalne koszty eksploatacji. To idealny wybór dla przedsiębiorców, którzy podchodzą do zarządzania flotą w sposób pragmatyczny, ceniąc sobie optymalizację wydatków bez rezygnacji z jakości i profesjonalnego wizerunku.",
    ADDITIONAL_TEXTS: [
      {
        title: "Kia Ceed – idealne rozwiązanie dla Twojej firmy",
        text: `
        <p>Dynamiczna, a zarazem elegancka linia nadwozia Kii Ceed sprawia, że samochód ten pomaga doskonale budować profesjonalny wizerunek Twojego przedsiębiorstwa. Dobre wrażenie robi też wnętrze – zaprojektowane z myślą o ergonomii i komforcie kierowcy oraz pasażerów. Dla pracowników spędzających wiele godzin w trasie wygodne fotele i intuicyjny kokpit mają kluczowe znaczenie. Kia Ceed to wszechstronne auto, które sprawdzi się jako niezawodne narzędzie pracy dla przedstawicieli handlowych oraz komfortowy środek transportu dla kadry menedżerskiej niższego szczebla.</p>
        
        <p>Wszechstronność Kii Ceed przejawia się także w jej praktyczności. Pojemny i ustawny bagażnik bez problemu pomieści materiały promocyjne, niewielki sprzęt czy bagaże na kilkudniową delegację. 5-drzwiowe nadwozie typu hatchback to gwarancja wygody w codziennym użytkowaniu – od swobodnego manewrowania w miejskiej dżungli po stabilną i komfortową jazdę na drogach szybkiego ruchu. Kia Ceed idealnie wpisuje się w definicję biznesowego złotego środka: jest wystarczająco reprezentacyjna, wygodna i, co najważniejsze, oszczędna.</p>
        `
      },
      {
        title: "Kia Ceed – dane techniczne",
        text: `
        <p>W ofercie mAuto znajdziesz nowoczesne egzemplarze Kii Ceed z bogatym wyposażeniem. Oferowane modele napędza dynamiczna i wydajna jednostka, która zapewnia doskonałe osiągi przy zachowaniu rozsądnego apetytu na paliwo.</p>
        
        <p><strong>Dane techniczne:</strong></p>
        <ul>
          <li>wersja silnikowa: 1.5 T-GDI,</li>
          <li>typ nadwozia: 5-drzwiowy hatchback,</li>
          <li>roczniki: 2021-2022,</li>
          <li>rodzaj paliwa: benzyna,</li>
          <li>moc: 160 KM (118 kW).</li>
        </ul>
        `
      },
      {
        title: "Kia Ceed – spalanie",
        text: `
        <p>W skutecznym zarządzaniu flotą pojazdów każdy element wpływający na koszty ma ogromne znaczenie. Niskie koszty eksploatacji to jeden z kluczowych atutów Kii Ceed. Nowoczesny silnik 1.5 T-GDI charakteryzuje się średnim zużyciem paliwa na poziomie zaledwie 5,2-6,4 l/100 km oraz emisją CO₂ wynoszącą 119-145 g/km. W praktyce przekłada się to bezpośrednio na niższe rachunki za paliwo i, co kluczowe dla każdego przedsiębiorcy, znacząco obniża całkowity koszt posiadania (TCO) pojazdu w firmowym budżecie.</p>
        `
      },
      {
        title: "Poleasingowa Kia Ceed w mAuto",
        text: `
        <p>Wybór samochodu poleasingowego z mAuto to decyzja oparta na zaufaniu i bezpieczeństwie. Stawiamy na transparentność i jakość, oferując pojazdy ze sprawdzoną historią i w doskonałym stanie technicznym. Decydując się na Kię Ceed z naszej oferty, zyskujesz:</p>
        
        <ul>
          <li>szeroki wybór sprawdzonych egzemplarzy poleasingowych z roczników 2021-2022;</li>
          <li>gwarancję autentyczności przebiegu i pełną, udokumentowaną historię serwisową;</li>
          <li>elastyczne opcje finansowania – leasing z opłatą wstępną już od 0%, które dopasujemy idealnie do potrzeb i możliwości Twojej firmy.</li>
        </ul>
        
        <p>Kia Ceed to niezawodność, ekonomia i profesjonalny wizerunek w jednym. To inwestycja, która szybko się zwraca, optymalizując koszty transportu w Twojej firmie. Nie czekaj – już dziś zapoznaj się z naszą aktualną ofertą dostępnych modeli Kia Ceed. Skontaktuj się z naszymi doradcami, którzy przygotują dla Ciebie spersonalizowaną ofertę finansowania i pomogą wybrać idealny egzemplarz dla Twojego biznesu.</p>
        `
      }
    ]
  },
  NEW_HYUNDAI: {
    MAIN_TITLE: "Nowe samochody Hyundai",
    MAIN_TEXT: "Wybór floty pojazdów to strategiczna decyzja, która wpływa na wizerunek, koszty i efektywność Twojego biznesu. Samochód służbowy jest mobilną wizytówką firmy, dlatego warto postawić na markę, która łączy niezawodność, nowoczesny design i zaawansowane technologie. Hyundai jest synonimem tych wartości, oferując pojazdy zaprojektowane z myślą o dynamicznych potrzebach współczesnego przedsiębiorcy.",
    ADDITIONAL_TEXTS: [
      {
        title: "Hyundai – nowoczesne auta dla biznesu",
        text: `
        <p>Niezależnie od tego, czy potrzebujesz reprezentacyjnej limuzyny, wszechstronnego SUV-a do zadań specjalnych, czy ekonomicznego auta do codziennej pracy w mieście, gama modeli Hyundai odpowie na Twoje potrzeby. Każdy pojazd tej marki charakteryzuje się odważną stylistyką, która podkreśla profesjonalny wizerunek firmy i buduje prestiż w oczach klientów. Wnętrza samochodów Hyundai to przemyślane przestrzenie, łączące komfort, funkcjonalność i dostęp do najnowszych technologii, które czynią każdą podróż służbową bardziej komfortową i produktywną.</p>
        `
      },
      {
        title: "Technologia i bezpieczeństwo",
        text: `
        <p>Wybierając samochody marki Hyundai, inwestujesz w najwyższy poziom komfortu i bezpieczeństwa. Pojazdy są wyposażone w rozwiązania, które realnie wspierają kierowcę w codziennej pracy.</p>
        
        <ul>
          <li><strong>Pakiet systemów bezpieczeństwa Hyundai Smart Sense</strong> – zaawansowani asystenci monitorują otoczenie pojazdu, minimalizując ryzyko kolizji i aktywnie chroniąc Twoich pracowników.</li>
          <li><strong>Nowoczesne multimedia i łączność</strong> – intuicyjne systemy z dużymi ekranami dotykowymi, integracją Apple CarPlay™/Android Auto™ oraz bezprzewodowymi ładowarkami utrzymują stałą łączność ze światem.</li>
          <li><strong>Komfort i funkcjonalność</strong> – elementy takie jak bezkluczykowy dostęp, podgrzewane fotele i kierownica czy automatyczna klimatyzacja sprawiają, że nawet najdłuższa trasa staje się przyjemnością.</li>
          <li><strong>Styl i elegancja</strong> – efektowne reflektory w technologii LED oraz felgi aluminiowe o dynamicznych wzorach nadają pojazdom prestiżowy wygląd.</li>
        </ul>
        `
      },
      {
        title: "Korzystne finansowanie w mAuto",
        text: `
        <p>W mAuto rozumiemy, że biznes wymaga elastycznych rozwiązań. Dlatego naszą ofertę finansowania dopasowujemy do Twoich możliwości i oczekiwań.</p>
        
        <ul>
          <li>Atrakcyjny najem długoterminowy na okres od 24 do 48 miesięcy.</li>
          <li>Możliwość startu z 0% opłaty wstępnej, co pozwala zachować płynność finansową.</li>
          <li>Dostępność od ręki – fabrycznie nowe modele czekają, by dołączyć do Twojej floty.</li>
        </ul>
        
        <p>Skontaktuj się z naszymi doradcami i wybierz nowego Hyundaia, który napędzi Twój biznes.</p>
        `
      }
    ]
  },
  NEW_HYUNDAI_TUCSON: {
    MAIN_TITLE: "Nowy Hyundai Tucson 2025",
    MAIN_TEXT: "Nowy Hyundai Tucson wyznacza standardy dla samochodu służbowego. Jego dynamiczny design, zaawansowana technologia i niezrównana wszechstronność czynią go idealnym wyborem dla nowoczesnych przedsiębiorstw. To połączenie elegancji i prestiżu SUV-a z racjonalnością kosztów, które doceni każdy menedżer.",
    ADDITIONAL_TEXTS: [
      {
        title: "Nowy Hyundai Tucson – niezawodne narzędzie w biznesie",
        text: `
        <p>W biznesie samochód służbowy pełni dwie ważne role: jest niezawodnym narzędziem pracy i wizytówką firmy. Nowy Hyundai Tucson doskonale łączy oba te zadania. Jego dynamiczna sylwetka i nowoczesny design przyciągają wzrok, budując profesjonalny wizerunek na każdym spotkaniu. Jednocześnie to niezwykle praktyczny i wszechstronny SUV.</p>
        
        <p>Przestronna, komfortowa kabina i bardzo duży bagażnik sprawiają, że Tucson jest solidnym partnerem w codziennych zadaniach – idealnym dla menedżera czy pracownika w terenie. Wybierając go, stawiasz na znaną niezawodność, nowoczesne systemy bezpieczeństwa i pewność, że Twój zespół podróżuje komfortowo.</p>
        `
      },
      {
        title: "Nowy samochód Hyundai Tuscon – spalanie",
        text: `
        <p>Nowy Tucson łączy dynamiczne osiągi z rozsądnym apetytem na paliwo, co pozwala skutecznie optymalizować koszty floty. Nowoczesny i wydajny silnik benzynowy 1.6 T-GDI o mocy 160 KM, współpracujący z płynnie działającą, automatyczną skrzynią biegów, zapewnia doskonałą elastyczność zarówno w trasie, jak i w mieście. To gwarancja nie tylko pełnego komfortu jazdy, ale także przewidywalnych i niższych wydatków na paliwo w Twojej firmie.</p>
        `
      },
      {
        title: "Hyundai Tucson w mAuto – korzyści dla Twojego biznesu",
        text: `
        <p>W mAuto rozumiemy, że w biznesie liczą się elastyczne i przejrzyste rozwiązania. Dlatego przygotowaliśmy ofertę najmu długoterminowego, która pozwala Ci korzystać z fabrycznie nowego Hyundaia Tucson bez obciążania firmowego budżetu.</p>
        
        <ul>
          <li><strong>Atrakcyjna rata</strong> – już od 1029 zł netto miesięcznie w ofercie najmu długoterminowego.</li>
          <li><strong>Dostępność od ręki</strong> – oferujemy fabrycznie nowe modele z rocznika 2025, gotowe do pracy w Twojej firmie.</li>
          <li><strong>Pełna elastyczność</strong> – dopasuj okres najmu (od 24 do 48 miesięcy) i wysokość opłaty wstępnej do swoich potrzeb.</li>
          <li><strong>Przejrzystość i przewidywalność</strong> – stałe, miesięczne koszty pozwalają na precyzyjne planowanie wydatków.</li>
        </ul>
        
        <p>Nie czekaj. Zainwestuj w wizerunek i efektywność swojej firmy już dziś.</p>
        `
      }
    ]
  },
  NEW_RENAULT: {
    MAIN_TITLE: "Nowe samochody Renault",
    MAIN_TEXT: "Prowadzisz firmę i szukasz floty, która łączy nowoczesny styl, innowacyjną technologię i rozsądne koszty? Nowe samochody Renault to inteligentny wybór dla Twojego biznesu. Oferują dynamiczny design i zaawansowane rozwiązania w parze z niskimi kosztami eksploatacji, a dzięki ofercie mAuto możesz mieć je w swojej firmie już od 715 zł netto miesięcznie.",
    ADDITIONAL_TEXTS: [
      {
        title: "Samochody Renault – tradycja i innowacja w jednym",
        text: `
        <p>Renault to francuska marka z ponad stuletnią tradycją, która od zawsze stawia na innowacyjność i rozwiązania bliskie ludziom. Znana z tworzenia samochodów, które łączą komfort, bezpieczeństwo i charakterystyczny design, firma konsekwentnie wyznacza nowe trendy w motoryzacji. To właśnie ta filozofia, skupiona na człowieku i jego potrzebach, sprawia, że Renault od dekad cieszy się zaufaniem kierowców na całym świecie.</p>
        `
      },
      {
        title: "Dlaczego nowy Renault to doskonały wybór dla biznesu?",
        text: `
        <p>Renault to marka, która rozumie potrzeby przedsiębiorców. Wybierając ją, inwestujesz w trzy kluczowe obszary:</p>
        
        <ul>
          <li><strong>Niezawodność i ekonomia</strong> – nowoczesne i oszczędne silniki, w tym innowacyjne napędy hybrydowe E-Tech, gwarantują niskie zużycie paliwa. To realna oszczędność dla firmowego budżetu i mniejsze koszty utrzymania floty.</li>
          <li><strong>Prestiż i nowoczesny design</strong> – odważna linia stylistyczna nowych modeli Renault sprawia, że samochody te są mobilną wizytówką firmy. Profesjonalny i nowoczesny wizerunek buduje zaufanie w oczach klientów i partnerów biznesowych.</li>
          <li><strong>Wszechstronność floty</strong> – szeroka gama modeli pozwala idealnie dopasować pojazd do każdego zadania. Od zwinnego, miejskiego Clio, przez wszechstronne SUV-y jak Captur i Austral, aż po niezawodne samochody dostawcze takie jak Trafic – Renault ma odpowiedź na każdą potrzebę Twojej firmy.</li>
        </ul>
        `
      },
      {
        title: "Nowe Renault w mAuto – korzyści",
        text: `
        <p>W mAuto.pl zapewniamy nie tylko atrakcyjną ofertę, ale także wyjątkowe warunki finansowania i obsługi, stworzone z myślą o biznesie.</p>
        
        <ul>
          <li><strong>Finansowanie skrojone na miarę</strong> – oferujemy elastyczny leasing i wynajem długoterminowy z niską ratą. Skorzystaj z opcji wpłaty własnej nawet 0% i ciesz się uproszczonymi procedurami, które oszczędzają Twój cenny czas.</li>
          <li><strong>Samochody dostępne od ręki</strong> – Twoja firma nie musi czekać. Posiadamy flotę fabrycznie nowych pojazdów gotowych do pracy niemal od zaraz. Wybierz model i wyjedź nim na drogę bez zbędnej zwłoki.</li>
          <li><strong>Pełne wsparcie na każdym etapie</strong> – nasi doradcy biznesowi pomogą Ci wybrać idealny model oraz najkorzystniejszą formę finansowania, gwarantując profesjonalną obsługę i przejrzyste warunki.</li>
        </ul>
        
        <p>Nie czekaj. Już dziś wzmocnij swoją flotę o nowoczesne i ekonomiczne samochody Renault.</p>
        `
      }
    ]
  }
};
